import { defineComponent as L, computed as V, openBlock as c, createElementBlock as g, normalizeClass as I, createElementVNode as v, ref as C, onMounted as te, onUnmounted as Mt, createVNode as O, toDisplayString as J, createCommentVNode as _, createApp as wo, createTextVNode as D, Fragment as W, createBlock as T, resolveDynamicComponent as Z, mergeProps as H, withCtx as z, renderSlot as w, unref as q, renderList as U, inject as Ce, normalizeStyle as ee, useAttrs as be, useId as Fe, resolveDirective as ct, withDirectives as Ke, getCurrentScope as Pt, onScopeDispose as Ft, toRef as _o, readonly as jo, customRef as ko, shallowRef as Ot, watch as K, nextTick as Me, getCurrentInstance as $o, h as So, Teleport as ze, useSlots as G, withKeys as Oe, onBeforeUnmount as Je, provide as Ze, Transition as ft, createSlots as pt, normalizeProps as Co, guardReactiveProps as Vo, mergeModels as To, useModel as xo, createStaticVNode as Dt, onBeforeMount as Io, shallowReadonly as xe, vShow as Lo, render as kt, withModifiers as Bo } from "vue";
function $t(e) {
  const t = e.target;
  if (!t)
    return;
  const l = t.getBoundingClientRect(), o = "joy-ripple-effect";
  let n;
  const r = t.querySelector(`.${o}`);
  r || (n = document.createElement("span"), n.classList.add(o));
  const a = r || n;
  t.prepend(a);
  const i = Math.sqrt(Math.pow(l.width, 2) + Math.pow(l.height, 2)) * 2;
  a.style.width = a.style.height = `${i}px`, a.style.left = `${e.clientX - l.left}px`, a.style.top = `${e.clientY - l.top}px`;
}
const Rt = {
  mounted: (e) => {
    e.addEventListener("click", $t);
  },
  beforeUnmount: (e) => {
    e.removeEventListener("click", $t);
  }
}, Ao = /\d/, Eo = ["-", "_", "/", "."];
function zo(e = "") {
  if (!Ao.test(e))
    return e !== e.toLowerCase();
}
function Jo(e, t) {
  const l = Eo, o = [];
  if (!e || typeof e != "string")
    return o;
  let n = "", r, a;
  for (const i of e) {
    const s = l.includes(i);
    if (s === !0) {
      o.push(n), n = "", r = void 0;
      continue;
    }
    const d = zo(i);
    if (a === !1) {
      if (r === !1 && d === !0) {
        o.push(n), n = i, r = d;
        continue;
      }
      if (r === !0 && d === !1 && n.length > 1) {
        const p = n.at(-1);
        o.push(n.slice(0, Math.max(0, n.length - 1))), n = p + i, r = d;
        continue;
      }
    }
    n += i, r = d, a = s;
  }
  return o.push(n), o;
}
function St(e, t) {
  return e ? (Array.isArray(e) ? e : Jo(e)).map((l) => l.toLowerCase()).join("-") : "";
}
const Mo = {
  created: (e, t) => {
    for (const l in t.value) {
      const o = St(l);
      e.hasAttribute(o) || e.setAttribute(o, t.value[l]);
    }
  },
  getSSRProps(e) {
    return e.value ? Object.fromEntries(
      Object.entries(e.value).map(([t, l]) => [
        St(t),
        l
      ])
    ) : {};
  }
};
function Nt(e) {
  let t;
  switch (e) {
    case "error":
      t = "warning-triangle";
      break;
    case "success":
      t = "check-circle";
      break;
    default:
      t = "info-circle";
  }
  return t;
}
function Po(e) {
  if (!e) {
    console.warn("Missing ref element for focusOnFirstFocusableFormField use");
    return;
  }
  let t = ["input", "textarea", "select"];
  const l = (e.value ?? e).querySelectorAll(t.join(","));
  if (l.length)
    return l[0].focus();
}
const Xe = function(e = 10) {
  return Math.random().toString(36).substring(2, e + 2);
};
function ye(e) {
  e ? document.body.style.overflow = "hidden" : document.body.style.removeProperty("overflow");
}
const Fo = ["role", "tabindex", "aria-label", "title"], R = /* @__PURE__ */ L({
  __name: "VJoyIcon",
  props: {
    ariaLabel: {
      type: String
    },
    title: {
      type: String
    },
    role: {
      type: String
    },
    tabIndex: {
      type: Number,
      default: 0
    },
    name: {
      type: String,
      required: !0
    },
    color: {
      type: String,
      default: "secondary"
    },
    /** Use `TJoyIconSizes` */
    size: {
      type: String,
      default: "xsmall"
    }
  },
  setup(e) {
    const t = e, l = V(() => {
      if (t.role === "button")
        return t.tabIndex;
    });
    return (o, n) => (c(), g("span", {
      class: I(["joy-icon", `joy-icon--${e.color}`, `joy-icon--${e.size}`, { "joy-icon--button": e.role === "button" }]),
      role: e.role,
      tabindex: l.value,
      "aria-label": e.ariaLabel || e.title,
      title: e.title || e.ariaLabel
    }, [
      v("i", {
        class: I(["icon", `icon-${e.name}`]),
        "aria-hidden": "true"
      }, null, 2)
    ], 10, Fo));
  }
}), Oo = { class: "joy-snackbar__img joy-core-radius-6" }, Do = { class: "joy-snackbar__content" }, Ro = {
  key: 0,
  class: "joy-mb-1"
}, No = ["innerHTML"], qo = /* @__PURE__ */ L({
  __name: "VJoySnackbar",
  props: {
    level: {
      type: String,
      default: "success"
    },
    /** Allows to manually hide the component before its timeout */
    closable: {
      type: Boolean,
      default: !0
    },
    /** Default snackar display duration. Default to 5000ms. Set "forever" to constantly display it. */
    duration: {
      type: [String, Number],
      default: 5e3
    },
    /** The title if you need to set one */
    header: {
      type: String
    },
    /** Main snackbar message. Mandatory */
    message: {
      type: String,
      required: !0
    },
    /** If you need to trigger an action from the generated snackbar, use this field to create a CTA.
     *
     * Use `bus.on('snackbar:action-click')` to catch the event.
     */
    actionText: {
      type: String
    },
    /** Documentation purpose */
    frozen: {
      type: Boolean,
      default: !1
    },
    /** You don't need to explicitely set the bus property as the snackbar service is already handling it. */
    bus: {
      type: Object
    },
    /** Internal purpose */
    instanceNb: {
      type: Number
    }
  },
  setup(e, { expose: t }) {
    const l = e, o = C(!0);
    let n, r;
    const a = "joy-snackbar-" + Xe(), i = V(() => Nt(l.level));
    function s() {
      var b;
      (b = l.bus) == null || b.emit("snackbar:action-click");
    }
    function d() {
      n && clearTimeout(n), r && clearTimeout(r);
    }
    function p() {
      var b;
      u(), (b = l.bus) == null || b.emit("snackbar:hide");
    }
    function u() {
      o.value = !1;
    }
    function f() {
      n = setTimeout(u, l.duration), m();
    }
    function m() {
      r = setTimeout(function() {
        var b;
        (b = l.bus) == null || b.emit("snackbar:hide");
      }, l.duration + 300);
    }
    te(() => {
      var b;
      (b = l.bus) == null || b.emit("snackbar:show"), typeof l.duration == "number" && f();
    });
    const y = {
      destroySnackbarAfterTimeout: f
    };
    return Mt(() => {
      d();
    }), t({
      isOpen: o,
      exposedMethods: y
    }), (b, h) => (c(), g("div", {
      class: I(["joy-snackbar_container", {
        "joy-snackbar__frozen": e.frozen === !0,
        "joy-snackbar__hiding": !o.value
      }])
    }, [
      v("div", {
        id: a,
        class: I(["joy-snackbar", `joy-snackbar_${e.level}`])
      }, [
        v("div", Oo, [
          O(R, {
            color: "white",
            name: i.value,
            size: "small"
          }, null, 8, ["name"])
        ]),
        v("div", Do, [
          e.header ? (c(), g("strong", Ro, J(e.header), 1)) : _("", !0),
          v("span", { innerHTML: e.message }, null, 8, No),
          e.actionText ? (c(), g("p", {
            key: 1,
            class: "joy-snackbar__trigger___action",
            onClick: s
          }, J(e.actionText), 1)) : _("", !0)
        ]),
        e.closable ? (c(), g("button", {
          key: 0,
          type: "button",
          class: "joy-snackbar__close-icon",
          onClick: p
        }, [
          O(R, {
            color: "white",
            name: "cross"
          })
        ])) : _("", !0)
      ], 2)
    ], 2));
  }
}), A = (e, t) => {
  const l = e.__vccOpts || e;
  for (const [o, n] of t)
    l[o] = n;
  return l;
}, Ho = /* @__PURE__ */ A(qo, [["__scopeId", "data-v-544f38e7"]]);
function Wo(e) {
  return { all: e = e || /* @__PURE__ */ new Map(), on: function(t, l) {
    var o = e.get(t);
    o ? o.push(l) : e.set(t, [l]);
  }, off: function(t, l) {
    var o = e.get(t);
    o && (l ? o.splice(o.indexOf(l) >>> 0, 1) : e.set(t, []));
  }, emit: function(t, l) {
    var o = e.get(t);
    o && o.slice().map(function(n) {
      n(l);
    }), (o = e.get("*")) && o.slice().map(function(n) {
      n(t, l);
    });
  } };
}
function Uo() {
  return Wo();
}
const qt = "joy-snackbar__container", Go = "joy-snackbar__shell--";
let He = 0, Ht = [];
const Yo = {
  install: (e) => {
    typeof window < "u" && Wt(), e.directive("joy-ripple", Rt);
  }
};
function Ws() {
  He = 0, Ht = [];
}
function Wt(e = { appendTo: "body", defaultMountSelector: qt }) {
  var o;
  const t = document.createElement("div");
  t.id = e.defaultMountSelector;
  const l = document.createElement("style");
  l.textContent = `
        #${e.defaultMountSelector} {
            position: fixed;
            bottom: 0;
            right: 0;
            left: 0;
            margin: auto;
            z-index: var(--joy-core-z-index-snackbar);
            width: 580px;
            max-width: calc(100% - var(--joy-core-spacing-6) * 2);
        }
    `, document.head.appendChild(l), document.getElementById(t.id) === null && (e.appendTo === "body" ? document.body.appendChild(t) : (o = document.body.querySelector(e.appendTo)) == null || o.appendChild(t));
}
function Us(e) {
  var r, a;
  He++;
  let t, l;
  const o = Uo();
  t = wo(
    Ho,
    Object.assign(e.props, {
      bus: o,
      instanceNb: He
    })
  );
  const n = document.createElement("div");
  return n.classList.add("joy-snackbar__shell"), l = `${Go}${He}`, n.id = l, e.snackbarHostId ? (r = document.getElementById(e.snackbarHostId)) == null || r.appendChild(n) : (a = document.getElementById(qt)) == null || a.appendChild(n), t.use(Yo).mount("#" + l), Ht.push(t), o.on("snackbar:hide", () => {
    var i;
    t.unmount(), (i = document.getElementById(l)) == null || i.remove();
  }), {
    snackbarEventBus: o,
    snackbarApp: t
  };
}
const Ko = { class: "joy-admin-banner" }, Zo = { class: "joy-admin-banner__label joy-font-primary-350" }, Xo = /* @__PURE__ */ L({
  __name: "VJoyAdminBanner",
  props: {
    label: { default: "Admin view" }
  },
  setup(e) {
    return (t, l) => (c(), g("div", Ko, [
      v("span", Zo, [
        O(R, { name: "eye" }),
        D(" " + J(t.label), 1)
      ])
    ]));
  }
}), Gs = /* @__PURE__ */ A(Xo, [["__scopeId", "data-v-77d28117"]]), Qo = ["title"], en = /* @__PURE__ */ L({
  __name: "VJoyAvailability",
  props: {
    label: {},
    status: { default: "AVAILABLE" },
    isPartial: { type: Boolean }
  },
  setup(e) {
    const t = e, l = V(() => ({
      "joy-availability__dot": !0,
      "joy-availability--partial": t.isPartial,
      [t.status]: !0
    }));
    return (o, n) => (c(), g("div", {
      class: I(["joy-availability", { "joy-availability-has-label": !!o.label }]),
      title: o.label || void 0
    }, [
      v("span", {
        class: I(l.value)
      }, null, 2),
      o.label ? (c(), g(W, { key: 0 }, [
        D(J(o.label), 1)
      ], 64)) : _("", !0)
    ], 10, Qo));
  }
}), Ys = /* @__PURE__ */ A(en, [["__scopeId", "data-v-b3bb9092"]]), tn = ["src", "title", "alt", "loading"], on = {
  key: 0,
  class: "joy-avatar__strategy"
}, nn = ["height"], ln = /* @__PURE__ */ L({
  __name: "VJoyAvatar",
  props: {
    size: { default: "medium" },
    fullName: {},
    photoUrl: {},
    totalNumber: {},
    link: { type: Boolean },
    profile: { default: "default" },
    loading: { default: "lazy" },
    isEmpty: { type: Boolean, default: !1 },
    square: { type: Boolean, default: !1 },
    placeholder: { default: "user-photo" },
    showLetters: { type: Boolean, default: !0 }
  },
  emits: ["click"],
  setup(e, { expose: t, emit: l }) {
    const o = l, n = e, r = V(() => n.size === "large" ? "medium" : n.size === "medium" ? "small" : n.size === "small" ? "xsmall" : "xxsmall"), a = V(() => n.link ? {
      type: "button"
    } : null), i = V(() => ({
      "joy-avatar": !0,
      "joy-avatar__link": n.link,
      "joy-avatar__placeholder": s.value,
      [`joy-avatar__${n.size}`]: !0,
      "joy-avatar--empty": n.isEmpty
    })), s = V(() => !n.fullName && !n.photoUrl && !n.totalNumber && !n.isEmpty), d = V(() => {
      function u(m) {
        return m.replace(/[';,:()]/g, "").charAt(0);
      }
      let f = n.fullName.split(" ");
      return f = f.slice(0, 2), f.forEach((m, y) => {
        f[y] = u(m);
      }), f.join("").toUpperCase();
    });
    function p() {
      o("click");
    }
    return t({
      isAnonymous: s,
      initials: d
    }), (u, f) => (c(), g("div", {
      ref: "avatarEl",
      class: I(["joy-avatar__wrapper", {
        [`joy-avatar__wrapper--${u.size}`]: !0,
        "joy-core-radius-6": !u.square,
        "joy-avatar__wrapper--anonymous": s.value
      }])
    }, [
      (c(), T(Z(u.link ? "button" : "div"), H(a.value, {
        title: u.fullName,
        class: [i.value],
        onClick: p
      }), {
        default: z(() => [
          s.value ? (c(), T(R, {
            key: 0,
            name: u.placeholder,
            color: "neutral-50",
            size: r.value
          }, null, 8, ["name", "size"])) : _("", !0),
          u.photoUrl ? (c(), g("img", {
            key: 1,
            src: u.photoUrl,
            title: u.fullName,
            alt: u.fullName || "",
            loading: u.loading
          }, null, 8, tn)) : _("", !0),
          u.fullName && u.showLetters ? (c(), g(W, { key: 2 }, [
            D(J(d.value), 1)
          ], 64)) : _("", !0),
          u.totalNumber ? (c(), g(W, { key: 3 }, [
            D(J("+" + u.totalNumber), 1)
          ], 64)) : _("", !0)
        ]),
        _: 1
      }, 16, ["title", "class"])),
      u.profile === "strategy" ? (c(), g("span", on, [
        (c(), g("svg", {
          width: "12",
          height: u.size === "small" ? "10" : "16",
          viewBox: "0 0 12 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, f[0] || (f[0] = [
          v("path", {
            d: "M6.40531 15.88C5.29156 15.88 4.31531 15.6737 3.47656 15.2612C2.63781 14.8487 1.98469 14.2644 1.51719 13.5081C1.04969 12.7519 0.809061 11.8719 0.795311 10.8681L4.01281 10.3525C4.01281 11.2188 4.25344 11.9131 4.73469 12.4356C5.21594 12.9581 5.82781 13.2194 6.57031 13.2194C7.16156 13.2194 7.63594 13.0612 7.99344 12.745C8.36469 12.4288 8.55031 12.0231 8.55031 11.5281C8.55031 11.1156 8.40594 10.7719 8.11719 10.4969C7.84219 10.2081 7.38844 9.95375 6.75594 9.73375L4.96156 9.15625C3.65531 8.7575 2.70656 8.21438 2.11531 7.52687C1.53781 6.83937 1.24906 5.93187 1.24906 4.80437C1.24906 3.47062 1.68219 2.39812 2.54844 1.58687C3.41469 0.775624 4.63156 0.369999 6.19906 0.369999C7.65656 0.369999 8.83219 0.768749 9.72594 1.56625C10.6197 2.35 11.0803 3.41562 11.1078 4.76312L7.97281 5.36125C7.98656 4.64625 7.82156 4.07562 7.47781 3.64937C7.13406 3.20937 6.68719 2.98937 6.13719 2.98937C5.65594 2.98937 5.26406 3.14062 4.96156 3.44313C4.65906 3.73187 4.50781 4.10312 4.50781 4.55687C4.50781 4.99687 4.64531 5.36125 4.92031 5.65C5.20906 5.925 5.67656 6.15875 6.32281 6.35125L8.03469 6.92875C9.36844 7.3275 10.3309 7.87063 10.9222 8.55812C11.5272 9.23188 11.8297 10.1325 11.8297 11.26C11.8297 12.1538 11.6166 12.9513 11.1903 13.6525C10.7641 14.3538 10.1453 14.9038 9.33406 15.3025C8.52281 15.6875 7.54656 15.88 6.40531 15.88Z",
            fill: "#F7F7F5"
          }, null, -1)
        ]), 8, nn))
      ])) : _("", !0)
    ], 2));
  }
}), an = /* @__PURE__ */ A(ln, [["__scopeId", "data-v-f4bfc432"]]), rn = /* @__PURE__ */ L({
  __name: "VJoyAvatarsList",
  props: {
    /** Renders a compact list of avatars */
    compress: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (t, l) => (c(), g("div", {
      ref: "avatarsList",
      class: I(["joy-avatars-list", { "joy-avatars-list--compressed": e.compress }])
    }, [
      w(t.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), Ks = /* @__PURE__ */ A(rn, [["__scopeId", "data-v-c985cccf"]]), sn = { key: 0 }, un = /* @__PURE__ */ L({
  __name: "VJoyDot",
  props: {
    number: Number,
    variant: {
      type: String,
      default: "info"
    }
  },
  setup(e) {
    const t = e, l = V(() => typeof t.number == "number");
    return (o, n) => (c(), g("div", {
      class: I(["joy-dot", `joy-dot__${e.variant}`, { "joy-dot__number": l.value }])
    }, [
      l.value ? (c(), g("span", sn, J(e.number && e.number > 99 ? "99+" : e.number), 1)) : _("", !0)
    ], 2));
  }
}), Ct = /* @__PURE__ */ A(un, [["__scopeId", "data-v-cf7284ce"]]), dn = /* @__PURE__ */ L({
  __name: "VJoyBadge",
  props: {
    /**
     * Display the colored bulletpoint on the left
     */
    bulletpoint: {
      type: Boolean,
      default: !1
    },
    /**
     * Use label or slot in order to inject the text.
     */
    label: {
      type: String,
      default: ""
    },
    /**
     * Color of the badge. Override the color with `--badge-bg-color` and `--badge-circle-color` if needed.
     *
     * You can use the `TJoyBadgeVariants` type.
     */
    variant: {
      type: String,
      default: "info"
    },
    number: Number
  },
  setup(e) {
    const t = e, l = V(() => typeof t.number == "number");
    return (o, n) => l.value ? (c(), T(Ct, {
      key: 0,
      variant: e.variant,
      number: e.number
    }, null, 8, ["variant", "number"])) : (c(), g("span", {
      key: 1,
      class: I(["joy-badge", `joy-badge__${e.variant}`, { "joy-badge--with-bulletpoint": e.bulletpoint }]),
      role: "status"
    }, [
      e.bulletpoint ? (c(), T(Ct, {
        key: 0,
        class: "joy-badge_dot",
        variant: e.variant
      }, null, 8, ["variant"])) : _("", !0),
      w(o.$slots, "default", {}, () => [
        D(J(e.label), 1)
      ], !0)
    ], 2));
  }
}), cn = /* @__PURE__ */ A(dn, [["__scopeId", "data-v-f159ad49"]]);
var X = /* @__PURE__ */ ((e) => (e.HIGH_POTENTIAL = "highpotential", e.HIGH_POTENTIAL_AUTO = "high-potential-auto", e.MALT_LINKER = "maltlinker", e.NEW = "new", e.SUPER_MALTER = "supermalter", e.VERIFIED = "verified", e))(X || {}), We = /* @__PURE__ */ ((e) => (e.HIGH_POTENTIAL = "program_high-potential", e))(We || {});
const fn = { class: "joy-badge-level" }, pn = {
  key: 1,
  class: "joy-badge-level__highpotential",
  viewBox: "0 0 15 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, yn = {
  key: 2,
  class: "joy-badge-level__high-potential-auto",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64",
  "enable-background": "new 0 0 64 64"
}, mn = {
  key: 3,
  class: "joy-badge-level__maltlinker",
  viewBox: "0 0 23 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, vn = {
  key: 4,
  class: "joy-badge-level__highpotential-program",
  viewBox: "0 0 15 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, hn = /* @__PURE__ */ L({
  __name: "VJoyBadgeLevel",
  props: {
    /** type: `TJoyBadges` */
    type: {
      type: String,
      required: !0
    },
    /** If supermalter type is given, specify the level (from 1 to 3) */
    superMalterLevel: {
      type: Number,
      default: 1
    },
    /** Display the default badge label */
    visibleText: {
      type: Boolean,
      default: !0
    }
  },
  setup(e) {
    const t = e, l = V(() => {
      switch (t.type) {
        case We.HIGH_POTENTIAL:
        case X.HIGH_POTENTIAL:
          return "High Potential";
        case X.HIGH_POTENTIAL_AUTO:
          return "High Potential Auto";
        case X.MALT_LINKER:
          return "Malt Linker";
        case X.NEW:
          return "New";
        case X.SUPER_MALTER:
          return "Supermalter";
        case X.VERIFIED:
          return "Verified";
        default:
          return "Supermalter";
      }
    });
    return (o, n) => (c(), g("span", fn, [
      e.type === q(X).SUPER_MALTER ? (c(!0), g(W, { key: 0 }, U(e.superMalterLevel, (r, a) => (c(), g("svg", {
        key: a,
        class: "joy-badge-level__supermalter",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 12 18"
      }, n[0] || (n[0] = [
        v("path", {
          fill: "#264FFA",
          d: "M5.71533 12.2962 11.4243 18l.0049-11.45716-5.71387 5.75336Z"
        }, null, -1),
        v("path", {
          fill: "#FC5757",
          d: "M.00195312 6.54284.00671145 18 5.7158 12.2962.00195312 6.54284Z"
        }, null, -1),
        v("path", {
          fill: "#FFC200",
          d: "M11.4289 5.68249c-.0059-1.52434-.6069-2.9554-1.69067-4.02851C8.95862.882797 7.99681.362073 6.9506.132677 6.95037.132599 6.95021.132599 6.94998.132521c-.04337-.009516-.08681-.018408-.13041-.02691-.0057-.001092-.01147-.002184-.01724-.003276-.0383-.0073317-.07675-.0142735-.11529-.0208255-.01068-.001794-.02144-.00351-.03213-.005304-.03385-.0055379-.06778-.0108418-.10179-.0158338-.01505-.002184-.03011-.0042121-.04516-.0063181-.03011-.0041339-.06022-.008112-.0904-.0117779-.01857-.002262-.03721-.0042901-.05577-.006396C6.33472.0328377 6.30766.029952 6.28051.0273 6.25914.025194 6.23769.0233999 6.21624.0215279 6.19144.0194219 6.16671.017316 6.14183.015522 6.11851.013806 6.09511.0123239 6.07171.0109199 6.04831.00951588 6.02483.00811199 6.00135.006942 5.9771.00577201 5.95276.00483616 5.92842.00397816 5.90541.00312017 5.8824.00234019 5.85931.00179419c-.02433-.00062399-.04874-.0009362-.07316-.0012482C5.76267.000234 5.73912 0 5.71564 0c-.02355 0-.04703.000234-.07051.000546-.02442.000312-.04883.0006242-.07316.00124819-.02309.000546-.0461.00140398-.06911.00218397-.02434.000858-.04859.00179385-.07293.00296384-.02348.00116999-.04696.00257388-.07036.0039779-.0234.001404-.0468.0028861-.07012.0046021-.0248.001794-.0496.0038999-.07441.0060059-.02145.001872-.0429.0036661-.06427.0057721-.02714.002652-.05421.0055377-.08135.0085797-.01857.0021059-.03721.004134-.05577.006396-.03019.0036659-.06037.007644-.09048.0117779-.01506.002106-.03011.0041341-.04516.0063181-.03401.004992-.06794.0102959-.10179.0158338-.01077.001794-.02145.00351-.03214.005304-.03853.006552-.07699.0134938-.11528.0208255-.00578.001092-.01155.002184-.01724.003276-.0436.008502-.08705.017394-.13041.02691-.00024.000078-.00047.000078-.00071.000156C3.43424.361995 2.4725.882719 1.6929 1.65398.609098 2.72702.00811193 4.15815.00218397 5.68249L0 6.15064l.00171623.39226L5.71556 12.2962l5.71384-5.7533.0017-.39202-.0022-.46839Z"
        }, null, -1)
      ])))), 128)) : _("", !0),
      e.type === q(X).HIGH_POTENTIAL ? (c(), g("svg", pn, n[1] || (n[1] = [
        v("path", {
          d: "M0.0635011 7.89462C0.0715011 5.91062 0.853501 4.04762 2.2645 2.65062C3.2795 1.64662 4.5315 0.96862 5.8925 0.67062H5.8935C5.9495 0.65862 6.0065 0.64662 6.0635 0.63562C6.0705 0.63362 6.0785 0.63262 6.0855 0.63062C6.1355 0.62062 6.1855 0.61162 6.2355 0.60362C6.2495 0.60162 6.2635 0.59862 6.2775 0.59662C6.3215 0.58962 6.3655 0.58262 6.4105 0.57662C6.4305 0.57362 6.4495 0.57062 6.4695 0.56862C6.5075 0.56262 6.5475 0.55762 6.5865 0.55262C6.6105 0.54962 6.6345 0.54662 6.6595 0.54462C6.6945 0.54062 6.7295 0.53662 6.7655 0.53362C6.7925 0.53062 6.8205 0.52762 6.8485 0.52562C6.8805 0.52262 6.9135 0.52062 6.9455 0.51762C6.9755 0.51562 7.0065 0.51362 7.0365 0.51162C7.0665 0.50962 7.0975 0.50762 7.1285 0.50662C7.1605 0.50462 7.1915 0.50362 7.2235 0.50262C7.2535 0.50162 7.2835 0.50062 7.3135 0.49962C7.3455 0.49862 7.3765 0.49862 7.4085 0.49762C7.4385 0.49762 7.4695 0.49762 7.5005 0.49762C7.5305 0.49762 7.5615 0.49762 7.5915 0.49862C7.6235 0.49862 7.6555 0.49962 7.6865 0.50062C7.7165 0.50162 7.7465 0.50262 7.7765 0.50362C7.8085 0.50362 7.8405 0.50562 7.8725 0.50662C7.9035 0.50762 7.9335 0.50962 7.9645 0.51162C7.9945 0.51362 8.0255 0.51562 8.0555 0.51762C8.0875 0.51962 8.1205 0.52262 8.1525 0.52562C8.1795 0.52762 8.2075 0.53062 8.2355 0.53362C8.2705 0.53662 8.3055 0.54062 8.3415 0.54462C8.3655 0.54762 8.3895 0.54962 8.4145 0.55262C8.4535 0.55762 8.4925 0.56262 8.5315 0.56762C8.5515 0.57062 8.5705 0.57362 8.5905 0.57662C8.6345 0.58262 8.6785 0.58962 8.7225 0.59762C8.7365 0.59962 8.7505 0.60162 8.7645 0.60362C8.8145 0.61262 8.8645 0.62162 8.9145 0.63062C8.9215 0.63162 8.9295 0.63362 8.9365 0.63462C8.9935 0.64662 9.0505 0.65762 9.1065 0.67062H9.1075C10.4695 0.96962 11.7215 1.64662 12.7355 2.65062C14.1465 4.04762 14.9285 5.91062 14.9365 7.89462L14.9395 8.50362L14.9375 9.01462L7.5005 16.5026L0.0625011 9.01462L0.0605011 8.50362L0.0635011 7.89462Z",
          fill: "#FFC200"
        }, null, -1)
      ]))) : _("", !0),
      e.type === q(X).HIGH_POTENTIAL_AUTO ? (c(), g("svg", yn, n[2] || (n[2] = [
        v("path", {
          fill: "#EF4E16",
          d: "M60 23.913s-8.76-2.903-14.05 1.058C44.256 17.449 45.203 8.674 34.688 2c-.712 9.413-12.856 9.891-15.691 22.005-1.86-3.319-2.227-7.716-9.28-9.871C11.615 25.513.415 31.3 5.199 47.68c2.699 9.246 12.72 13.651 21.047 14.217 16.527 1.123 31.896-6.848 32.258-24.148.155-7.437-2.975-8.343 1.496-13.836z"
        }, null, -1),
        v("path", {
          fill: "#F9B700",
          d: "M53.226 32.962c-6.012-.063-5.458 2.387-9.883 3.896-3.212-5.842-.067-13.682-10.056-19.364.066 10.625-7.32 7.313-10.414 17.456-3.758-2.145-1.943-6.888-9.256-8.89 4.042 6.349-.99 7.542-3.526 13.335-5.093 11.632 7.181 19.813 16.548 20.382 13.019.793 25.124-4.834 25.408-17.048.122-5.25-2.342-5.888 1.179-9.767z"
        }, null, -1),
        v("path", {
          fill: "#FFE463",
          d: "M47.616 41.169c-4.47-.041-4.061 1.522-7.351 2.484-2.391-3.727-.051-8.729-7.479-12.354.049 6.778-5.446 4.666-7.746 11.137-2.795-1.368-1.447-4.395-6.885-5.672 3.006 4.051-.735 4.812-2.621 8.508-3.791 7.421 5.339 12.64 12.307 13.003 9.683.506 18.686-3.084 18.896-10.876.093-3.348-1.741-3.755.879-6.23z"
        }, null, -1),
        v("path", {
          fill: "#FFF7D1",
          d: "M37.182 54.939c0 2.188-12.427 2.188-12.427 0 0-5.849 12.427-5.849 12.427 0z"
        }, null, -1)
      ]))) : _("", !0),
      e.type === q(X).MALT_LINKER ? (c(), g("svg", mn, n[3] || (n[3] = [
        v("path", {
          d: "M5.77736 10.4456C4.45736 10.4406 3.21936 9.91961 2.29036 8.98161C1.62236 8.30661 1.17136 7.47461 0.97336 6.56861C0.97336 6.56861 0.97336 6.56861 0.97336 6.56761C0.96536 6.53061 0.95736 6.49361 0.94936 6.45561C0.94936 6.45061 0.94836 6.44561 0.94736 6.44061C0.94136 6.40761 0.93536 6.37461 0.92936 6.34061C0.92736 6.33161 0.92636 6.32261 0.92436 6.31261C0.91936 6.28361 0.91536 6.25461 0.91036 6.22461C0.90836 6.21161 0.90736 6.19861 0.90536 6.18561C0.90136 6.15961 0.89836 6.13361 0.89536 6.10761C0.89336 6.09161 0.89136 6.07561 0.88936 6.05961C0.88636 6.03561 0.88436 6.01261 0.88236 5.98861C0.88036 5.97061 0.87836 5.95161 0.87736 5.93361C0.87536 5.91161 0.87336 5.89061 0.87136 5.86861C0.87036 5.84861 0.86836 5.82861 0.86736 5.80761C0.86636 5.78761 0.86536 5.76661 0.86436 5.74661C0.86336 5.72661 0.86236 5.70561 0.86136 5.68461C0.86036 5.66461 0.86036 5.64461 0.85936 5.62461C0.85936 5.60361 0.85936 5.58161 0.85836 5.56061C0.85836 5.54061 0.85836 5.51961 0.85836 5.49961C0.85836 5.47961 0.85836 5.45861 0.85836 5.43861C0.85836 5.41761 0.85936 5.39661 0.85936 5.37561C0.85936 5.35561 0.86036 5.33561 0.86136 5.31561C0.86236 5.29461 0.86336 5.27361 0.86436 5.25261C0.86536 5.23261 0.86636 5.21161 0.86736 5.19161C0.86836 5.17161 0.86936 5.15161 0.87136 5.13061C0.87336 5.10961 0.87436 5.08761 0.87636 5.06661C0.87836 5.04761 0.88036 5.02961 0.88236 5.01061C0.88436 4.98661 0.88736 4.96361 0.88936 4.94061C0.89136 4.92461 0.89336 4.90861 0.89536 4.89261C0.89836 4.86661 0.90236 4.84061 0.90536 4.81461C0.90736 4.80061 0.90836 4.78761 0.91036 4.77461C0.91436 4.74561 0.91936 4.71561 0.92436 4.68661C0.92636 4.67761 0.92736 4.66761 0.92936 4.65861C0.93536 4.62561 0.94136 4.59161 0.94736 4.55861C0.94836 4.55361 0.94936 4.54861 0.95036 4.54361C0.95736 4.50561 0.96536 4.46861 0.97336 4.43061C0.97336 4.43061 0.97336 4.43061 0.97336 4.42961C1.17136 3.52561 1.62236 2.69261 2.29036 2.01761C3.21936 1.07961 4.45836 0.559612 5.77736 0.554612L6.18236 0.552612L6.52236 0.553612L11.5024 5.49961L6.52236 10.4456L6.18236 10.4476L5.77736 10.4456Z",
          fill: "#E3F8FB"
        }, null, -1),
        v("path", {
          d: "M17.2235 0.554612C18.5425 0.559612 19.7815 1.07961 20.7105 2.01761C21.3785 2.69261 21.8285 3.52461 22.0275 4.43061C22.0275 4.43061 22.0275 4.43061 22.0275 4.43161C22.0355 4.46961 22.0435 4.50661 22.0505 4.54461C22.0515 4.54961 22.0525 4.55461 22.0535 4.55961C22.0595 4.59261 22.0655 4.62561 22.0715 4.65961C22.0735 4.66861 22.0745 4.67861 22.0765 4.68761C22.0815 4.71661 22.0855 4.74661 22.0905 4.77561C22.0925 4.78861 22.0945 4.80161 22.0955 4.81461C22.0995 4.84061 22.1025 4.86661 22.1055 4.89261C22.1075 4.90861 22.1095 4.92461 22.1115 4.94061C22.1145 4.96361 22.1165 4.98761 22.1185 5.01061C22.1205 5.02961 22.1215 5.04761 22.1235 5.06661C22.1255 5.08761 22.1275 5.10961 22.1285 5.13061C22.1295 5.15061 22.1315 5.17061 22.1325 5.19161C22.1335 5.21161 22.1345 5.23261 22.1355 5.25261C22.1365 5.27361 22.1375 5.29461 22.1385 5.31561C22.1395 5.33561 22.1395 5.35561 22.1405 5.37561C22.1415 5.39661 22.1415 5.41761 22.1415 5.43861C22.1415 5.45861 22.1415 5.47961 22.1415 5.49961C22.1415 5.51961 22.1415 5.54061 22.1415 5.56061C22.1415 5.58161 22.1405 5.60261 22.1405 5.62361C22.1405 5.64361 22.1395 5.66361 22.1385 5.68361C22.1375 5.70461 22.1365 5.72561 22.1355 5.74661C22.1345 5.76661 22.1335 5.78761 22.1325 5.80761C22.1315 5.82761 22.1305 5.84761 22.1285 5.86861C22.1265 5.88961 22.1255 5.91161 22.1235 5.93261C22.1215 5.95161 22.1205 5.96961 22.1185 5.98861C22.1165 6.01261 22.1135 6.03561 22.1115 6.05861C22.1095 6.07461 22.1075 6.09061 22.1055 6.10661C22.1025 6.13261 22.0985 6.15861 22.0955 6.18461C22.0935 6.19761 22.0915 6.21061 22.0905 6.22361C22.0865 6.25261 22.0815 6.28261 22.0765 6.31161C22.0745 6.32061 22.0735 6.33061 22.0715 6.33961C22.0655 6.37261 22.0595 6.40661 22.0535 6.43961C22.0525 6.44461 22.0515 6.44961 22.0505 6.45461C22.0435 6.49261 22.0355 6.52961 22.0275 6.56761C22.0275 6.56761 22.0275 6.56761 22.0275 6.56861C21.8285 7.47461 21.3785 8.30661 20.7105 8.98161C19.7815 9.91961 18.5425 10.4396 17.2235 10.4446L16.8185 10.4466L16.4785 10.4456L11.4985 5.49961L16.4785 0.553612L16.8175 0.552612L17.2235 0.554612Z",
          fill: "#FF91F0"
        }, null, -1)
      ]))) : _("", !0),
      e.type === q(We).HIGH_POTENTIAL ? (c(), g("svg", vn, n[4] || (n[4] = [
        v("path", {
          d: "M0.0635011 7.89462C0.0715011 5.91062 0.853501 4.04762 2.2645 2.65062C3.2795 1.64662 4.5315 0.96862 5.8925 0.67062H5.8935C5.9495 0.65862 6.0065 0.64662 6.0635 0.63562C6.0705 0.63362 6.0785 0.63262 6.0855 0.63062C6.1355 0.62062 6.1855 0.61162 6.2355 0.60362C6.2495 0.60162 6.2635 0.59862 6.2775 0.59662C6.3215 0.58962 6.3655 0.58262 6.4105 0.57662C6.4305 0.57362 6.4495 0.57062 6.4695 0.56862C6.5075 0.56262 6.5475 0.55762 6.5865 0.55262C6.6105 0.54962 6.6345 0.54662 6.6595 0.54462C6.6945 0.54062 6.7295 0.53662 6.7655 0.53362C6.7925 0.53062 6.8205 0.52762 6.8485 0.52562C6.8805 0.52262 6.9135 0.52062 6.9455 0.51762C6.9755 0.51562 7.0065 0.51362 7.0365 0.51162C7.0665 0.50962 7.0975 0.50762 7.1285 0.50662C7.1605 0.50462 7.1915 0.50362 7.2235 0.50262C7.2535 0.50162 7.2835 0.50062 7.3135 0.49962C7.3455 0.49862 7.3765 0.49862 7.4085 0.49762C7.4385 0.49762 7.4695 0.49762 7.5005 0.49762C7.5305 0.49762 7.5615 0.49762 7.5915 0.49862C7.6235 0.49862 7.6555 0.49962 7.6865 0.50062C7.7165 0.50162 7.7465 0.50262 7.7765 0.50362C7.8085 0.50362 7.8405 0.50562 7.8725 0.50662C7.9035 0.50762 7.9335 0.50962 7.9645 0.51162C7.9945 0.51362 8.0255 0.51562 8.0555 0.51762C8.0875 0.51962 8.1205 0.52262 8.1525 0.52562C8.1795 0.52762 8.2075 0.53062 8.2355 0.53362C8.2705 0.53662 8.3055 0.54062 8.3415 0.54462C8.3655 0.54762 8.3895 0.54962 8.4145 0.55262C8.4535 0.55762 8.4925 0.56262 8.5315 0.56762C8.5515 0.57062 8.5705 0.57362 8.5905 0.57662C8.6345 0.58262 8.6785 0.58962 8.7225 0.59762C8.7365 0.59962 8.7505 0.60162 8.7645 0.60362C8.8145 0.61262 8.8645 0.62162 8.9145 0.63062C8.9215 0.63162 8.9295 0.63362 8.9365 0.63462C8.9935 0.64662 9.0505 0.65762 9.1065 0.67062H9.1075C10.4695 0.96962 11.7215 1.64662 12.7355 2.65062C14.1465 4.04762 14.9285 5.91062 14.9365 7.89462L14.9395 8.50362L14.9375 9.01462L7.5005 16.5026L0.0625011 9.01462L0.0605011 8.50362L0.0635011 7.89462Z",
          fill: "#FFC200"
        }, null, -1)
      ]))) : _("", !0),
      v("span", {
        class: I([
          {
            "joy-badge-level__tag": e.visibleText,
            red: e.type === q(X).NEW || e.type === q(X).MALT_LINKER || e.type === q(X).HIGH_POTENTIAL_AUTO,
            blue: e.type === q(We).HIGH_POTENTIAL || e.type === q(X).HIGH_POTENTIAL || e.type === q(X).SUPER_MALTER,
            turquoise: e.type === q(X).VERIFIED
          }
        ])
      }, [
        e.visibleText ? w(o.$slots, "default", { key: 0 }, () => [
          D(J(l.value), 1)
        ], !0) : _("", !0)
      ], 2)
    ]));
  }
}), Zs = /* @__PURE__ */ A(hn, [["__scopeId", "data-v-08a5e2c8"]]), gn = /* @__PURE__ */ L({
  __name: "VJoyBlockSkeleton",
  props: {
    /** If you want to use it properly you need to set fixed width and height */
    circle: {
      type: Boolean,
      default: !1
    },
    /** Size in any unit. Example: 50px, 100%... */
    width: {
      type: String
    },
    /** Size in any unit. */
    height: {
      type: String
    }
  },
  setup(e) {
    const t = e, l = Ce("VJoyWrapperContext", {}), o = V(() => {
      if (Object.keys(l).length === 0)
        return;
      let n = "1 0";
      return t.width && (n += ` ${t.width}`), n;
    });
    return (n, r) => (c(), g("div", {
      "aria-hidden": "true",
      class: I({
        "joy-block-skeleton": !0,
        "joy-block-skeleton--circle": e.circle
      }),
      style: ee({
        "max-width": e.width,
        height: e.height,
        flex: o.value
      })
    }, null, 6));
  }
}), Xs = /* @__PURE__ */ A(gn, [["__scopeId", "data-v-4da2c7cb"]]), bn = /* @__PURE__ */ L({
  __name: "VJoySpinner",
  props: {
    color: {
      type: String
    }
  },
  setup(e) {
    return (t, l) => (c(), g("div", {
      class: I(["joy-spinner", `joy-spinner_${e.color}`])
    }, null, 2));
  }
}), Ut = /* @__PURE__ */ A(bn, [["__scopeId", "data-v-52944a9b"]]), wn = /* @__PURE__ */ L({
  __name: "VJoyButton",
  props: {
    /**
     * If you only need a button with an icon. To keep your component accessible, you can give a text as slot, it will be used as title and aria-label.
     * This property takes effect only if icon property is set
     */
    circle: {
      type: Boolean,
      default: !1
    },
    /** Name of the icon, placed before the text */
    icon: {
      type: String
    },
    /** Left to the text or right */
    iconPosition: {
      type: String,
      default: "left"
    },
    /**
     * Use default slot or label property.
     */
    label: {
      type: String
    },
    /** Change the component's state and display a JoySpinner. */
    loading: {
      type: Boolean,
      default: !1
    },
    /** Button or Link color variant */
    variant: {
      type: String,
      default: "primary"
    },
    /** Button or Link size */
    size: {
      type: String,
      default: "medium"
    },
    id: {
      type: String
    }
  },
  setup(e, { expose: t }) {
    const l = e, o = be(), n = Fe() + "--JoyButton", r = V(() => {
      switch (l.size) {
        case "xxsmall":
          return "xxsmall";
        case "xsmall":
          return "xxsmall";
        case "small":
          return "xsmall";
        case "medium":
          return "xsmall";
        default:
          return "small";
      }
    }), a = V(() => ["ghost", "secondary"].includes(l.variant) ? "teal" : "white");
    return t({ generatedId: n }), (i, s) => {
      const d = ct("joy-ripple");
      return Ke((c(), T(Z(q(o).href ? "a" : "button"), {
        id: e.id,
        disabled: e.loading || q(o).disabled,
        type: q(o).type || "button",
        class: I([
          "joy-button",
          `joy-button_${e.variant}`,
          `joy-button_${e.size}`,
          {
            "joy-button_circle": e.circle,
            "joy-button_loading": e.loading
          }
        ]),
        "aria-labelledby": (i.$slots.default || e.label) && n
      }, {
        default: z(() => [
          e.icon && e.iconPosition === "left" ? (c(), T(R, {
            key: 0,
            class: "joy-button_icon joy-button_icon--left",
            name: e.icon,
            size: r.value,
            "aria-hidden": "true"
          }, null, 8, ["name", "size"])) : _("", !0),
          e.loading ? (c(), T(Ut, {
            key: 1,
            color: a.value
          }, null, 8, ["color"])) : _("", !0),
          v("span", {
            id: n,
            class: "joy-button--slot"
          }, [
            w(i.$slots, "default", {}, () => [
              D(J(e.label), 1)
            ], !0)
          ]),
          e.icon && e.iconPosition === "right" ? (c(), T(R, {
            key: 2,
            class: "joy-button_icon joy-button_icon--right",
            name: e.icon,
            size: r.value,
            "aria-hidden": "true"
          }, null, 8, ["name", "size"])) : _("", !0)
        ]),
        _: 3
      }, 8, ["id", "disabled", "type", "class", "aria-labelledby"])), [
        [d]
      ]);
    };
  }
}), ne = /* @__PURE__ */ A(wn, [["__scopeId", "data-v-d687ce44"]]);
function Qe(e) {
  return Pt() ? (Ft(e), !0) : !1;
}
function me(e) {
  return typeof e == "function" ? e() : q(e);
}
const et = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const _n = (e) => e != null, jn = Object.prototype.toString, Gt = (e) => jn.call(e) === "[object Object]", Le = () => {
}, at = /* @__PURE__ */ kn();
function kn() {
  var e, t;
  return et && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(ad|hone|od)/.test(window.navigator.userAgent) || ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function $n(...e) {
  if (e.length !== 1)
    return _o(...e);
  const t = e[0];
  return typeof t == "function" ? jo(ko(() => ({ get: t, set: Le }))) : C(t);
}
function _e(e) {
  var t;
  const l = me(e);
  return (t = l == null ? void 0 : l.$el) != null ? t : l;
}
const yt = et ? window : void 0;
function je(...e) {
  let t, l, o, n;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([l, o, n] = e, t = yt) : [t, l, o, n] = e, !t)
    return Le;
  Array.isArray(l) || (l = [l]), Array.isArray(o) || (o = [o]);
  const r = [], a = () => {
    r.forEach((p) => p()), r.length = 0;
  }, i = (p, u, f, m) => (p.addEventListener(u, f, m), () => p.removeEventListener(u, f, m)), s = K(
    () => [_e(t), me(n)],
    ([p, u]) => {
      if (a(), !p)
        return;
      const f = Gt(u) ? { ...u } : u;
      r.push(
        ...l.flatMap((m) => o.map((y) => i(p, m, y, f)))
      );
    },
    { immediate: !0, flush: "post" }
  ), d = () => {
    s(), a();
  };
  return Qe(d), d;
}
let Vt = !1;
function Sn(e, t, l = {}) {
  const { window: o = yt, ignore: n = [], capture: r = !0, detectIframe: a = !1 } = l;
  if (!o)
    return Le;
  at && !Vt && (Vt = !0, Array.from(o.document.body.children).forEach((f) => f.addEventListener("click", Le)), o.document.documentElement.addEventListener("click", Le));
  let i = !0;
  const s = (f) => n.some((m) => {
    if (typeof m == "string")
      return Array.from(o.document.querySelectorAll(m)).some((y) => y === f.target || f.composedPath().includes(y));
    {
      const y = _e(m);
      return y && (f.target === y || f.composedPath().includes(y));
    }
  }), p = [
    je(o, "click", (f) => {
      const m = _e(e);
      if (!(!m || m === f.target || f.composedPath().includes(m))) {
        if (f.detail === 0 && (i = !s(f)), !i) {
          i = !0;
          return;
        }
        t(f);
      }
    }, { passive: !0, capture: r }),
    je(o, "pointerdown", (f) => {
      const m = _e(e);
      i = !s(f) && !!(m && !f.composedPath().includes(m));
    }, { passive: !0 }),
    a && je(o, "blur", (f) => {
      setTimeout(() => {
        var m;
        const y = _e(e);
        ((m = o.document.activeElement) == null ? void 0 : m.tagName) === "IFRAME" && !(y != null && y.contains(o.document.activeElement)) && t(f);
      }, 0);
    })
  ].filter(Boolean);
  return () => p.forEach((f) => f());
}
function Cn() {
  const e = C(!1), t = $o();
  return t && te(() => {
    e.value = !0;
  }, t), e;
}
function Vn(e) {
  const t = Cn();
  return V(() => (t.value, !!e()));
}
function Tn(e, t = {}) {
  const l = C(!1), o = Ot(null);
  let n = 0, r = !0;
  if (et) {
    const a = typeof t == "function" ? { onDrop: t } : t, i = (s) => {
      var d, p;
      const u = Array.from((p = (d = s.dataTransfer) == null ? void 0 : d.files) != null ? p : []);
      return o.value = u.length === 0 ? null : u;
    };
    je(e, "dragenter", (s) => {
      var d, p;
      const u = Array.from(((d = s == null ? void 0 : s.dataTransfer) == null ? void 0 : d.items) || []).map((f) => f.kind === "file" ? f.type : null).filter(_n);
      if (a.dataTypes && s.dataTransfer) {
        const f = q(a.dataTypes);
        if (r = typeof f == "function" ? f(u) : f ? f.some((m) => u.includes(m)) : !0, !r)
          return;
      }
      s.preventDefault(), n += 1, l.value = !0, (p = a.onEnter) == null || p.call(a, i(s), s);
    }), je(e, "dragover", (s) => {
      var d;
      r && (s.preventDefault(), (d = a.onOver) == null || d.call(a, i(s), s));
    }), je(e, "dragleave", (s) => {
      var d;
      r && (s.preventDefault(), n -= 1, n === 0 && (l.value = !1), (d = a.onLeave) == null || d.call(a, i(s), s));
    }), je(e, "drop", (s) => {
      var d;
      s.preventDefault(), n = 0, l.value = !1, (d = a.onDrop) == null || d.call(a, i(s), s);
    });
  }
  return {
    files: o,
    isOverDropZone: l
  };
}
function xn(e, t, l = {}) {
  const { window: o = yt, ...n } = l;
  let r;
  const a = Vn(() => o && "ResizeObserver" in o), i = () => {
    r && (r.disconnect(), r = void 0);
  }, s = V(() => Array.isArray(e) ? e.map((u) => _e(u)) : [_e(e)]), d = K(
    s,
    (u) => {
      if (i(), a.value && o) {
        r = new ResizeObserver(t);
        for (const f of u)
          f && r.observe(f, n);
      }
    },
    { immediate: !0, flush: "post" }
  ), p = () => {
    i(), d();
  };
  return Qe(p), {
    isSupported: a,
    stop: p
  };
}
function In(e) {
  var t;
  const l = C(e == null ? void 0 : e.element), o = C(e == null ? void 0 : e.input), n = (t = e == null ? void 0 : e.styleProp) != null ? t : "height", r = C(1);
  function a() {
    var i, s;
    if (!l.value)
      return;
    let d = "";
    l.value.style[n] = "1px", r.value = (i = l.value) == null ? void 0 : i.scrollHeight, e != null && e.styleTarget ? me(e.styleTarget).style[n] = `${r.value}px` : d = `${r.value}px`, l.value.style[n] = d, (s = e == null ? void 0 : e.onResize) == null || s.call(e);
  }
  return K([o, l], () => Me(a), { immediate: !0 }), xn(l, () => a()), e != null && e.watch && K(e.watch, a, { immediate: !0, deep: !0 }), {
    textarea: l,
    input: o,
    triggerResize: a
  };
}
const mt = /* @__PURE__ */ L({
  name: "OnClickOutside",
  props: ["as", "options"],
  emits: ["trigger"],
  setup(e, { slots: t, emit: l }) {
    const o = C();
    return Sn(o, (n) => {
      l("trigger", n);
    }, e.options), () => {
      if (t.default)
        return So(e.as || "div", { ref: o }, t.default());
    };
  }
});
function Ln(e) {
  var t;
  const l = me(e);
  return (t = l == null ? void 0 : l.$el) != null ? t : l;
}
const Bn = et ? window : void 0;
function An(...e) {
  let t, l, o, n;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([l, o, n] = e, t = Bn) : [t, l, o, n] = e, !t)
    return Le;
  Array.isArray(l) || (l = [l]), Array.isArray(o) || (o = [o]);
  const r = [], a = () => {
    r.forEach((p) => p()), r.length = 0;
  }, i = (p, u, f, m) => (p.addEventListener(u, f, m), () => p.removeEventListener(u, f, m)), s = K(
    () => [Ln(t), me(n)],
    ([p, u]) => {
      if (a(), !p)
        return;
      const f = Gt(u) ? { ...u } : u;
      r.push(
        ...l.flatMap((m) => o.map((y) => i(p, m, y, f)))
      );
    },
    { immediate: !0, flush: "post" }
  ), d = () => {
    s(), a();
  };
  return Qe(d), d;
}
function lt(e) {
  return typeof Window < "u" && e instanceof Window ? e.document.documentElement : typeof Document < "u" && e instanceof Document ? e.documentElement : e;
}
function Yt(e) {
  const t = window.getComputedStyle(e);
  if (t.overflowX === "scroll" || t.overflowY === "scroll" || t.overflowX === "auto" && e.clientWidth < e.scrollWidth || t.overflowY === "auto" && e.clientHeight < e.scrollHeight)
    return !0;
  {
    const l = e.parentNode;
    return !l || l.tagName === "BODY" ? !1 : Yt(l);
  }
}
function En(e) {
  const t = e || window.event, l = t.target;
  return Yt(l) ? !1 : t.touches.length > 1 ? !0 : (t.preventDefault && t.preventDefault(), !1);
}
const Ne = /* @__PURE__ */ new WeakMap();
function zn(e, t = !1) {
  const l = C(t);
  let o = null, n;
  K($n(e), (i) => {
    const s = lt(me(i));
    if (s) {
      const d = s;
      Ne.get(d) || Ne.set(d, n), l.value && (d.style.overflow = "hidden");
    }
  }, {
    immediate: !0
  });
  const r = () => {
    const i = lt(me(e));
    !i || l.value || (at && (o = An(
      i,
      "touchmove",
      (s) => {
        En(s);
      },
      { passive: !1 }
    )), i.style.overflow = "hidden", l.value = !0);
  }, a = () => {
    var i;
    const s = lt(me(e));
    !s || !l.value || (at && (o == null || o()), s.style.overflow = (i = Ne.get(s)) != null ? i : "", Ne.delete(s), l.value = !1);
  };
  return Qe(a), V({
    get() {
      return l.value;
    },
    set(i) {
      i ? r() : a();
    }
  });
}
function Jn() {
  let e = !1;
  const t = C(!1);
  return (l, o) => {
    if (t.value = o.value, e)
      return;
    e = !0;
    const n = zn(l, o.value);
    K(t, (r) => n.value = r);
  };
}
Jn();
const Mn = { class: "joy-bottom-sheet_content" }, Pn = { class: "joy-bottom-sheet_footer" }, Tt = 75, xt = "moving", Fn = /* @__PURE__ */ L({
  inheritAttrs: !1,
  __name: "VJoyBottomSheet",
  props: {
    closeLabel: { default: "Close" },
    open: { type: Boolean, default: !1 },
    preventBodyScroll: { type: Boolean, default: !0 },
    teleport: { default: "body" },
    frozen: { type: Boolean, default: !1 }
  },
  emits: ["bottom-sheet:close"],
  setup(e, { expose: t, emit: l }) {
    const o = e, n = be(), r = V(() => {
      if (i.value)
        return n;
    }), a = l, i = C(!1), s = C(!1), d = C(o.open), p = C(!1), u = C();
    let f = 0;
    function m() {
      d.value = !0, P();
    }
    function y() {
      o.frozen || (s.value = !0, setTimeout(async () => {
        p.value = !1, s.value = !1, d.value = !1, ye(!1), a("bottom-sheet:close");
      }, 300));
    }
    function b(k) {
      p.value = !0, u.value.classList.add(xt), f = x(k);
    }
    function h(k) {
      p.value && (j(k) > Tt && y(), B());
    }
    function $(k) {
      if (p.value) {
        const N = j(k);
        N > Tt ? y() : N > 0 && E(N);
      }
    }
    function j(k) {
      return x(k) - f;
    }
    function x(k) {
      return ["touchend", "touchmove", "touchstart"].includes(k.type) ? k.changedTouches[0].clientY : k.clientY;
    }
    function E(k) {
      u.value.style.setProperty("transform", `translateY(${k}px)`);
    }
    function B() {
      u.value.classList.remove(xt), u.value.style.removeProperty("transform"), p.value = !1;
    }
    function P() {
      o.preventBodyScroll && ye(!0);
    }
    return K(
      () => o.open,
      (k) => {
        k === !0 ? m() : y();
      }
    ), te(() => {
      i.value = !0, o.open && P();
    }), t({
      hide: y,
      show: m,
      isOpen: d,
      moveContainer: E
    }), (k, N) => i.value ? (c(), T(ze, {
      key: 0,
      to: k.teleport
    }, [
      d.value ? (c(), g("div", H({ key: 0 }, r.value, {
        class: [
          "joy-bottom-sheet",
          {
            "joy-bottom-sheet--open": d.value,
            "joy-bottom-sheet--hiding": s.value && d.value,
            "joy-bottom-sheet--frozen": k.frozen
          }
        ]
      }), [
        N[1] || (N[1] = v("div", { class: "joy-bottom-sheet-overlay" }, null, -1)),
        O(q(mt), { onTrigger: y }, {
          default: z(() => [
            v("div", {
              ref_key: "bottomSheetContainerElement",
              ref: u,
              class: "joy-bottom-sheet-container"
            }, [
              v("div", {
                class: "joy-bottom-sheet_header",
                onMousedown: b,
                onMouseup: h,
                onMousemove: $,
                onMouseleave: h,
                onTouchstart: b,
                onTouchend: h,
                onTouchmove: $
              }, N[0] || (N[0] = [
                v("div", { class: "joy-bottom-sheet_header-close" }, null, -1)
              ]), 32),
              v("div", Mn, [
                w(k.$slots, "bottom-sheet-content", {}, void 0, !0)
              ]),
              v("div", Pn, [
                w(k.$slots, "bottom-sheet-cta", {}, () => [
                  O(ne, {
                    class: "joy-bottom-sheet_footer-close",
                    label: k.closeLabel,
                    onClick: y
                  }, null, 8, ["label"])
                ], !0)
              ])
            ], 512)
          ]),
          _: 3
        })
      ], 16)) : _("", !0)
    ], 8, ["to"])) : _("", !0);
  }
}), Qs = /* @__PURE__ */ A(Fn, [["__scopeId", "data-v-098e6a23"]]), eu = /* @__PURE__ */ L({
  __name: "VJoyBottomSheetTrigger",
  props: {
    bottomSheet: {}
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const l = e, o = t, n = V(() => l.bottomSheet), r = G(), a = V(() => r.default());
    function i() {
      var s;
      o("click"), (s = n.value) == null || s.show();
    }
    return (s, d) => (c(!0), g(W, null, U(a.value, (p) => (c(), T(Z(p), {
      key: p,
      onClick: i
    }))), 128));
  }
}), On = { class: "joy-checkbox__wrapper" }, Dn = { class: "joy-checkbox__input-wrapper" }, Rn = ["id", "name", "disabled", "checked", "required", "value", "indeterminate"], Nn = { class: "joy-checkbox__content-wrapper" }, qn = { class: "joy-checkbox__content" }, Hn = /* @__PURE__ */ L({
  __name: "VJoyCheckbox",
  props: {
    /** Can't be used in addition of v-model. See usage : https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/checkbox#indeterminate_state_checkboxes */
    indeterminate: {
      type: Boolean,
      default: !1
    },
    /**
     * Internal purpose in order to prevent double focus mark on selectable-item
     * @internal
     */
    displayFocus: {
      type: Boolean,
      default: !0
    },
    /** Use it to replace the default slot */
    label: {
      type: String
    },
    /** Checked state of the component */
    checked: {
      type: Boolean,
      default: !1
    },
    invalid: {
      type: Boolean,
      default: !1
    },
    /** The value is used in multiselection context in order to build array of values. */
    value: {
      type: String,
      default: "on"
    },
    /** Removes any interactivity if disabled */
    disabled: {
      type: Boolean,
      default: !1
    },
    id: {
      type: String
    },
    name: {
      type: String
    },
    required: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:checked", "focus", "blur"],
  setup(e, { expose: t, emit: l }) {
    const o = l, n = e, r = C(), a = C(n.indeterminate), i = C(n.invalid), s = C(!1), d = {
      onChange: (p) => {
        const u = p.target.checked;
        a.value = !1, i.value = !1, o("update:checked", u);
      },
      onFocus: () => {
        s.value = !0, o("focus");
      },
      onBlur: () => {
        s.value = !1, o("blur");
      }
    };
    return t({
      isIndeterminate: a
    }), (p, u) => (c(), g("div", On, [
      v("label", {
        class: I([
          "joy-checkbox",
          {
            "joy-checkbox__checked": e.checked,
            "joy-checkbox__indeterminate": a.value,
            "joy-checkbox__disabled": e.disabled,
            "joy-checkbox__invalid": i.value,
            "joy-checkbox__focusing": s.value && e.displayFocus
          }
        ])
      }, [
        v("div", Dn, [
          v("input", {
            id: e.id,
            ref_key: "input",
            ref: r,
            "data-joy-form-field": "",
            type: "checkbox",
            class: "joy-checkbox__input",
            name: e.name,
            disabled: e.disabled,
            checked: e.checked,
            required: e.required,
            value: e.value,
            indeterminate: a.value,
            onChange: u[0] || (u[0] = //@ts-ignore
            (...f) => d.onChange && d.onChange(...f)),
            onFocus: u[1] || (u[1] = //@ts-ignore
            (...f) => d.onFocus && d.onFocus(...f)),
            onBlur: u[2] || (u[2] = //@ts-ignore
            (...f) => d.onBlur && d.onBlur(...f))
          }, null, 40, Rn)
        ]),
        v("div", Nn, [
          w(p.$slots, "default", {}, () => [
            D(J(e.label), 1)
          ], !0),
          v("div", qn, [
            w(p.$slots, "checkbox-content", {}, void 0, !0)
          ])
        ])
      ], 2)
    ]));
  }
}), Kt = /* @__PURE__ */ A(Hn, [["__scopeId", "data-v-5365d871"]]), Wn = ["id"], Un = { class: "joy-collapse-item__header-right" }, Gn = {
  key: 0,
  class: "joy-collapse-item__summary___subheader"
}, Yn = { class: "joy-collapse-item__summary___preview" }, Kn = ["aria-labelledby"], Zn = /* @__PURE__ */ L({
  __name: "VJoyCollapseItem",
  props: {
    /** Title of the collapse item */
    header: {
      type: String,
      required: !0
    },
    subheader: {
      type: String
    },
    open: {
      type: Boolean,
      default: !1
    },
    /** Pick the icon you want to display in front of the header/title */
    summaryIcon: {
      type: String
    },
    id: {
      type: String
    },
    /**
     * Experimental: outline mode may be the default one in near future
     */
    mode: {
      type: String,
      default: "default"
    }
  },
  emits: ["collapse-item:open", "collapse-item:close"],
  setup(e, { expose: t, emit: l }) {
    const o = e, n = l, r = C(o.open), a = C(!1);
    K(
      () => o.open,
      (d) => {
        r.value = d;
      }
    );
    function i() {
      r.value = !r.value, s();
    }
    function s() {
      r.value ? n("collapse-item:open") : n("collapse-item:close");
    }
    return t({
      isOpen: r,
      onToggle: i,
      props: o
    }), (d, p) => (c(), g("div", {
      class: I([
        "joy-collapse-item",
        {
          "joy-collapse-item--open": r.value,
          "joy-collapse-item--outline": e.mode === "outline",
          "joy-collapse-item--focusing": a.value
        }
      ])
    }, [
      v("div", {
        role: "button",
        tabindex: "0",
        class: "joy-collapse-item__summary",
        onClick: i,
        onKeydown: Oe(i, ["enter"]),
        onFocus: p[0] || (p[0] = (u) => a.value = !0),
        onBlur: p[1] || (p[1] = (u) => a.value = !1)
      }, [
        v("div", {
          id: e.id,
          class: "joy-collapse-item__summary___content"
        }, [
          e.summaryIcon ? (c(), T(R, {
            key: 0,
            "aria-hidden": "true",
            color: "secondary",
            name: e.summaryIcon
          }, null, 8, ["name"])) : _("", !0),
          D(" " + J(e.header), 1)
        ], 8, Wn),
        v("div", Un, [
          w(d.$slots, "collapse-header-right")
        ]),
        O(R, {
          class: "joy-collapse-item__summary___marker joy-mt-1",
          name: "chevron-down"
        }),
        e.subheader ? (c(), g("span", Gn, J(e.subheader), 1)) : _("", !0),
        v("span", Yn, [
          w(d.$slots, "collapse-preview")
        ])
      ], 32),
      r.value ? (c(), g("div", {
        key: 0,
        role: "region",
        "aria-labelledby": e.id,
        class: I([
          "joy-collapse-item__detail",
          {
            "joy-collapse-item__detail--open": r.value
          }
        ])
      }, [
        w(d.$slots, "default")
      ], 10, Kn)) : _("", !0)
    ], 2));
  }
}), Xn = /* @__PURE__ */ A(Zn, [["__scopeId", "data-v-0d2e400d"]]), Qn = { class: "joy-collapse" }, el = /* @__PURE__ */ L({
  __name: "VJoyCollapse",
  props: {
    /** Open one item at a time. Works with modelValue */
    accordion: {
      type: Boolean,
      default: !1
    },
    /** Use v-model to handle   */
    modelValue: {
      type: Array,
      default() {
        return [];
      }
    },
    /**
     * Experimental: outline mode may be the default one in near future
     */
    mode: {
      type: String,
      default: "default"
    }
  },
  emits: ["update:modelValue"],
  setup(e, { expose: t, emit: l }) {
    const o = e, n = C(o.modelValue), r = G(), a = l, i = V(() => {
      const y = r.default();
      return y.length === 1 && typeof y[0].type != "object" ? y[0].children.filter(s) : y.filter(s);
    });
    function s(y) {
      var b;
      return ((b = y == null ? void 0 : y.type) == null ? void 0 : b.__name) === "VJoyCollapseItem";
    }
    function d(y, b) {
      if (!(!y.children || !y.children[b]))
        return y.children[b]();
    }
    function p(y) {
      return o.modelValue.length ? o.modelValue.includes(m(y)) : y.props.open;
    }
    async function u(y) {
      if (o.accordion) {
        let b = [];
        b.push(m(y)), n.value = b;
      }
      n.value.indexOf(m(y)) === -1 && n.value.push(m(y)), a("update:modelValue", n.value);
    }
    function f(y) {
      o.accordion && (n.value = []);
      const b = n.value.indexOf(m(y));
      b !== -1 && n.value.splice(b, 1), a("update:modelValue", n.value);
    }
    function m(y) {
      return y.props.id || y.props.header;
    }
    return t({
      getValForModel: m,
      isItem: s,
      isOpen: p,
      items: i,
      openedCollapseItem: n
    }), (y, b) => (c(), g("div", Qn, [
      (c(!0), g(W, null, U(i.value, (h) => (c(), T(Xn, H({ ref_for: !0 }, h.props, {
        key: h.props.id,
        open: p(h),
        mode: e.mode,
        "onCollapseItem:open": () => u(h),
        "onCollapseItem:close": () => f(h)
      }), {
        "collapse-header-right": z(() => [
          (c(!0), g(W, null, U(d(h, "collapse-header-right"), ($, j) => (c(), T(Z($), { key: j }))), 128))
        ]),
        "collapse-preview": z(() => [
          (c(!0), g(W, null, U(d(h, "collapse-preview"), ($, j) => (c(), T(Z($), { key: j }))), 128))
        ]),
        default: z(() => [
          (c(!0), g(W, null, U(d(h, "default"), ($, j) => (c(), T(Z($), { key: j }))), 128))
        ]),
        _: 2
      }, 1040, ["open", "mode", "onCollapseItem:open", "onCollapseItem:close"]))), 128))
    ]));
  }
}), tu = /* @__PURE__ */ A(el, [["__scopeId", "data-v-35744932"]]), tl = ["src", "alt", "title", "loading"], ol = /* @__PURE__ */ L({
  __name: "VJoyCompanyAvatar",
  props: {
    /** Inject the URL of your image. Fallback will be the icon */
    imgSrc: String,
    /** Mostly for accessibility, use this to add an alternative text. */
    imgAlt: String,
    /** Used as "title" attribute for the img. */
    companyName: String,
    size: {
      type: String,
      default: "large"
    },
    /** Only applied if you set a imgSrc */
    loading: {
      type: String,
      default: "lazy"
    }
  },
  setup(e) {
    const t = e, l = V(() => {
      switch (t.size) {
        case "large":
          return "small";
        case "medium":
          return "xsmall";
        case "small":
          return "xxsmall";
        default:
          return "xsmall";
      }
    });
    return (o, n) => (c(), g("div", {
      class: I(["joy-company-avatar", `joy-company-avatar--${e.size}`])
    }, [
      e.imgSrc ? (c(), g("img", {
        key: 0,
        src: e.imgSrc,
        alt: e.imgAlt || e.companyName,
        title: e.companyName,
        loading: e.loading
      }, null, 8, tl)) : (c(), T(R, {
        key: 1,
        name: "company-placeholder",
        size: l.value
      }, null, 8, ["size"]))
    ], 2));
  }
}), ou = /* @__PURE__ */ A(ol, [["__scopeId", "data-v-2f1289c1"]]), nl = ["aria-hidden"], ll = /* @__PURE__ */ L({
  __name: "VJoyFormError",
  props: {
    /** In some cases you'll need to inject the error in the DOM but hide it. Visible by default */
    visible: {
      type: Boolean,
      default: !0
    },
    /** Error message to display. If you need a list of errors, use the slot instead */
    noHtmlErrorText: String
  },
  setup(e) {
    return (t, l) => (c(), g("div", {
      "data-joy-form-error": "",
      "aria-hidden": e.visible,
      class: I(["joy-form-error", { "joy-has-error": e.visible }]),
      role: "alert"
    }, [
      O(R, {
        class: "joy-icon-error",
        name: "warning-triangle"
      }),
      v("div", null, [
        w(t.$slots, "default", {}, () => [
          D(J(e.noHtmlErrorText), 1)
        ], !0)
      ])
    ], 10, nl));
  }
}), tt = /* @__PURE__ */ A(ll, [["__scopeId", "data-v-d4e96d51"]]), al = {
  key: 0,
  class: "joy-label-required"
}, rl = {
  key: 1,
  class: "joy-label-optional"
}, il = /* @__PURE__ */ L({
  __name: "VJoyLabel",
  props: {
    size: {
      type: String,
      default: "medium"
    },
    tagName: {
      type: String,
      default: "label"
    },
    required: {
      type: Boolean,
      default: !1
    },
    optionalLabel: {
      type: String
    },
    text: String
  },
  setup(e) {
    return (t, l) => (c(), T(Z(e.tagName), H({
      "data-joy-form-label": "",
      class: ["joy-label", `joy-label--${e.size}`]
    }, t.$attrs), {
      default: z(() => [
        w(t.$slots, "default", {}, () => [
          D(J(e.text), 1)
        ], !0),
        e.required ? (c(), g("span", al, "*")) : _("", !0),
        e.optionalLabel ? (c(), g("span", rl, "- " + J(e.optionalLabel), 1)) : _("", !0)
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), Ve = /* @__PURE__ */ A(il, [["__scopeId", "data-v-b7569c8b"]]);
function sl(e) {
  const t = () => e();
  te(() => {
    window.addEventListener("resize", t);
  }), Je(() => {
    window.removeEventListener("resize", t);
  });
}
function vt(e, t) {
  te(() => {
    var l;
    t && ((l = e.value) == null || l.focus());
  });
}
const ul = { class: "joy-counter" }, dl = ["aria-label", "disabled"], cl = { class: "joy-counter__input-wrapper" }, fl = ["id", "min", "max", "aria-invalid", "name", "required", "value"], pl = ["aria-label", "disabled"], yl = {
  key: 0,
  class: "joy-counter_error"
}, ml = {
  inheritAttrs: !1
}, vl = /* @__PURE__ */ L({
  ...ml,
  __name: "VJoyCounter",
  props: {
    autofocus: {
      type: Boolean,
      default: !1
    },
    /** Removes any interactivity */
    disabled: {
      type: Boolean,
      default: !1
    },
    id: {
      type: String
    },
    invalid: {
      type: Boolean,
      default: !1
    },
    name: {
      type: String
    },
    required: {
      type: Boolean,
      default: !1
    },
    /** Display a label on top of the element. */
    label: String,
    /** Overrides the default label size. See JoyLabel stories */
    labelSize: {
      type: String,
      default: "medium"
    },
    /** If your component is not required, we can add a label to explicitely tell that it's not mandatory */
    optionalLabel: String,
    /** Depending on context, we can add a "*" after the label to specify it's mandatory. */
    requiredMark: {
      type: Boolean,
      default: !1
    },
    /** Used for aria-label. */
    labelDecrement: {
      type: String
    },
    /** Used for aria-label. */
    labelIncrement: {
      type: String
    },
    max: {
      type: Number
    },
    min: {
      type: Number,
      default: 0
    },
    modelValue: {
      type: Number,
      default: 0
    },
    /** In order to increment or decrement by given steps. For non-integer values, don't use comma */
    step: {
      type: Number,
      default: 1
    },
    /** When given, it renders a JoyFormError element */
    errorMessage: {
      type: String
    }
  },
  emits: ["update:modelValue"],
  setup(e, { expose: t, emit: l }) {
    const o = l, n = e, r = C(!1), a = C(!1), i = C();
    vt(i, n.autofocus);
    function s() {
      const h = u(!1);
      h >= 0 ? o("update:modelValue", h <= n.min ? n.min : h) : o("update:modelValue", 0), p();
    }
    function d() {
      const h = u();
      n.max && h <= n.max ? o("update:modelValue", h >= n.max ? n.max : h) : n.max && h > n.max ? o("update:modelValue", n.max) : o("update:modelValue", h), p();
    }
    function p() {
      r.value = !f();
    }
    function u(h = !0) {
      const $ = n.step.toString().split("."), j = $.length === 2 ? $[1].length : 0;
      return parseFloat(h ? (n.modelValue + n.step).toFixed(j) : (n.modelValue - n.step).toFixed(j));
    }
    function f() {
      return m() && y();
    }
    function m() {
      return !n.max || n.modelValue <= n.max;
    }
    function y() {
      return n.min <= n.modelValue;
    }
    const b = {
      onInput: (h) => {
        o("update:modelValue", +h.target.value || 0), r.value = !1;
      },
      onFocus: () => {
        a.value = !0;
      },
      onBlur: () => {
        a.value = !1, p();
      }
    };
    return t({
      props: n
    }), (h, $) => (c(), g("div", ul, [
      e.label ? (c(), T(Ve, {
        key: 0,
        for: e.id,
        required: e.required && e.requiredMark,
        "optional-label": e.optionalLabel,
        size: e.labelSize
      }, {
        default: z(() => [
          w(h.$slots, "default", {}, () => [
            D(J(e.label), 1)
          ], !0)
        ]),
        _: 3
      }, 8, ["for", "required", "optional-label", "size"])) : _("", !0),
      v("div", {
        class: I(["joy-counter__wrapper", { "joy-counter--focusing": a.value }])
      }, [
        v("button", {
          class: "joy-counter__decrement",
          type: "button",
          "aria-label": e.labelDecrement,
          disabled: e.modelValue <= e.min,
          onClick: s
        }, [
          O(R, { name: "minus" })
        ], 8, dl),
        v("div", cl, [
          v("input", H({
            id: e.id,
            ref_key: "input",
            ref: i,
            "data-joy-form-field": "",
            type: "number",
            class: { "joy-counter__invalid": e.invalid || r.value },
            min: e.min,
            max: e.max,
            "aria-invalid": e.invalid || r.value,
            name: e.name,
            required: e.required,
            step: "any",
            value: e.modelValue
          }, h.$attrs, {
            onInput: $[0] || ($[0] = //@ts-ignore
            (...j) => b.onInput && b.onInput(...j)),
            onBlur: $[1] || ($[1] = //@ts-ignore
            (...j) => b.onBlur && b.onBlur(...j)),
            onFocus: $[2] || ($[2] = //@ts-ignore
            (...j) => b.onFocus && b.onFocus(...j))
          }), null, 16, fl)
        ]),
        v("button", {
          class: "joy-counter__increment",
          type: "button",
          "aria-label": e.labelIncrement,
          disabled: e.max ? e.modelValue >= e.max : !1,
          onClick: d
        }, [
          O(R, { name: "add" })
        ], 8, pl),
        e.invalid && e.errorMessage ? (c(), g("div", yl, [
          O(tt, { "no-html-error-text": e.errorMessage }, null, 8, ["no-html-error-text"])
        ])) : _("", !0)
      ], 2)
    ]));
  }
}), nu = /* @__PURE__ */ A(vl, [["__scopeId", "data-v-3e354b87"]]), hl = /* @__PURE__ */ L({
  __name: "VJoyWrapper",
  props: {
    /** Horizontal spread. Refers to CSS flex justify-content. */
    justify: {
      type: String,
      default: "flex-start"
    },
    /** Vertical spread. Refers to CSS flex align-items. */
    align: {
      type: String,
      default: "center"
    },
    /** Vertical flex, or horizontal. Refers to CSS flex-direction */
    direction: {
      type: String,
      default: "row"
    },
    /** Automatically sets new line if there are not enough horizontal space. Refers to CSS flex-wrap */
    wrap: {
      type: String,
      default: "wrap"
    },
    /** Applies a flex-grow to children in order to stretch them all along horizontal space */
    itemStretch: {
      type: Boolean
    },
    /** Removes the default bottom margin applied to the wrapper */
    noMargin: {
      type: Boolean,
      default: !1
    },
    /** Gap between the columns. Refers to CSS column-gap. Value is based on spacing tokens. */
    columnGap: {
      type: String,
      default: "4"
    },
    /** Gap between the rows. Refers to CSS row-gap. Value is based on spacing tokens. */
    rowGap: {
      type: String,
      default: "8"
    }
  },
  setup(e) {
    return Ze("VJoyWrapperContext", e), (l, o) => (c(), g("div", {
      class: I([
        "joy-wrapper",
        `joy-wrapper--justify-${e.justify}`,
        `joy-wrapper--align-${e.align}`,
        `joy-wrapper--direction-${e.direction}`,
        `joy-wrapper--wrap-${e.wrap}`,
        `joy-wrapper--row-gap-${e.rowGap}`,
        `joy-wrapper--column-gap-${e.columnGap}`,
        { "joy-wrapper--item-stretch": e.itemStretch },
        { "joy-wrapper--has-margin": !e.noMargin }
      ])
    }, [
      w(l.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), re = /* @__PURE__ */ A(hl, [["__scopeId", "data-v-68d89412"]]), gl = ["id"], bl = { class: "joy-dialog__inner" }, wl = {
  key: 0,
  class: "joy-dialog__shapes"
}, _l = { class: "joy-dialog--header" }, jl = {
  key: 0,
  class: "joy-dialog--preheader"
}, kl = {
  id: "dialogDescription",
  class: "joy-dialog--subheader"
}, $l = {
  class: "joy-dialog--body",
  tabindex: "0"
}, Sl = {
  key: 2,
  class: "joy-dialog--indicators"
}, Cl = /* @__PURE__ */ L({
  inheritAttrs: !1,
  __name: "VJoyDialog",
  props: {
    id: {
      type: String
    },
    size: {
      type: String,
      default: "default"
    },
    /** By default the dialog is teleported to the end of body tag */
    teleport: {
      type: String,
      default: "body"
    },
    open: {
      type: Boolean,
      default: !1
    },
    /**
     * Mostly for documentation purpose
     */
    preventBodyScroll: {
      type: Boolean,
      default: !0
    },
    disableTeleport: {
      type: Boolean,
      default: !1
    },
    /** Mostly for documentation purpose, it prevents the component from being hidden */
    demoMode: {
      type: Boolean,
      default: !1
    },
    /** **For accessibility purpose**. Label associated with the top right corner icon.  */
    closeLabel: {
      type: String,
      default: "Close dialog"
    },
    /** Display the dialog without the top right icon to close it.
     * Click on backdrop is disabled and pressing Escape does not trigger anything.
     */
    patternConfirm: {
      type: Boolean,
      default: !1
    },
    /**
     * EXPERIMENTAL: activates a new centered layout and display decorative colored shapes. Shapes can't be disabled.
     */
    patternBrand: {
      type: Boolean,
      default: !1
    },
    /** Use this property to directly create a cancel CTA (VJoyButton), if you don't need to customize the CTA. */
    cancelText: {
      type: String
    },
    /** Use this property to directly create a confirm CTA (VJoyButton), if you don't need to customize the CTA. */
    confirmText: {
      type: String
    },
    buttonSize: {
      type: String,
      default: "medium"
    },
    /** Link to inject an image on top of the dialog */
    bannerSrc: {
      type: String
    },
    /** Based on CSS propetty background-position. https://developer.mozilla.org/en-US/docs/Web/CSS/background-position */
    bannerPosition: {
      type: String
    },
    bannerHeight: {
      type: Number,
      default: 250
    }
  },
  emits: ["dialog:open", "dialog:after-open", "dialog:hide", "dialog:after-hide", "dialog:before-unmount", "dialog:confirm"],
  setup(e, { expose: t, emit: l }) {
    const o = e, n = l, r = Fe() + "--JoyDialog", a = G(), i = C(!1), s = C(), d = C(o.open), p = be(), u = V(() => {
      if (i.value)
        return p;
    }), f = V(() => {
      const B = a["dialog-cancel"] || a["dialog-confirm"], P = o.cancelText || o.confirmText;
      return !!B || !!P;
    }), y = V(() => o.id || r).value + "-header";
    function b() {
      !o.patternConfirm && h();
    }
    async function h(B = { fireHideEvent: !0 }) {
      o.demoMode || (d.value = !1, await Me(), ye(!1), B.fireHideEvent && n("dialog:hide"));
    }
    async function $() {
      d.value = !0, await Me(), o.preventBodyScroll && ye(!0);
    }
    function j() {
      n("dialog:open");
    }
    function x() {
      n("dialog:after-open");
    }
    function E() {
      n("dialog:after-hide");
    }
    return te(async () => {
      i.value = !0;
    }), Je(() => {
      d.value === !0 && (n("dialog:before-unmount"), ye(!1));
    }), t({
      hasFooterSlots: f,
      hide: h,
      isOpen: d,
      show: $
    }), (B, P) => i.value ? (c(), T(ze, {
      key: 0,
      to: e.teleport,
      disabled: e.disableTeleport
    }, [
      O(ft, {
        duration: { enter: 300, leave: 100 },
        name: "dialog",
        appear: "",
        onEnter: j,
        onAfterEnter: x,
        onAfterLeave: E
      }, {
        default: z(() => [
          d.value ? (c(), g("div", H({ key: 0 }, u.value, {
            id: e.id || r,
            ref_key: "dialogRef",
            ref: s,
            role: "dialog",
            "aria-modal": "true",
            class: ["joy-dialog", `joy-dialog--${e.size}`, { "joy-dialog--open": d.value, "joy-dialog--pattern-brand": e.patternBrand }],
            "aria-labelledby": y,
            onKeydown: Oe(b, ["esc"])
          }), [
            v("div", {
              class: I([
                {
                  "joy-dialog__overlay": !0,
                  "joy-dialog__overlay--open": d.value,
                  "joy-dialog__overlay___disabled": e.patternConfirm
                }
              ]),
              onClick: b
            }, null, 2),
            v("div", {
              class: I([
                {
                  "joy-dialog--wrapper": !0,
                  "joy-dialog--wrapper-open": d.value
                }
              ])
            }, [
              v("div", bl, [
                e.patternBrand ? (c(), g("div", wl, P[3] || (P[3] = [
                  v("div", { class: "joy-dialog__shapes___shape" }, null, -1),
                  v("div", { class: "joy-dialog__shapes___shape" }, null, -1)
                ]))) : _("", !0),
                e.bannerSrc ? (c(), g("div", {
                  key: 1,
                  class: "joy-dialog--banner",
                  style: ee({
                    backgroundImage: `url(${e.bannerSrc})`,
                    backgroundPosition: e.bannerPosition,
                    height: `${e.bannerHeight}px`
                  })
                }, null, 4)) : _("", !0),
                v("div", _l, [
                  B.$slots["dialog-preheader"] ? (c(), g("div", jl, [
                    w(B.$slots, "dialog-preheader", {}, void 0, !0)
                  ])) : _("", !0),
                  v("div", {
                    id: y,
                    class: "joy-dialog--header__title"
                  }, [
                    w(B.$slots, "dialog-header", {}, void 0, !0)
                  ]),
                  v("p", kl, [
                    w(B.$slots, "dialog-subheader", {}, void 0, !0)
                  ]),
                  e.patternConfirm ? _("", !0) : (c(), T(ne, {
                    key: 1,
                    id: "joy-dialog--close",
                    circle: "",
                    icon: "cross",
                    size: "small",
                    variant: "ghost",
                    name: "cross",
                    label: e.closeLabel,
                    class: "joy-dialog--close",
                    onClick: P[0] || (P[0] = (k) => h())
                  }, null, 8, ["label"]))
                ]),
                v("div", $l, [
                  w(B.$slots, "dialog-body", {}, void 0, !0)
                ]),
                v("div", {
                  class: I([
                    {
                      "joy-dialog--footer": !0,
                      "joy-dialog--footer-filled": f.value
                    }
                  ])
                }, [
                  O(re, {
                    justify: "flex-end",
                    "no-margin": ""
                  }, {
                    default: z(() => [
                      w(B.$slots, "dialog-cancel", {}, () => [
                        e.cancelText ? (c(), T(ne, {
                          key: 0,
                          class: "joy-dialog--cancel",
                          variant: "ghost",
                          size: e.buttonSize,
                          onClick: P[1] || (P[1] = (k) => h())
                        }, {
                          default: z(() => [
                            D(J(e.cancelText), 1)
                          ]),
                          _: 1
                        }, 8, ["size"])) : _("", !0)
                      ], !0),
                      w(B.$slots, "dialog-confirm", {}, () => [
                        e.confirmText ? (c(), T(ne, {
                          key: 0,
                          class: "joy-dialog--confirm",
                          variant: "main",
                          size: e.buttonSize,
                          onClick: P[2] || (P[2] = (k) => n("dialog:confirm"))
                        }, {
                          default: z(() => [
                            D(J(e.confirmText), 1)
                          ]),
                          _: 1
                        }, 8, ["size"])) : _("", !0)
                      ], !0)
                    ]),
                    _: 3
                  })
                ], 2),
                q(a)["dialog-indicators"] ? (c(), g("div", Sl, [
                  w(B.$slots, "dialog-indicators", {}, void 0, !0)
                ])) : _("", !0)
              ])
            ], 2)
          ], 16, gl)) : _("", !0)
        ]),
        _: 3
      })
    ], 8, ["to", "disabled"])) : _("", !0);
  }
}), lu = /* @__PURE__ */ A(Cl, [["__scopeId", "data-v-0f773f72"]]), au = /* @__PURE__ */ L({
  __name: "VJoyDialogTrigger",
  props: {
    dialog: {}
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const l = e, o = V(() => l.dialog), n = t, r = G(), a = V(() => r.default());
    async function i() {
      var s;
      n("click"), await ((s = o.value) == null ? void 0 : s.show());
    }
    return (s, d) => (c(!0), g(W, null, U(a.value, (p) => (c(), T(Z(p), {
      key: p,
      onClick: i
    }))), 128));
  }
}), Vl = ["id"], Tl = { class: "joy-drawer__inner" }, xl = { class: "joy-drawer--header" }, Il = {
  id: "drawerDescription",
  class: "joy-drawer--subheader"
}, Ll = {
  class: "joy-drawer--body",
  tabindex: "0"
}, Bl = /* @__PURE__ */ L({
  inheritAttrs: !1,
  __name: "VJoyDrawer",
  props: {
    id: {
      type: String
    },
    size: {
      type: String,
      default: "default"
    },
    /** By default the drawer is teleported to the end of body tag */
    teleport: {
      type: String,
      default: "body"
    },
    open: {
      type: Boolean,
      default: !1
    },
    /** Removes the overlay and allows interacting with background content.*/
    elevated: {
      type: Boolean,
      default: !1
    },
    /**
     * Mostly for documentation purpose
     */
    preventBodyScroll: {
      type: Boolean,
      default: !0
    },
    disableTeleport: {
      type: Boolean,
      default: !1
    },
    /** Mostly for documentation purpose, it prevents the component from being hidden */
    demoMode: {
      type: Boolean,
      default: !1
    },
    /** **For accessibility purpose**. Label associated with the top right corner icon.  */
    closeLabel: {
      type: String,
      default: "Close drawer"
    },
    /** Use this property to directly create a cancel CTA (VJoyButton), if you don't need to customize the CTA. */
    cancelText: {
      type: String
    },
    /** Use this property to directly create a confirm CTA (VJoyButton), if you don't need to customize the CTA. */
    confirmText: {
      type: String
    },
    buttonSize: {
      type: String,
      default: "medium"
    },
    /** Called just before you close the drawer. Returning false will cancel the closing.
     * This is useful when you need confirmation from the user to close the drawer. */
    onBeforeHide: {
      type: Function
    }
  },
  emits: ["drawer:open", "drawer:after-open", "drawer:hide", "drawer:after-hide", "drawer:before-unmount", "drawer:confirm"],
  setup(e, { expose: t, emit: l }) {
    const o = e, n = l, r = Fe() + "--JoyDrawer", a = G(), i = C(!1), s = C(), d = C(o.open), p = be(), u = V(() => {
      if (i.value)
        return p;
    }), f = V(() => {
      const E = a["drawer-cancel"] || a["drawer-confirm"], B = o.cancelText || o.confirmText;
      return !!E || !!B;
    }), m = V(() => o.id || r), y = m.value + "-header";
    async function b(E = { fireHideEvent: !0 }) {
      o.demoMode || o.onBeforeHide && !await o.onBeforeHide() || (d.value = !1, await Me(), ye(!1), E.fireHideEvent && n("drawer:hide"));
    }
    async function h() {
      d.value = !0, await Me(), !o.elevated && o.preventBodyScroll && ye(!0);
    }
    function $() {
      n("drawer:open");
    }
    function j() {
      n("drawer:after-open");
    }
    function x() {
      n("drawer:after-hide");
    }
    return te(() => {
      i.value = !0;
    }), Je(() => {
      d.value === !0 && (n("drawer:before-unmount"), ye(!1));
    }), t({
      hasFooterSlots: f,
      hide: b,
      isOpen: d,
      show: h
    }), (E, B) => i.value ? (c(), T(ze, {
      key: 0,
      to: e.teleport,
      disabled: e.disableTeleport
    }, [
      O(ft, {
        duration: { enter: 300, leave: 100 },
        name: "drawer",
        appear: "",
        onEnter: $,
        onAfterEnter: j,
        onAfterLeave: x
      }, {
        default: z(() => [
          d.value ? (c(), g("div", H({ key: 0 }, u.value, {
            id: m.value,
            ref_key: "drawerRef",
            ref: s,
            role: "dialog",
            "aria-modal": "true",
            class: [
              "joy-drawer",
              `joy-drawer--${e.size}`,
              {
                "joy-drawer--open": d.value,
                "joy-drawer--elevated": e.elevated
              }
            ],
            "aria-labelledby": y,
            onKeydown: B[4] || (B[4] = Oe((P) => b(), ["esc"]))
          }), [
            e.elevated ? _("", !0) : (c(), g("div", {
              key: 0,
              class: I([
                {
                  "joy-drawer__overlay": !0,
                  "joy-drawer__overlay--open": d.value
                }
              ]),
              onClick: B[0] || (B[0] = (P) => b())
            }, null, 2)),
            v("div", {
              class: I([
                {
                  "joy-drawer--wrapper": !0,
                  "joy-drawer--wrapper-open": d.value
                }
              ])
            }, [
              v("div", Tl, [
                v("div", xl, [
                  v("div", {
                    id: y,
                    class: "joy-drawer--header__title"
                  }, [
                    w(E.$slots, "drawer-header", {}, void 0, !0)
                  ]),
                  v("p", Il, [
                    w(E.$slots, "drawer-subheader", {}, void 0, !0)
                  ]),
                  O(ne, {
                    id: "joy-drawer--close",
                    circle: "",
                    icon: "cross",
                    size: "small",
                    variant: "ghost",
                    name: "cross",
                    label: e.closeLabel,
                    class: "joy-drawer--close",
                    onClick: B[1] || (B[1] = (P) => b())
                  }, null, 8, ["label"])
                ]),
                v("div", Ll, [
                  w(E.$slots, "drawer-body", {}, void 0, !0)
                ]),
                v("div", {
                  class: I([
                    {
                      "joy-drawer--footer": !0,
                      "joy-drawer--footer-filled": f.value
                    }
                  ])
                }, [
                  O(re, {
                    justify: "flex-end",
                    "no-margin": "",
                    class: "joy-drawer--footer-wrapper"
                  }, {
                    default: z(() => [
                      w(E.$slots, "drawer-cancel", {}, () => [
                        e.cancelText ? (c(), T(ne, {
                          key: 0,
                          class: "joy-drawer--cancel",
                          variant: "ghost",
                          size: e.buttonSize,
                          onClick: B[2] || (B[2] = (P) => b())
                        }, {
                          default: z(() => [
                            D(J(e.cancelText), 1)
                          ]),
                          _: 1
                        }, 8, ["size"])) : _("", !0)
                      ], !0),
                      w(E.$slots, "drawer-confirm", {}, () => [
                        e.confirmText ? (c(), T(ne, {
                          key: 0,
                          class: "joy-drawer--confirm",
                          variant: "main",
                          size: e.buttonSize,
                          onClick: B[3] || (B[3] = (P) => n("drawer:confirm"))
                        }, {
                          default: z(() => [
                            D(J(e.confirmText), 1)
                          ]),
                          _: 1
                        }, 8, ["size"])) : _("", !0)
                      ], !0)
                    ]),
                    _: 3
                  })
                ], 2)
              ])
            ], 2)
          ], 16, Vl)) : _("", !0)
        ]),
        _: 3
      })
    ], 8, ["to", "disabled"])) : _("", !0);
  }
}), ru = /* @__PURE__ */ A(Bl, [["__scopeId", "data-v-056f6134"]]), iu = /* @__PURE__ */ L({
  __name: "VJoyDrawerTrigger",
  props: {
    drawer: {}
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const l = e, o = t, n = V(() => l.drawer), r = G(), a = V(() => r.default());
    async function i() {
      var s;
      o("click"), await ((s = n.value) == null ? void 0 : s.show());
    }
    return (s, d) => (c(!0), g(W, null, U(a.value, (p) => (c(), T(Z(p), {
      key: p,
      onClick: i
    }))), 128));
  }
}), Al = {
  key: 0,
  class: "joy-dropdown-list__header"
}, El = ["aria-label", "aria-labelledby"], zl = ["id", "tabindex", "aria-disabled", "aria-selected", "title", "aria-label", ".dataModel", "onClick"], Jl = {
  key: 1,
  class: "joy-dropdown-list__footer"
}, Ml = /* @__PURE__ */ L({
  __name: "VJoyDropdownList",
  props: {
    /**
     * You need to pass an unique ID for each option. You can also pass a value if you want to customize the value of the v-model.
     */
    options: {
      type: Array,
      default() {
        return [];
      }
    },
    /** Customize the actual size of each items. */
    size: {
      type: String,
      default: "medium"
    },
    modelValue: {
      type: String
    },
    width: {
      type: String,
      default: "300"
    },
    height: {
      type: String,
      default: "300"
    },
    reset: {
      type: Boolean,
      default: !1
    },
    resetLabel: {
      type: String
    },
    ariaLabelledBy: {
      type: String
    },
    ariaLabel: {
      type: String
    }
  },
  emits: ["update:modelValue", "close:dropdownList", "reset"],
  setup(e, { expose: t, emit: l }) {
    const o = l, n = e, r = C(), a = V(() => (y) => !n.modelValue || !y.value && !y.id ? !1 : n.modelValue === y.value || n.modelValue === y.id);
    function i(y) {
      y.disabled || o("update:modelValue", y.value || y.id);
    }
    function s() {
      var y;
      return Array.from(((y = r.value) == null ? void 0 : y.querySelectorAll("li")) || []);
    }
    function d() {
      const y = s().find((b) => b.getAttribute("aria-selected") === "true");
      y && (y.focus(), r.value.scrollTo({
        top: y.offsetTop
      }));
    }
    function p() {
      return s().find((y) => y === document.activeElement);
    }
    function u(y) {
      var b;
      if (!(r.value && !r.value.contains(document.activeElement) || !r.value)) {
        if ((y.key === "Escape" || y.key === "Tab") && o("close:dropdownList"), (y.key === "Enter" || y.key === "enter") && (y.preventDefault(), p() && ((b = r.value) != null && b.contains(p())))) {
          const h = p();
          if (!h)
            return;
          if (h.querySelector("a"))
            return h.querySelector("a").click();
          o("update:modelValue", h.dataModel);
        }
        if (p() && y.key === " " && y.preventDefault(), ["ArrowDown", "ArrowUp", "Home", "End"].includes(y.key)) {
          const h = s(), $ = p();
          let j = h.indexOf($);
          if (h.length) {
            y.preventDefault(), y.key === "ArrowDown" ? j++ : y.key === "ArrowUp" ? j-- : y.key === "Home" ? j = 0 : y.key === "End" && (j = h.length - 1), j < 0 && (j = h.length - 1), j > h.length - 1 && (j = 0), f(h[j]);
            return;
          }
        }
      }
    }
    function f(y) {
      y.focus();
    }
    function m() {
      o("reset");
    }
    return te(() => {
      window.addEventListener("keydown", u), d();
    }), Je(() => {
      window.removeEventListener("keydown", u);
    }), t({
      isSelected: a
    }), (y, b) => (c(), g("div", {
      class: "joy-dropdown-list",
      style: ee({ width: `${e.width}px`, "max-width": `${e.width}px` })
    }, [
      y.$slots["dropdown-list-header"] || e.reset ? (c(), g("header", Al, [
        e.reset ? (c(), g("button", {
          key: 0,
          type: "button",
          class: "joy-dropdown-list__reset",
          onClick: m
        }, J(e.resetLabel || "Reset"), 1)) : _("", !0),
        w(y.$slots, "dropdown-list-header", {}, void 0, !0)
      ])) : _("", !0),
      v("div", {
        tabindex: "0",
        class: I(["joy-dropdown-list__items", { "joy-dropdown-list__items-slotted": y.$slots["dropdown-list-items"] }]),
        style: ee({ "max-height": `${e.height}px` })
      }, [
        w(y.$slots, "dropdown-list-items", {}, void 0, !0),
        e.options.length ? (c(), g("ul", {
          key: 0,
          ref_key: "listbox",
          ref: r,
          role: "listbox",
          "aria-expanded": "true",
          "aria-label": e.ariaLabel,
          "aria-labelledby": e.ariaLabelledBy
        }, [
          (c(!0), g(W, null, U(e.options, (h) => (c(), g("li", {
            id: h.id,
            key: h.id,
            style: ee({ "max-width": `${e.width}px` }),
            class: I([
              "joy-dropdown-list__item",
              `joy-dropdown-list__item--${e.size}`,
              {
                "joy-dropdown-list__item--selected": a.value(h),
                "joy-dropdown-list__item--disabled": h.disabled
              }
            ]),
            tabindex: h.disabled ? void 0 : -1,
            "aria-disabled": h.disabled,
            "aria-selected": a.value(h),
            title: h.label,
            "aria-label": h.label,
            ".dataModel": h.value || h.id,
            role: "option",
            onClick: ($) => i(h)
          }, [
            w(y.$slots, "label", H({ ref_for: !0 }, h), () => [
              v("span", null, J(h.label), 1)
            ], !0)
          ], 46, zl))), 128))
        ], 8, El)) : _("", !0)
      ], 6),
      y.$slots["dropdown-list-footer"] ? (c(), g("footer", Jl, [
        w(y.$slots, "dropdown-list-footer", {}, void 0, !0)
      ])) : _("", !0)
    ], 4));
  }
}), Pl = /* @__PURE__ */ A(Ml, [["__scopeId", "data-v-7a3292aa"]]), Fl = /* @__PURE__ */ L({
  __name: "VJoyDropdown",
  props: {
    /** DOM valid selector to give to Vue3 Teleport "to" property */
    appendTo: {
      type: String,
      default: "body"
    },
    /**
     * Disable teleport for testing purpose mostly.
     */
    disableTeleport: {
      type: Boolean,
      default: !1
    },
    /** close the dropdown list when clicking on any item. Default to false */
    closeOnSelect: {
      type: Boolean,
      default: !0
    },
    /** Dropdown vertical position according to the trigger */
    direction: {
      type: String,
      default: "down"
    },
    /** Dropdown horizontal justify according to the trigger */
    justify: {
      type: String,
      default: "left"
    },
    /**
     * Use options to render a pre-designed list.
     *
     * ```
     * interface Option {id: string; value?: string; label: string; href?: string; disabled?:boolean; checked?:boolean}
     * ```
     */
    options: {
      type: Array,
      default() {
        return [];
      }
    },
    size: {
      type: String,
      default: "medium"
    },
    /** Use v-model */
    modelValue: {
      type: String,
      default: ""
    },
    /**
     * Space between the trigger and the list
     */
    dropdownGap: {
      type: String,
      default: "12"
    },
    /**
     * Max-width of the dropdown list
     */
    width: {
      type: String,
      default: "300"
    },
    /**
     * Max-height of the dropdown list
     */
    height: {
      type: String,
      default: "300"
    },
    /**
     * Display a reset CTA on top of the dropdown list. Useful when using a VJoyMultiCheckbox.
     * Please note that is does not automatically apply changes to you models, it simply fires a **dropdown:reset** custom event
     * */
    reset: {
      type: Boolean,
      default: !1
    },
    /** Label of the reset CTA. Depends on reset property activation */
    resetLabel: {
      type: String
    }
  },
  emits: ["update:modelValue", "dropdown:open", "dropdown:hide", "dropdown:reset"],
  setup(e, { expose: t, emit: l }) {
    const o = l, n = e, r = C(!1), a = C(null), i = C(), s = C(null), d = C(null), p = C(!1), u = "joy-dropdown--" + Xe();
    Ze("VJoyDropdownContext", n);
    const f = {
      ignore: [i, ".joy-dropdown__list"]
    };
    let m = null;
    K(
      () => r.value,
      (k) => {
        k && Po(s);
      },
      { flush: "post" }
    );
    const y = V(() => {
      let k = `${n.dropdownGap}px`;
      return n.direction === "up" && (k = "-" + k), {
        marginTop: k
      };
    });
    function b() {
      m && clearTimeout(m), p.value = !0, m = setTimeout(() => {
        r.value = !1, p.value = !1, o("dropdown:hide");
      }, 300);
    }
    function h() {
      p.value = !1, m && clearTimeout(m), r.value = !0, o("dropdown:open");
    }
    function $(k) {
      k.stopPropagation(), r.value ? j() : h(), d.value = k.target;
    }
    function j() {
      b(), x();
    }
    function x() {
      d.value && d.value.focus();
    }
    function E(k) {
      o("update:modelValue", k), n.closeOnSelect && (b(), x());
    }
    function B() {
      o("dropdown:reset");
    }
    function P() {
      !i.value || !i.value.children.length || (i.value.children[0].id = u);
    }
    return sl(b), te(() => {
      P();
    }), t({
      showDropdownList: r,
      generatedId: u
    }), (k, N) => (c(), T(q(mt), {
      ref_key: "dropdown",
      ref: a,
      options: f,
      class: "joy-dropdown",
      onTrigger: b
    }, {
      default: z(() => [
        v("div", {
          ref_key: "button",
          ref: i,
          class: "joy-dropdown__button",
          "data-testid": "dropdown-trigger",
          onClick: $
        }, [
          w(k.$slots, "dropdown-button", {}, void 0, !0)
        ], 512),
        r.value ? (c(), g("div", {
          key: 0,
          ref_key: "list",
          ref: s,
          class: I([
            "joy-dropdown__list",
            `joy-dropdown__list--${e.justify}`,
            `joy-dropdown__list--${e.direction}`,
            {
              "joy-dropdown__list--visible": !p.value,
              "joy-dropdown__list--hiding": p.value
            }
          ]),
          style: ee(y.value)
        }, [
          O(Pl, {
            "model-value": e.modelValue,
            options: e.options,
            size: e.size,
            width: e.width,
            height: e.height,
            reset: e.reset,
            "reset-label": e.resetLabel,
            "aria-labelled-by": u,
            "onUpdate:modelValue": E,
            "onClose:dropdownList": j,
            onReset: B
          }, pt({
            label: z((S) => [
              w(k.$slots, "dropdown-item", Co(Vo(S)), () => [
                v("span", null, J(S.label), 1)
              ], !0)
            ]),
            _: 2
          }, [
            k.$slots["dropdown-header"] ? {
              name: "dropdown-list-header",
              fn: z(() => [
                w(k.$slots, "dropdown-header", {}, void 0, !0)
              ]),
              key: "0"
            } : void 0,
            k.$slots["dropdown-items"] ? {
              name: "dropdown-list-items",
              fn: z(() => [
                w(k.$slots, "dropdown-items", {}, void 0, !0)
              ]),
              key: "1"
            } : void 0,
            k.$slots["dropdown-footer"] ? {
              name: "dropdown-list-footer",
              fn: z(() => [
                w(k.$slots, "dropdown-footer", {}, void 0, !0)
              ]),
              key: "2"
            } : void 0
          ]), 1032, ["model-value", "options", "size", "width", "height", "reset", "reset-label"])
        ], 6)) : _("", !0)
      ]),
      _: 3
    }, 512));
  }
}), su = /* @__PURE__ */ A(Fl, [["__scopeId", "data-v-8d25933f"]]), Ol = { class: "joy-dropzone__icon-wrapper" }, Dl = /* @__PURE__ */ L({
  __name: "VJoyDropzoneIcon",
  props: {
    name: { type: String, required: !0 }
  },
  setup(e) {
    return (t, l) => (c(), g("div", Ol, [
      O(R, {
        "aria-hidden": "true",
        name: e.name,
        class: "joy-dropzone__icon"
      }, null, 8, ["name"])
    ]));
  }
}), Zt = /* @__PURE__ */ A(Dl, [["__scopeId", "data-v-5a2d1889"]]), Rl = { class: "joy-dropzone__file__description" }, Nl = { class: "joy-dropzone__file__name" }, ql = {
  key: 0,
  class: "joy-dropzone__file__information"
}, Hl = {
  key: 1,
  class: "joy-dropzone__file__error"
}, Wl = /* @__PURE__ */ L({
  __name: "VJoyDropzoneFileItem",
  props: {
    file: {},
    deleteLabel: {},
    updateLabel: {},
    error: {}
  },
  emits: ["delete", "update"],
  setup(e) {
    const t = G(), l = e;
    return (o, n) => (c(), T(re, {
      "column-gap": "6",
      "row-gap": "4",
      justify: "flex-start",
      wrap: "nowrap",
      align: "center",
      "no-margin": "",
      class: "joy-dropzone__file"
    }, {
      default: z(() => [
        O(Zt, {
          name: "file-check",
          class: "joy-dropzone__file__icon"
        }),
        v("div", Rl, [
          v("span", Nl, J(l.file.name), 1),
          t.information ? (c(), g("div", ql, [
            w(o.$slots, "information", { file: o.file }, void 0, !0)
          ])) : _("", !0),
          o.error ? (c(), g("p", Hl, J(o.error), 1)) : _("", !0)
        ]),
        O(re, {
          "column-gap": "1",
          wrap: "nowrap",
          "no-margin": "",
          class: "joy-dropzone__file__actions"
        }, {
          default: z(() => [
            w(o.$slots, "actions", { file: o.file }, void 0, !0),
            O(ne, {
              circle: "",
              size: "small",
              variant: "ghost",
              icon: "pen",
              title: o.updateLabel,
              "aria-label": o.updateLabel,
              onClick: n[0] || (n[0] = (r) => o.$emit("update"))
            }, null, 8, ["title", "aria-label"]),
            O(ne, {
              circle: "",
              size: "small",
              variant: "ghost",
              icon: "trash",
              title: o.deleteLabel,
              "aria-label": o.deleteLabel,
              onClick: n[1] || (n[1] = (r) => o.$emit("delete"))
            }, null, 8, ["title", "aria-label"])
          ]),
          _: 3
        })
      ]),
      _: 3
    }));
  }
}), Ul = /* @__PURE__ */ A(Wl, [["__scopeId", "data-v-f47da94a"]]), Gl = ["name", "accept", "multiple"], Yl = ["for"], Kl = {
  key: 0,
  class: "joy-dropzone__files"
}, Zl = { class: "joy-dropzone__instruction__text" }, Xl = {
  key: 0,
  class: "joy-dropzone__legend"
}, Ql = /* @__PURE__ */ L({
  __name: "VJoyDropzone",
  props: /* @__PURE__ */ To({
    name: {},
    multiple: { type: Boolean, default: !1 },
    accept: { default: () => [] },
    maxSize: { default: 32 },
    deleteLabel: { default: "Delete this file" },
    updateLabel: { default: "Update this file" },
    errorTextFormat: { default: "This format is not supported" },
    errorTextMaxSize: { default: (e) => `The file is over ${e.maxSize}MB. Upload a file smaller than ${e.maxSize}MB.` },
    errorTextFormatAndMaxSize: { default: (e) => `The file format isn't correct and is over ${e.maxSize}MB. Upload a file smaller than ${e.maxSize}MB.` }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e, { expose: t }) {
    const l = G(), o = e, n = xo(e, "modelValue"), r = C(y(n.value)), a = C(), i = C(), s = C(), { isOverDropZone: d } = Tn(i, {
      onDrop: x
    }), p = V(() => n.value.filter((S) => S instanceof File)), u = V(() => o.multiple || p.value.length === 0 ? void 0 : b(p.value[0]));
    function f(S) {
      return o.accept.length > 0 ? o.accept.includes(S.type) : !0;
    }
    function m(S) {
      return S.size < o.maxSize * 1024 * 1024;
    }
    function y(S) {
      return S.filter((F) => F instanceof File).some((F) => !f(F) || !m(F));
    }
    function b(S) {
      if (!(S instanceof File))
        return;
      const M = f(S), F = m(S);
      if (!M && !F)
        return o.errorTextFormatAndMaxSize;
      if (!M)
        return o.errorTextFormat;
      if (!F)
        return o.errorTextMaxSize;
    }
    function h() {
      a.value = void 0, s.value && s.value.click();
    }
    function $() {
      s.value && (s.value.value = "");
    }
    function j(S) {
      var F;
      const M = (F = S.target) == null ? void 0 : F.files;
      !M || M.length === 0 || (a.value ? (N(a.value, Array.from(M)), a.value = void 0) : k(Array.from(M)));
    }
    function x(S) {
      !S || S.length === 0 || (a.value = void 0, k(S));
    }
    function E(S) {
      a.value = S, s.value && s.value.click();
    }
    function B(S) {
      r.value = y(S), n.value = S;
    }
    function P(S) {
      B(n.value.filter((M) => M !== S));
    }
    function k(S) {
      o.multiple ? B([...n.value, ...S]) : B([S[0]]);
    }
    function N(S, [M, ...F]) {
      if (o.multiple) {
        const Y = [...n.value];
        Y[n.value.indexOf(S)] = M, Y.push(...F), B(Y);
      } else
        B([M]);
    }
    return t({
      invalid: r
    }), (S, M) => (c(), g("div", {
      class: I(["joy-dropzone", {
        "joy-dropzone--dragover": q(d),
        "joy-dropzone--invalid": r.value,
        "joy-dropzone--empty": n.value.length === 0
      }])
    }, [
      v("div", {
        ref_key: "dropzoneAreaRef",
        ref: i,
        class: "joy-dropzone__area"
      }, [
        v("input", {
          ref_key: "inputRef",
          ref: s,
          name: S.name,
          type: "file",
          accept: S.accept.join(","),
          multiple: S.multiple,
          tabindex: "-1",
          onChange: j,
          onClick: $
        }, null, 40, Gl),
        v("label", {
          for: S.name,
          class: "joy-dropzone__label"
        }, [
          n.value.length > 0 ? (c(), g("div", Kl, [
            (c(!0), g(W, null, U(n.value, (F, Y) => (c(), T(Ul, {
              key: `${F.name}_${Y}`,
              file: F,
              error: S.multiple ? b(F) : void 0,
              "update-label": S.updateLabel,
              "delete-label": S.deleteLabel,
              onUpdate: (se) => E(F),
              onDelete: (se) => P(F)
            }, pt({ _: 2 }, [
              l["file-information"] ? {
                name: "information",
                fn: z(() => [
                  w(S.$slots, "file-information", { file: F }, void 0, !0)
                ]),
                key: "0"
              } : void 0,
              l["file-actions"] ? {
                name: "actions",
                fn: z(() => [
                  w(S.$slots, "file-actions", { file: F }, void 0, !0)
                ]),
                key: "1"
              } : void 0
            ]), 1032, ["file", "error", "update-label", "delete-label", "onUpdate", "onDelete"]))), 128))
          ])) : _("", !0),
          n.value.length === 0 || S.multiple ? (c(), T(re, {
            key: 1,
            wrap: "nowrap",
            "no-margin": "",
            class: "joy-dropzone__instruction",
            onClick: h
          }, {
            default: z(() => [
              O(Zt, {
                name: "add",
                class: "joy-dropzone__instruction__icon"
              }),
              v("p", Zl, [
                w(S.$slots, "dropzone-description", {}, () => [
                  M[0] || (M[0] = D("Drop your file here or click here"))
                ], !0)
              ])
            ]),
            _: 3
          })) : _("", !0)
        ], 8, Yl)
      ], 512),
      l["dropzone-legend"] ? (c(), g("div", Xl, [
        w(S.$slots, "dropzone-legend", {}, void 0, !0)
      ])) : _("", !0),
      u.value ? (c(), T(tt, {
        key: 1,
        "no-html-error-text": u.value,
        class: "joy-dropzone__error"
      }, null, 8, ["no-html-error-text"])) : _("", !0)
    ], 2));
  }
}), uu = /* @__PURE__ */ A(Ql, [["__scopeId", "data-v-bf95ba80"]]), ea = ["aria-label"], ta = { class: "joy-filter-bar__wrapper" }, oa = /* @__PURE__ */ L({
  __name: "VJoyFilterBar",
  props: {
    /** To give a label to the whole component */
    ariaLabel: String
  },
  setup(e) {
    return (t, l) => (c(), g("div", {
      class: "joy-filter-bar",
      role: "group",
      "aria-label": e.ariaLabel || "Filter bar"
    }, [
      v("div", ta, [
        w(t.$slots, "default", {}, void 0, !0)
      ])
    ], 8, ea));
  }
}), du = /* @__PURE__ */ A(oa, [["__scopeId", "data-v-cb769d05"]]), na = /* @__PURE__ */ L({
  __name: "VJoyFilterBarButton",
  props: {
    /** Label to inject inside the  button */
    label: String,
    /** Required when used in the `VJoyFilterBar` to properly handle v-model */
    value: {
      type: String,
      required: !0
    },
    active: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["filter"],
  setup(e, { emit: t }) {
    const l = e, o = t, n = Ce("VJoyDropdownContext", null);
    function r() {
      o("filter", l.value);
    }
    return (a, i) => (c(), g("button", {
      type: "button",
      "data-joy-form-field": "",
      class: I(["joy-filter-bar-button", { "joy-filter-bar-button--active": e.active }]),
      onClick: r
    }, [
      D(J(e.label) + " ", 1),
      w(a.$slots, "default", {}, void 0, !0),
      q(n) ? (c(), T(R, {
        key: 0,
        class: "joy-filter-bar-button__icon",
        name: "chevron-down",
        size: "xxsmall",
        color: "neutral"
      })) : _("", !0)
    ], 2));
  }
}), cu = /* @__PURE__ */ A(na, [["__scopeId", "data-v-fcd9cacd"]]), la = /* @__PURE__ */ L({
  __name: "VJoyFormFieldSkeleton",
  props: {
    /** In some cases you'll need to inject the error in the DOM but hide it. Visible by default */
    size: {
      type: String,
      default: "medium"
    },
    width: {
      type: String
    },
    /** The component is aimed to be used with a VJoyWrapper to quickly create skeleton layouts.
     * Use flex property to spread your items horizontally, by default they will all have the same width.
     */
    flex: {
      type: String,
      default: "1"
    }
  },
  setup(e, { expose: t }) {
    const l = e, o = Ce("VJoyWrapperContext", {}), n = V(() => {
      const r = o.direction === "column" ? "auto" : null;
      if (!l.width && l.flex === "1") {
        const s = ["1", "0"];
        return r && s.push(r), s.join(" ");
      }
      const a = [l.flex || "1", "0"], i = l.width || r;
      return i && a.push(i), a.join(" ");
    });
    return t({ flexStyle: n }), (r, a) => (c(), g("div", {
      "aria-hidden": "true",
      class: I(["joy-form-skeleton", `joy-form-skeleton--${e.size}`]),
      style: ee({
        "max-width": e.width,
        flex: n.value
      })
    }, null, 6));
  }
}), fu = /* @__PURE__ */ A(la, [["__scopeId", "data-v-3004f370"]]), aa = { class: "joy-funnel__header" }, ra = { class: "funnel__header__inner" }, ia = /* @__PURE__ */ L({
  __name: "VJoyFunnel",
  props: {
    /**
     * Remove decorative shapes placed at the bottom right corner
     */
    hideShapes: {
      type: Boolean,
      default: !1
    },
    layoutWidth: {
      type: String,
      default: "large"
    },
    profile: {
      type: String,
      default: "default"
    }
  },
  setup(e, { expose: t }) {
    const l = C(!0), o = G(), n = C(!0);
    Ze("VJoyStepperShowLabels", n);
    function r(s) {
      const d = s.currentTarget;
      l.value = d.scrollTop === 0, a.value && !l.value ? n.value = !1 : a.value && l.value && (n.value = !0);
    }
    const a = V(() => !!o["funnel-stepper"]), i = V(() => o["funnel-footer"] ? o["funnel-footer"]().length > 0 : !1);
    return t({
      scrollOnTop: l,
      hasStepperSlot: a,
      hasFooterSlot: i
    }), (s, d) => (c(), g("div", {
      class: I([
        "joy-funnel",
        {
          "joy-funnel--no-stepper": !a.value
        }
      ])
    }, [
      v("div", aa, [
        v("div", ra, [
          w(s.$slots, "funnel-header", {}, void 0, !0)
        ])
      ]),
      e.hideShapes ? _("", !0) : (c(), g("div", {
        key: 0,
        class: I([
          "joy-funnel__shapes",
          {
            "joy-funnel__shapes--strategy": e.profile === "strategy",
            "joy-funnel__shapes--no-footer": !i.value
          }
        ])
      }, d[0] || (d[0] = [
        Dt('<div class="shapes__wrapper" data-v-e2fccb79><div class="shape_1" data-v-e2fccb79></div><div class="shape_2" data-v-e2fccb79></div><div class="shape_3" data-v-e2fccb79></div><div class="shape_4" data-v-e2fccb79></div></div>', 1)
      ]), 2)),
      v("div", {
        class: I(["joy-funnel__stepper", { "joy-funnel__stepper--medium": e.layoutWidth === "medium" }])
      }, [
        w(s.$slots, "funnel-stepper", {}, void 0, !0)
      ], 2),
      v("div", {
        class: "joy-funnel__scrollable",
        onScroll: r
      }, [
        v("div", {
          class: I(["joy-funnel__content", { "joy-funnel__content--medium": e.layoutWidth === "medium" }])
        }, [
          w(s.$slots, "default", {}, void 0, !0)
        ], 2)
      ], 32)
    ], 2));
  }
}), pu = /* @__PURE__ */ A(ia, [["__scopeId", "data-v-e2fccb79"]]), sa = { class: "joy-funnel-footer" }, ua = { class: "joy-funnel-footer__left" }, da = { class: "joy-funnel-footer__right" }, ca = /* @__PURE__ */ L({
  __name: "VJoyFunnelFooter",
  setup(e) {
    return (t, l) => (c(), g("footer", sa, [
      v("div", ua, [
        w(t.$slots, "footer-left", {}, void 0, !0)
      ]),
      v("div", da, [
        w(t.$slots, "footer-right", {}, void 0, !0)
      ])
    ]));
  }
}), yu = /* @__PURE__ */ A(ca, [["__scopeId", "data-v-bdeeb2bd"]]), fa = { class: "joy-funnel-header" }, pa = { class: "joy-funnel-header__left" }, ya = { class: "joy-funnel-header__right" }, ma = /* @__PURE__ */ L({
  __name: "VJoyFunnelHeader",
  setup(e) {
    return (t, l) => (c(), g("header", fa, [
      v("div", pa, [
        w(t.$slots, "funnel-header-left", {}, void 0, !0)
      ]),
      v("div", ya, [
        w(t.$slots, "funnel-header-right", {}, void 0, !0)
      ])
    ]));
  }
}), mu = /* @__PURE__ */ A(ma, [["__scopeId", "data-v-d9804793"]]), va = { class: "joy-highlight__decorator" }, ha = { class: "joy-highlight__text" }, ga = { key: 0 }, ba = /* @__PURE__ */ L({
  __name: "VJoyHighlight",
  props: {
    accent: {
      type: Boolean,
      default: !1
    },
    displayIcon: {
      type: Boolean,
      default: !1
    },
    /** Based on maltjoy/icons availabilities. Works in pair with displayIcon boolean prop. */
    icon: {
      type: String
    },
    /** import `TJoyHighlightLevels` */
    level: {
      type: String,
      default: "neutral"
    },
    /** Please note that 'default' variant has no effect. This property is meant to completely override "level" prop style */
    variant: {
      type: String,
      default: "default"
    }
  },
  setup(e, { expose: t }) {
    const l = e, o = V(() => l.icon ? l.icon : Nt(l.level));
    return t({
      getRelevantIcon: o
    }), (n, r) => (c(), g("div", {
      class: I([
        "joy-highlight",
        `joy-highlight_${e.level}`,
        `joy-highlight_${e.variant}`,
        {
          "joy-highlight__accent": e.accent,
          "joy-highlight__titled": n.$slots["highlight-title"]
        }
      ])
    }, [
      v("div", va, [
        w(n.$slots, "highlight-decorator", {}, () => [
          e.displayIcon ? (c(), T(R, {
            key: 0,
            name: o.value
          }, null, 8, ["name"])) : _("", !0)
        ], !0)
      ]),
      v("div", ha, [
        n.$slots["highlight-title"] ? (c(), g("strong", ga, [
          w(n.$slots, "highlight-title", {}, void 0, !0)
        ])) : _("", !0),
        w(n.$slots, "default", {}, void 0, !0)
      ])
    ], 2));
  }
}), vu = /* @__PURE__ */ A(ba, [["__scopeId", "data-v-e5c2ff23"]]), wa = ["aria-label"], _a = /* @__PURE__ */ L({
  __name: "VJoyIndicator",
  props: {
    /** Value is used for the parent v-model. Mandatory */
    value: {
      type: [String, Number],
      required: !0
    },
    /** Automatically handled by parent. No need to set it manually */
    selected: {
      type: Boolean,
      default: !1
    },
    variant: {
      type: String,
      default: "default"
    },
    /** Indicators are text-less buttons by design. To make them more accessible, you can pass them an aria-label that will describe more their action. */
    ariaLabel: {
      type: String
    }
  },
  setup(e) {
    return (t, l) => (c(), g("li", {
      class: I(["joy-indicator", `joy-indicator--${e.variant}`, { "joy-indicator--selected": e.selected }])
    }, [
      v("button", {
        type: "button",
        class: I(["joy-indicator--button", { "joy-indicator--button-selected": e.selected }]),
        "aria-label": e.ariaLabel || e.value.toString()
      }, null, 10, wa)
    ], 2));
  }
}), ja = /* @__PURE__ */ A(_a, [["__scopeId", "data-v-88a82b4f"]]), ka = /* @__PURE__ */ L({
  __name: "VJoyIndicators",
  props: {
    variant: {
      type: String
    },
    /** Use the component with a v-model to easily handle selected items */
    modelValue: {
      type: [String, Number]
    }
  },
  emits: ["update:modelValue"],
  setup(e, { expose: t, emit: l }) {
    const o = e, n = l, r = G(), a = C(o.modelValue), i = V(() => {
      const u = r.default();
      return u.length === 1 && typeof u[0].type != "object" ? u[0].children.filter(d) : u.filter(d);
    });
    function s(u) {
      return a.value === u.props.value;
    }
    function d(u) {
      var f;
      return ((f = u == null ? void 0 : u.type) == null ? void 0 : f.__name) === "VJoyIndicator";
    }
    function p(u) {
      n("update:modelValue", u.props.value), a.value = u.props.value;
    }
    return K(
      () => o.modelValue,
      (u, f) => {
        u !== f && (a.value = u);
      }
    ), t({
      indicators: i,
      isSelected: s
    }), (u, f) => (c(), g("ul", {
      class: I(["joy-indicators", `joy-indicators--${e.variant}`])
    }, [
      (c(!0), g(W, null, U(i.value, (m) => (c(), T(ja, H({
        key: m.props.value,
        ref_for: !0
      }, { ...m.props, variant: e.variant }, {
        selected: s(m),
        onClick: (y) => p(m)
      }), null, 16, ["selected", "onClick"]))), 128))
    ], 2));
  }
}), hu = /* @__PURE__ */ A(ka, [["__scopeId", "data-v-f2dd63e9"]]), $a = ["id", "name", "required", "disabled", "readonly", "type", "value"], Sa = ["data-unit"], Ca = /* @__PURE__ */ L({
  inheritAttrs: !1,
  __name: "VJoyInput",
  props: {
    autofocus: {
      type: Boolean,
      default: !1
    },
    modelValue: {
      type: [String, Number]
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    id: {
      type: String
    },
    invalid: {
      type: Boolean,
      default: !1
    },
    name: {
      type: String,
      required: !0
    },
    required: {
      type: Boolean,
      default: !1
    },
    /** Display a label on top of the element. */
    label: String,
    /** Overrides the default label size. See JoyLabel stories */
    labelSize: {
      type: String,
      default: "medium"
    },
    /** If your component is not required, we can add a label to explicitely tell that it's not mandatory */
    optionalLabel: String,
    /** Depending on context, we can add a "*" after the label to specify it's mandatory. */
    requiredMark: {
      type: Boolean,
      default: !1
    },
    modelModifiers: {
      type: Object,
      default: () => ({
        lazy: !1
      })
    },
    /** Display a cross icon on the right that enables to clear the field */
    clearable: {
      type: Boolean,
      default: !1
    },
    /** Add a JoyIcon / joy-icon with given name on left-side. */
    icon: {
      type: String
    },
    size: {
      type: String,
      default: "medium"
    },
    type: {
      type: String,
      default: "text"
    },
    /** Adds a legend like symbol on the right of the component. Made for number based values */
    unit: String,
    /** Activates the readonly mode for the input */
    readonly: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  setup(e, { expose: t, emit: l }) {
    const o = l, n = e, r = Ce("VJoyWrapperContext", {}), a = C(), i = C(), s = be(), d = G(), p = C(!1), u = C(!1);
    vt(a, n.autofocus);
    const f = V(() => typeof n.modelValue == "number" || !n.clearable || n.unit || !n.modelValue ? !1 : n.modelValue.length > 0 && !n.unit), m = V(() => d.default && d.default()), y = V(() => Object.keys(r).length > 0), b = C(n.type), h = V(() => n.type === "password" && !!n.modelValue);
    Io(() => {
      b.value = n.unit ? "number" : n.type;
    });
    function $() {
      var x;
      n.readonly || (x = a.value) == null || x.focus();
    }
    const j = {
      onFocus: () => {
        n.readonly || (p.value = !0);
      },
      onBlur: () => {
        p.value = !1;
      },
      onWheelScroll(x) {
        n.type === "number" && x.preventDefault();
      },
      onInput: (x) => {
        let E = x.target.value;
        n.modelModifiers.lazy || o("update:modelValue", E);
      },
      onChange: (x) => {
        let E = x.target.value;
        n.modelModifiers.lazy && o("update:modelValue", E);
      },
      clearValue: () => {
        n.disabled || o("update:modelValue", "");
      },
      togglePassword: (x) => {
        x.preventDefault(), u.value = !u.value, u.value ? b.value = "text" : b.value = "password";
      }
    };
    return t({
      focus: $
    }), (x, E) => (c(), g("div", {
      ref_key: "root",
      ref: i,
      class: I([`joy-input--${n.size}`])
    }, [
      v("div", {
        class: I([
          "joy-input",
          {
            "joy-input--focusing": p.value,
            "joy-input--disabled": e.disabled,
            "joy-input--invalid": e.invalid,
            "joy-input--readonly": e.readonly,
            "joy-input--valid": !e.invalid && !q(s).disabled
          }
        ])
      }, [
        m.value || e.label ? (c(), T(Ve, {
          key: 0,
          for: e.id || e.name,
          required: e.required && e.requiredMark,
          "optional-label": e.optionalLabel,
          size: e.labelSize
        }, {
          default: z(() => [
            w(x.$slots, "default", {}, () => [
              D(J(e.label), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["for", "required", "optional-label", "size"])) : _("", !0),
        v("div", {
          class: I([
            "joy-input--wrapper",
            {
              "joy-input--wrapper-has-icon": !!e.icon,
              "joy-input--wrapper---clearable": e.clearable,
              "joy-input--wrapper-unit": !!e.unit,
              "joy-input--wrapper-margin": !y.value
            }
          ])
        }, [
          v("input", H(x.$attrs, {
            id: e.id || e.name,
            ref_key: "input",
            ref: a,
            "data-joy-form-field": "",
            name: e.name,
            required: e.required,
            disabled: e.disabled,
            readonly: e.readonly,
            class: [
              {
                "joy-input--field-disabled": e.disabled,
                "joy-input--field-invalid": e.invalid
              }
            ],
            type: b.value,
            value: e.modelValue,
            onFocus: E[0] || (E[0] = //@ts-ignore
            (...B) => j.onFocus && j.onFocus(...B)),
            onBlur: E[1] || (E[1] = //@ts-ignore
            (...B) => j.onBlur && j.onBlur(...B)),
            onInput: E[2] || (E[2] = //@ts-ignore
            (...B) => j.onInput && j.onInput(...B)),
            onChange: E[3] || (E[3] = //@ts-ignore
            (...B) => j.onChange && j.onChange(...B)),
            onWheel: E[4] || (E[4] = //@ts-ignore
            (...B) => j.onWheelScroll && j.onWheelScroll(...B))
          }), null, 16, $a),
          f.value ? (c(), T(ne, {
            key: 0,
            class: "joy-input--clear",
            circle: "",
            variant: "ghost",
            size: "xxsmall",
            icon: "cross",
            onClick: j.clearValue
          }, null, 8, ["onClick"])) : _("", !0),
          h.value ? (c(), T(R, {
            key: 1,
            class: "joy-input--password-icon",
            name: u.value ? "eye-masked" : "eye",
            onClick: j.togglePassword
          }, null, 8, ["name", "onClick"])) : _("", !0),
          e.icon ? (c(), T(R, {
            key: 2,
            class: "joy-input--decorative-icon",
            name: e.icon
          }, null, 8, ["name"])) : _("", !0),
          e.unit ? (c(), g("div", {
            key: 3,
            "data-unit": e.unit,
            class: "joy-input--unit"
          }, null, 8, Sa)) : _("", !0)
        ], 2)
      ], 2)
    ], 2));
  }
}), gu = /* @__PURE__ */ A(Ca, [["__scopeId", "data-v-aff0578c"]]), Va = { class: "joy-link__text" }, Ta = /* @__PURE__ */ L({
  __name: "VJoyLink",
  props: {
    href: {
      type: String
    },
    color: {
      type: String,
      default: "teal"
    },
    icon: String,
    text: String,
    type: {
      type: String
    }
  },
  setup(e) {
    return (t, l) => (c(), T(Z(e.href ? "a" : "button"), H({ href: e.href }, t.$attrs, {
      class: ["joy-link", `joy-link_${e.color}`],
      type: e.type
    }), {
      default: z(() => [
        e.icon ? (c(), T(R, {
          key: 0,
          name: e.icon
        }, null, 8, ["name"])) : _("", !0),
        v("span", Va, [
          w(t.$slots, "default", {}, () => [
            D(J(e.text), 1)
          ], !0)
        ])
      ]),
      _: 3
    }, 16, ["href", "class", "type"]));
  }
}), bu = /* @__PURE__ */ A(Ta, [["__scopeId", "data-v-19a65db4"]]), xa = { class: "joy-list-item__left" }, Ia = { class: "joy-font-primary-300 joy-m-0" }, La = { class: "joy-list-item__right" }, Ba = /* @__PURE__ */ L({
  __name: "VJoyListItem",
  props: {
    icon: {}
  },
  emits: ["click"],
  setup(e) {
    return (t, l) => (c(), g("div", {
      class: "joy-list-item joy-core-radius-3 joy-pt-2 joy-pl-3 joy-pr-3 joy-pb-2 joy-color-neutral-60",
      onClick: l[0] || (l[0] = (o) => t.$emit("click"))
    }, [
      O(re, {
        "no-margin": "",
        "row-gap": "2",
        wrap: "nowrap",
        justify: "space-between"
      }, {
        default: z(() => [
          v("div", xa, [
            t.icon ? (c(), T(R, {
              key: 0,
              class: "joy-p-3 joy-list-item__left-icon",
              name: t.icon
            }, null, 8, ["name"])) : _("", !0),
            v("p", Ia, [
              w(t.$slots, "list-item-left", {}, void 0, !0)
            ])
          ]),
          v("div", La, [
            w(t.$slots, "list-item-right", {}, void 0, !0)
          ])
        ]),
        _: 3
      })
    ]));
  }
}), wu = /* @__PURE__ */ A(Ba, [["__scopeId", "data-v-6c3750f0"]]), Aa = ["aria-activedescendant", "aria-label"], Ea = ["aria-disabled", "aria-current", "title", "aria-label", ".dataModel", "onClick"], za = { "aria-hidden": "true" }, Ja = /* @__PURE__ */ L({
  __name: "VJoyMenu",
  props: {
    /**
     * DEPRECATED: In order to make it work with v-model, you need to pass for each option, a value or an ID.
     */
    items: {
      type: Array,
      default() {
        return [];
      }
    },
    modelValue: {
      type: String
    },
    ariaLabel: {
      type: String
    }
  },
  emits: ["selectItem"],
  setup(e, { expose: t, emit: l }) {
    const o = l, n = C();
    C(0);
    const r = C();
    function a(u) {
      u.disabled || o("selectItem", u);
    }
    function i() {
      var u;
      return Array.from(((u = n.value) == null ? void 0 : u.querySelectorAll("li")) || []).filter((f) => f.getAttribute("aria-disabled") !== "true");
    }
    function s(u) {
      return u.id || Xe();
    }
    function d() {
      return i().find((u) => u === document.activeElement);
    }
    function p(u) {
      if (d() && u.key === " " && u.preventDefault(), u.key === "Tab" && (r.value = void 0), ["ArrowDown", "ArrowUp", "Home", "End"].includes(u.key)) {
        u.preventDefault();
        const f = i(), m = d();
        let y = f.indexOf(m);
        if (u.key === "ArrowDown" ? y++ : u.key === "ArrowUp" ? y-- : u.key === "Home" ? y = 0 : u.key === "End" && (y = f.length - 1), y < 0 && (y = 0), y > f.length - 1)
          return;
        r.value = f[y].id, f[y].focus();
      }
      if (u.key === "Enter") {
        const f = d();
        if (!f)
          return;
        const m = f.querySelector("a");
        f && m ? m.click() : f.click();
      }
    }
    return t({
      activeMenuItemId: r,
      getItems: i,
      getItemId: s,
      getFocusedItem: d
    }), (u, f) => {
      const m = ct("bind-once");
      return c(), g("ul", {
        ref_key: "menu",
        ref: n,
        class: "joy-menu-list joy-menu-list__items",
        "aria-activedescendant": r.value,
        "aria-label": e.ariaLabel,
        role: "menu",
        onKeydown: p
      }, [
        w(u.$slots, "default", {}, void 0, !0),
        (c(!0), g(W, null, U(e.items, (y) => Ke((c(), g("li", {
          key: y.label,
          class: I([
            "joy-menu-list__item",
            {
              "joy-menu-list__item--current": y.current,
              "joy-menu-list__item--disabled": y.disabled
            }
          ]),
          tabindex: "-1",
          "aria-disabled": y.disabled,
          "aria-current": y.current,
          title: y.label,
          "aria-label": y.label,
          ".dataModel": y.value || y.id,
          role: "menuitem",
          onClick: (b) => a(y)
        }, [
          v("div", za, [
            w(u.$slots, "menu-item", H({ ref_for: !0 }, y), () => [
              y.icon ? (c(), T(R, {
                key: 0,
                name: y.icon
              }, null, 8, ["name"])) : _("", !0),
              v("span", null, J(y.label), 1)
            ], !0)
          ])
        ], 42, Ea)), [
          [m, { id: s(y) }]
        ])), 128))
      ], 40, Aa);
    };
  }
}), _u = /* @__PURE__ */ A(Ja, [["__scopeId", "data-v-b76ae1e8"]]), Ma = ["aria-disabled", "aria-current", "title", "aria-label"], Pa = { class: "joy-menu-item__label joy-font-primary-400" }, Fa = /* @__PURE__ */ L({
  inheritAttrs: !1,
  __name: "VJoyMenuItem",
  props: {
    label: {},
    href: {},
    icon: {},
    current: { type: Boolean },
    disabled: { type: Boolean },
    status: {},
    statusColor: {},
    type: { default: "a" },
    linkProps: {}
  },
  emits: ["click"],
  setup(e, { expose: t, emit: l }) {
    const o = l, n = be(), r = e, a = V(() => r.type !== "a" && r.type !== "button" ? r.linkProps : { ...n, href: r.href });
    function i() {
      r.disabled || o("click");
    }
    return t({
      getProps: a
    }), (s, d) => (c(), g("li", {
      class: I(["joy-menu-item"]),
      "aria-disabled": s.disabled,
      "aria-current": s.current,
      title: s.label,
      "aria-label": s.label,
      role: "menuitem"
    }, [
      (c(), T(Z(s.disabled ? "div" : s.type), H({ ...a.value, ...s.$attrs }, {
        class: [
          "joy-menu-item__inner",
          {
            "joy-menu-item__inner--current": s.current,
            "joy-menu-item__inner--disabled": s.disabled
          }
        ],
        type: s.type === "button" ? "button" : null,
        onClick: i
      }), {
        default: z(() => [
          s.icon ? (c(), T(R, {
            key: 0,
            class: "joy-menu-item__icon-left",
            name: s.icon
          }, null, 8, ["name"])) : _("", !0),
          v("span", Pa, J(s.label), 1),
          s.status ? (c(), T(R, {
            key: 1,
            class: "joy-menu-item__icon-right",
            name: s.status,
            color: s.statusColor
          }, null, 8, ["name", "color"])) : _("", !0)
        ]),
        _: 1
      }, 16, ["class", "type"]))
    ], 8, Ma));
  }
}), ju = /* @__PURE__ */ A(Fa, [["__scopeId", "data-v-283b560c"]]), Oa = ["id"], Da = {
  class: /* @__PURE__ */ I(["joy-multi-checkbox"])
}, Ra = /* @__PURE__ */ L({
  __name: "VJoyMultiCheckbox",
  props: {
    options: {},
    id: {},
    value: { default: () => [] },
    required: { type: Boolean, default: !1 },
    label: {},
    labelSize: { default: "medium" },
    optionalLabel: {},
    requiredMark: { type: Boolean, default: !1 }
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const l = t, o = e;
    function n(a) {
      return o.value.includes(a.value);
    }
    function r(a, i) {
      let s = [...o.value || []];
      i ? s.push(a) : s.splice(s.indexOf(a), 1), l("update:value", s);
    }
    return (a, i) => (c(), g("fieldset", {
      id: a.id,
      class: "joy-multi-checkbox__wrapper"
    }, [
      a.label ? (c(), T(Ve, {
        key: 0,
        "tag-name": "legend",
        required: a.required && a.requiredMark,
        "optional-label": a.optionalLabel,
        size: a.labelSize
      }, {
        default: z(() => [
          D(J(a.label), 1)
        ]),
        _: 1
      }, 8, ["required", "optional-label", "size"])) : _("", !0),
      v("div", Da, [
        (c(!0), g(W, null, U(a.options, (s) => (c(), T(Kt, {
          id: s.id,
          key: s.id,
          name: s.name,
          value: s.value,
          checked: n(s),
          "onUpdate:checked": (d) => r(s.value, d)
        }, {
          default: z(() => [
            w(a.$slots, "checkbox", H({ ref_for: !0 }, s), () => [
              D(J(s.label), 1)
            ], !0)
          ]),
          _: 2
        }, 1032, ["id", "name", "value", "checked", "onUpdate:checked"]))), 128))
      ])
    ], 8, Oa));
  }
}), ku = /* @__PURE__ */ A(Ra, [["__scopeId", "data-v-c82c5828"]]), It = /* @__PURE__ */ L({
  __name: "PaginationIcon",
  props: {
    label: {
      type: String,
      required: !1
    },
    next: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["click"],
  setup(e) {
    return (t, l) => (c(), T(ne, {
      class: "joy-pagination__icon",
      label: e.label,
      title: e.label,
      color: "grey",
      icon: e.next ? "chevron-right" : "chevron-left",
      variant: "ghost",
      circle: "",
      size: "xsmall",
      disabled: e.disabled,
      onClick: l[0] || (l[0] = (o) => t.$emit("click"))
    }, null, 8, ["label", "title", "icon", "disabled"]));
  }
}), Na = ["aria-label", "data-current"], qa = ["onClick"], Ha = ["aria-current"], Wa = 6, Ua = /* @__PURE__ */ L({
  __name: "VJoyPagination",
  props: {
    /** Current page number */
    currentPage: {
      type: Number,
      default: 1
    },
    /** Total number of pages in order to construct the pagination */
    totalPages: {
      type: Number,
      default: 1
    },
    /** Can be used as aria-label attribute for the full component */
    labelPagination: {
      type: String,
      required: !1
    },
    /** Can be used as title and aria-label attributes for the previous CTA */
    labelPrev: {
      type: String,
      required: !1
    },
    /** Can be used as title and aria-label attributes for the next CTA */
    labelNext: {
      type: String,
      required: !1
    }
  },
  emits: ["update:current-page"],
  setup(e, { emit: t }) {
    const l = e, o = t, n = V(() => {
      const p = a.value.length;
      return a.value[p - 1] !== a.value[p - 2] + 1;
    }), r = V(() => a.value[0] !== a.value[1] - 1), a = V(() => l.totalPages === 1 ? [1] : l.totalPages < Wa ? s(2, l.totalPages - 1) : d(l.currentPage));
    function i(p, u) {
      l.currentPage === 1 && u === "prev" || l.currentPage === l.totalPages && u === "next" || o("update:current-page", p);
    }
    function s(p, u) {
      const f = [];
      f.push(1);
      for (let m = p; m <= u; m++)
        f.push(m);
      return f.push(l.totalPages), f;
    }
    function d(p) {
      let u = p - 2, f = p + 1;
      return u <= 1 && (u = 2, f = 5), f >= l.totalPages && (f = l.totalPages - 1, u = f - 3), s(u, f);
    }
    return (p, u) => (c(), g("nav", {
      role: "navigation",
      "aria-label": e.labelPagination,
      class: "joy-pagination",
      "data-current": e.currentPage
    }, [
      v("ul", null, [
        v("li", {
          class: "joy-pagination__item joy-pagination__previous",
          onClick: u[0] || (u[0] = (f) => i(e.currentPage - 1, "prev"))
        }, [
          w(p.$slots, "pagination-prev", {}, () => [
            O(It, {
              label: e.labelPrev,
              disabled: e.currentPage === 1
            }, null, 8, ["label", "disabled"])
          ], !0)
        ]),
        v("li", null, [
          v("ul", null, [
            (c(!0), g(W, null, U(a.value, (f) => (c(), g("li", {
              key: f,
              class: I({
                "joy-pagination__item": !0,
                "joy-pagination__page": !0,
                current: f === e.currentPage,
                "joy-pagination__separator joy-pagination__separator-after": e.totalPages > 1 && f === 1 && r.value,
                "joy-pagination__separator joy-pagination__separator-before": e.totalPages > 1 && f === e.totalPages && n.value
              }),
              onClick: (m) => i(f)
            }, [
              w(p.$slots, "page", H({ ref_for: !0 }, { page: f }), () => [
                v("button", {
                  type: "button",
                  "aria-current": f === e.currentPage ? "true" : "false"
                }, J(f), 9, Ha)
              ], !0)
            ], 10, qa))), 128))
          ])
        ]),
        v("li", {
          class: "joy-pagination__next",
          onClick: u[1] || (u[1] = (f) => i(e.currentPage + 1, "next"))
        }, [
          w(p.$slots, "pagination-next", {}, () => [
            O(It, {
              next: "",
              label: e.labelNext,
              disabled: e.currentPage === e.totalPages
            }, null, 8, ["label", "disabled"])
          ], !0)
        ])
      ])
    ], 8, Na));
  }
}), $u = /* @__PURE__ */ A(Ua, [["__scopeId", "data-v-7e82041f"]]), Ga = { class: "joy-screen-loader__content" }, Ya = {
  key: 0,
  class: "joy-screen-loader__content"
}, Ka = /* @__PURE__ */ L({
  __name: "VJoyScreenLoader",
  props: {
    /** Light or dark. Changes the spinner and background color */
    color: {
      type: String,
      default: "light"
    },
    /** The overlay mode set the component in an absolute position, and covers all the parent's area. */
    overlay: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (t, l) => (c(), g("div", {
      class: I(["joy-screen-loader", `joy-screen-loader--${e.color}`, { "joy-screen-loader--overlay": e.overlay }])
    }, [
      v("div", Ga, [
        w(t.$slots, "spinner", {}, () => [
          O(Ut, {
            color: e.color === "dark" ? "white" : "teal"
          }, null, 8, ["color"])
        ], !0),
        t.$slots.content ? (c(), g("div", Ya, [
          w(t.$slots, "content", {}, void 0, !0)
        ])) : _("", !0)
      ])
    ], 2));
  }
}), Xt = /* @__PURE__ */ A(Ka, [["__scopeId", "data-v-266b7e2a"]]), Za = {
  key: 0,
  class: /* @__PURE__ */ I(["joy-panel__header"])
}, Xa = {
  key: 1,
  class: "joy-panel__header-action"
}, Qa = {
  key: 2,
  class: "joy-panel__header-subtitle"
}, er = { class: "joy-panel__body" }, tr = {
  key: 1,
  class: "joy-panel__footer"
}, or = /* @__PURE__ */ L({
  __name: "VJoyPanel",
  props: {
    flex: {
      type: String
    },
    noMargin: {
      type: Boolean,
      default: !1
    },
    padding: {
      type: String,
      default: "medium"
    },
    titleSize: {
      type: String,
      default: "large"
    },
    loading: {
      type: Boolean,
      default: !1
    },
    loadingColor: {
      type: String,
      default: "light"
    },
    variant: {
      type: String,
      default: "default"
    }
  },
  setup(e) {
    const t = Ce("VJoyWrapperContext", {}), l = V(() => Object.keys(t).length > 0), o = G(), n = C(), r = V(() => !!o["panel-title"] || !!o["panel-subtitle"] || !!o["panel-title-action"]);
    return (a, i) => (c(), g("section", {
      ref_key: "panel",
      ref: n,
      style: ee({ flex: e.flex }),
      class: I([
        "joy-panel",
        `joy-panel--${e.padding}`,
        `joy-panel--${e.variant}`,
        {
          "joy-panel--no-margin": e.noMargin || l.value,
          "joy-panel--loading": e.loading
        }
      ])
    }, [
      r.value ? (c(), g("header", Za, [
        o["panel-title"] ? (c(), g("div", {
          key: 0,
          class: I(["joy-panel__header-title", `joy-panel__header-title--${e.titleSize}`])
        }, [
          w(a.$slots, "panel-title", {}, void 0, !0)
        ], 2)) : _("", !0),
        o["panel-title-action"] ? (c(), g("div", Xa, [
          w(a.$slots, "panel-title-action", {}, void 0, !0)
        ])) : _("", !0),
        o["panel-subtitle"] ? (c(), g("div", Qa, [
          w(a.$slots, "panel-subtitle", {}, void 0, !0)
        ])) : _("", !0)
      ])) : _("", !0),
      v("div", er, [
        w(a.$slots, "panel-body", {}, void 0, !0)
      ]),
      o["panel-action"] ? (c(), g("footer", tr, [
        w(a.$slots, "panel-action", {}, void 0, !0)
      ])) : _("", !0),
      e.loading ? (c(), T(Xt, {
        key: 2,
        overlay: "",
        color: e.loadingColor
      }, {
        content: z(() => [
          w(a.$slots, "panel-loader-content", {}, void 0, !0)
        ]),
        _: 3
      }, 8, ["color"])) : _("", !0)
    ], 6));
  }
}), Su = /* @__PURE__ */ A(or, [["__scopeId", "data-v-bf00f207"]]), nr = { class: "joy-panel-section" }, lr = {
  key: 0,
  class: "joy-panel-section__title"
}, ar = {
  key: 1,
  class: "joy-panel-section__content"
}, rr = /* @__PURE__ */ L({
  __name: "VJoyPanelSection",
  setup(e) {
    const t = G();
    return (l, o) => (c(), g("div", nr, [
      q(t)["panel-section-title"] ? (c(), g("div", lr, [
        w(l.$slots, "panel-section-title", {}, void 0, !0)
      ])) : _("", !0),
      q(t)["panel-section-content"] ? (c(), g("div", ar, [
        w(l.$slots, "panel-section-content", {}, void 0, !0)
      ])) : _("", !0)
    ]));
  }
}), Cu = /* @__PURE__ */ A(rr, [["__scopeId", "data-v-d88510ab"]]), ir = {}, sr = { class: "joy-product-tour-spotlight" };
function ur(e, t) {
  return c(), g("div", sr);
}
const dr = /* @__PURE__ */ A(ir, [["render", ur], ["__scopeId", "data-v-fbaf8e78"]]), rt = Math.min, cr = Math.max, fr = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, pr = {
  start: "end",
  end: "start"
};
function it(e, t, l) {
  return cr(e, rt(t, l));
}
function ke(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function ve(e) {
  return e.split("-")[0];
}
function De(e) {
  return e.split("-")[1];
}
function ht(e) {
  return e === "x" ? "y" : "x";
}
function gt(e) {
  return e === "y" ? "height" : "width";
}
function $e(e) {
  return ["top", "bottom"].includes(ve(e)) ? "y" : "x";
}
function bt(e) {
  return ht($e(e));
}
function yr(e, t, l) {
  l === void 0 && (l = !1);
  const o = De(e), n = bt(e), r = gt(n);
  let a = n === "x" ? o === (l ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return t.reference[r] > t.floating[r] && (a = Ue(a)), [a, Ue(a)];
}
function mr(e) {
  const t = Ue(e);
  return [st(e), t, st(t)];
}
function st(e) {
  return e.replace(/start|end/g, (t) => pr[t]);
}
function vr(e, t, l) {
  const o = ["left", "right"], n = ["right", "left"], r = ["top", "bottom"], a = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return l ? t ? n : o : t ? o : n;
    case "left":
    case "right":
      return t ? r : a;
    default:
      return [];
  }
}
function hr(e, t, l, o) {
  const n = De(e);
  let r = vr(ve(e), l === "start", o);
  return n && (r = r.map((a) => a + "-" + n), t && (r = r.concat(r.map(st)))), r;
}
function Ue(e) {
  return e.replace(/left|right|bottom|top/g, (t) => fr[t]);
}
function gr(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Qt(e) {
  return typeof e != "number" ? gr(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Ge(e) {
  const {
    x: t,
    y: l,
    width: o,
    height: n
  } = e;
  return {
    width: o,
    height: n,
    top: l,
    left: t,
    right: t + o,
    bottom: l + n,
    x: t,
    y: l
  };
}
function Lt(e, t, l) {
  let {
    reference: o,
    floating: n
  } = e;
  const r = $e(t), a = bt(t), i = gt(a), s = ve(t), d = r === "y", p = o.x + o.width / 2 - n.width / 2, u = o.y + o.height / 2 - n.height / 2, f = o[i] / 2 - n[i] / 2;
  let m;
  switch (s) {
    case "top":
      m = {
        x: p,
        y: o.y - n.height
      };
      break;
    case "bottom":
      m = {
        x: p,
        y: o.y + o.height
      };
      break;
    case "right":
      m = {
        x: o.x + o.width,
        y: u
      };
      break;
    case "left":
      m = {
        x: o.x - n.width,
        y: u
      };
      break;
    default:
      m = {
        x: o.x,
        y: o.y
      };
  }
  switch (De(t)) {
    case "start":
      m[a] -= f * (l && d ? -1 : 1);
      break;
    case "end":
      m[a] += f * (l && d ? -1 : 1);
      break;
  }
  return m;
}
const br = async (e, t, l) => {
  const {
    placement: o = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: a
  } = l, i = r.filter(Boolean), s = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let d = await a.getElementRects({
    reference: e,
    floating: t,
    strategy: n
  }), {
    x: p,
    y: u
  } = Lt(d, o, s), f = o, m = {}, y = 0;
  for (let b = 0; b < i.length; b++) {
    const {
      name: h,
      fn: $
    } = i[b], {
      x: j,
      y: x,
      data: E,
      reset: B
    } = await $({
      x: p,
      y: u,
      initialPlacement: o,
      placement: f,
      strategy: n,
      middlewareData: m,
      rects: d,
      platform: a,
      elements: {
        reference: e,
        floating: t
      }
    });
    p = j ?? p, u = x ?? u, m = {
      ...m,
      [h]: {
        ...m[h],
        ...E
      }
    }, B && y <= 50 && (y++, typeof B == "object" && (B.placement && (f = B.placement), B.rects && (d = B.rects === !0 ? await a.getElementRects({
      reference: e,
      floating: t,
      strategy: n
    }) : B.rects), {
      x: p,
      y: u
    } = Lt(d, f, s)), b = -1);
  }
  return {
    x: p,
    y: u,
    placement: f,
    strategy: n,
    middlewareData: m
  };
};
async function eo(e, t) {
  var l;
  t === void 0 && (t = {});
  const {
    x: o,
    y: n,
    platform: r,
    rects: a,
    elements: i,
    strategy: s
  } = e, {
    boundary: d = "clippingAncestors",
    rootBoundary: p = "viewport",
    elementContext: u = "floating",
    altBoundary: f = !1,
    padding: m = 0
  } = ke(t, e), y = Qt(m), h = i[f ? u === "floating" ? "reference" : "floating" : u], $ = Ge(await r.getClippingRect({
    element: (l = await (r.isElement == null ? void 0 : r.isElement(h))) == null || l ? h : h.contextElement || await (r.getDocumentElement == null ? void 0 : r.getDocumentElement(i.floating)),
    boundary: d,
    rootBoundary: p,
    strategy: s
  })), j = u === "floating" ? {
    x: o,
    y: n,
    width: a.floating.width,
    height: a.floating.height
  } : a.reference, x = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(i.floating)), E = await (r.isElement == null ? void 0 : r.isElement(x)) ? await (r.getScale == null ? void 0 : r.getScale(x)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, B = Ge(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: i,
    rect: j,
    offsetParent: x,
    strategy: s
  }) : j);
  return {
    top: ($.top - B.top + y.top) / E.y,
    bottom: (B.bottom - $.bottom + y.bottom) / E.y,
    left: ($.left - B.left + y.left) / E.x,
    right: (B.right - $.right + y.right) / E.x
  };
}
const wr = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: l,
      y: o,
      placement: n,
      rects: r,
      platform: a,
      elements: i,
      middlewareData: s
    } = t, {
      element: d,
      padding: p = 0
    } = ke(e, t) || {};
    if (d == null)
      return {};
    const u = Qt(p), f = {
      x: l,
      y: o
    }, m = bt(n), y = gt(m), b = await a.getDimensions(d), h = m === "y", $ = h ? "top" : "left", j = h ? "bottom" : "right", x = h ? "clientHeight" : "clientWidth", E = r.reference[y] + r.reference[m] - f[m] - r.floating[y], B = f[m] - r.reference[m], P = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(d));
    let k = P ? P[x] : 0;
    (!k || !await (a.isElement == null ? void 0 : a.isElement(P))) && (k = i.floating[x] || r.floating[y]);
    const N = E / 2 - B / 2, S = k / 2 - b[y] / 2 - 1, M = rt(u[$], S), F = rt(u[j], S), Y = M, se = k - b[y] - F, Q = k / 2 - b[y] / 2 + N, Te = it(Y, Q, se), ue = !s.arrow && De(n) != null && Q !== Te && r.reference[y] / 2 - (Q < Y ? M : F) - b[y] / 2 < 0, ae = ue ? Q < Y ? Q - Y : Q - se : 0;
    return {
      [m]: f[m] + ae,
      data: {
        [m]: Te,
        centerOffset: Q - Te - ae,
        ...ue && {
          alignmentOffset: ae
        }
      },
      reset: ue
    };
  }
}), to = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var l, o;
      const {
        placement: n,
        middlewareData: r,
        rects: a,
        initialPlacement: i,
        platform: s,
        elements: d
      } = t, {
        mainAxis: p = !0,
        crossAxis: u = !0,
        fallbackPlacements: f,
        fallbackStrategy: m = "bestFit",
        fallbackAxisSideDirection: y = "none",
        flipAlignment: b = !0,
        ...h
      } = ke(e, t);
      if ((l = r.arrow) != null && l.alignmentOffset)
        return {};
      const $ = ve(n), j = $e(i), x = ve(i) === i, E = await (s.isRTL == null ? void 0 : s.isRTL(d.floating)), B = f || (x || !b ? [Ue(i)] : mr(i)), P = y !== "none";
      !f && P && B.push(...hr(i, b, y, E));
      const k = [i, ...B], N = await eo(t, h), S = [];
      let M = ((o = r.flip) == null ? void 0 : o.overflows) || [];
      if (p && S.push(N[$]), u) {
        const Q = yr(n, a, E);
        S.push(N[Q[0]], N[Q[1]]);
      }
      if (M = [...M, {
        placement: n,
        overflows: S
      }], !S.every((Q) => Q <= 0)) {
        var F, Y;
        const Q = (((F = r.flip) == null ? void 0 : F.index) || 0) + 1, Te = k[Q];
        if (Te)
          return {
            data: {
              index: Q,
              overflows: M
            },
            reset: {
              placement: Te
            }
          };
        let ue = (Y = M.filter((ae) => ae.overflows[0] <= 0).sort((ae, fe) => ae.overflows[1] - fe.overflows[1])[0]) == null ? void 0 : Y.placement;
        if (!ue)
          switch (m) {
            case "bestFit": {
              var se;
              const ae = (se = M.filter((fe) => {
                if (P) {
                  const pe = $e(fe.placement);
                  return pe === j || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  pe === "y";
                }
                return !0;
              }).map((fe) => [fe.placement, fe.overflows.filter((pe) => pe > 0).reduce((pe, bo) => pe + bo, 0)]).sort((fe, pe) => fe[1] - pe[1])[0]) == null ? void 0 : se[0];
              ae && (ue = ae);
              break;
            }
            case "initialPlacement":
              ue = i;
              break;
          }
        if (n !== ue)
          return {
            reset: {
              placement: ue
            }
          };
      }
      return {};
    }
  };
};
async function _r(e, t) {
  const {
    placement: l,
    platform: o,
    elements: n
  } = e, r = await (o.isRTL == null ? void 0 : o.isRTL(n.floating)), a = ve(l), i = De(l), s = $e(l) === "y", d = ["left", "top"].includes(a) ? -1 : 1, p = r && s ? -1 : 1, u = ke(t, e);
  let {
    mainAxis: f,
    crossAxis: m,
    alignmentAxis: y
  } = typeof u == "number" ? {
    mainAxis: u,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...u
  };
  return i && typeof y == "number" && (m = i === "end" ? y * -1 : y), s ? {
    x: m * p,
    y: f * d
  } : {
    x: f * d,
    y: m * p
  };
}
const oo = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var l, o;
      const {
        x: n,
        y: r,
        placement: a,
        middlewareData: i
      } = t, s = await _r(t, e);
      return a === ((l = i.offset) == null ? void 0 : l.placement) && (o = i.arrow) != null && o.alignmentOffset ? {} : {
        x: n + s.x,
        y: r + s.y,
        data: {
          ...s,
          placement: a
        }
      };
    }
  };
}, no = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: l,
        y: o,
        placement: n
      } = t, {
        mainAxis: r = !0,
        crossAxis: a = !1,
        limiter: i = {
          fn: (h) => {
            let {
              x: $,
              y: j
            } = h;
            return {
              x: $,
              y: j
            };
          }
        },
        ...s
      } = ke(e, t), d = {
        x: l,
        y: o
      }, p = await eo(t, s), u = $e(ve(n)), f = ht(u);
      let m = d[f], y = d[u];
      if (r) {
        const h = f === "y" ? "top" : "left", $ = f === "y" ? "bottom" : "right", j = m + p[h], x = m - p[$];
        m = it(j, m, x);
      }
      if (a) {
        const h = u === "y" ? "top" : "left", $ = u === "y" ? "bottom" : "right", j = y + p[h], x = y - p[$];
        y = it(j, y, x);
      }
      const b = i.fn({
        ...t,
        [f]: m,
        [u]: y
      });
      return {
        ...b,
        data: {
          x: b.x - l,
          y: b.y - o
        }
      };
    }
  };
}, lo = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: l,
        y: o,
        placement: n,
        rects: r,
        middlewareData: a
      } = t, {
        offset: i = 0,
        mainAxis: s = !0,
        crossAxis: d = !0
      } = ke(e, t), p = {
        x: l,
        y: o
      }, u = $e(n), f = ht(u);
      let m = p[f], y = p[u];
      const b = ke(i, t), h = typeof b == "number" ? {
        mainAxis: b,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...b
      };
      if (s) {
        const x = f === "y" ? "height" : "width", E = r.reference[f] - r.floating[x] + h.mainAxis, B = r.reference[f] + r.reference[x] - h.mainAxis;
        m < E ? m = E : m > B && (m = B);
      }
      if (d) {
        var $, j;
        const x = f === "y" ? "width" : "height", E = ["top", "left"].includes(ve(n)), B = r.reference[u] - r.floating[x] + (E && (($ = a.offset) == null ? void 0 : $[u]) || 0) + (E ? 0 : h.crossAxis), P = r.reference[u] + r.reference[x] + (E ? 0 : ((j = a.offset) == null ? void 0 : j[u]) || 0) - (E ? h.crossAxis : 0);
        y < B ? y = B : y > P && (y = P);
      }
      return {
        [f]: m,
        [u]: y
      };
    }
  };
}, ut = Math.min, Be = Math.max, Ye = Math.round, qe = Math.floor, he = (e) => ({
  x: e,
  y: e
});
function ge(e) {
  return ao(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function oe(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function ce(e) {
  var t;
  return (t = (ao(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function ao(e) {
  return e instanceof Node || e instanceof oe(e).Node;
}
function de(e) {
  return e instanceof Element || e instanceof oe(e).Element;
}
function ie(e) {
  return e instanceof HTMLElement || e instanceof oe(e).HTMLElement;
}
function Bt(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof oe(e).ShadowRoot;
}
function Re(e) {
  const {
    overflow: t,
    overflowX: l,
    overflowY: o,
    display: n
  } = le(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + o + l) && !["inline", "contents"].includes(n);
}
function jr(e) {
  return ["table", "td", "th"].includes(ge(e));
}
function wt(e) {
  const t = _t(), l = le(e);
  return l.transform !== "none" || l.perspective !== "none" || (l.containerType ? l.containerType !== "normal" : !1) || !t && (l.backdropFilter ? l.backdropFilter !== "none" : !1) || !t && (l.filter ? l.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((o) => (l.willChange || "").includes(o)) || ["paint", "layout", "strict", "content"].some((o) => (l.contain || "").includes(o));
}
function kr(e) {
  let t = Ee(e);
  for (; ie(t) && !ot(t); ) {
    if (wt(t))
      return t;
    t = Ee(t);
  }
  return null;
}
function _t() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function ot(e) {
  return ["html", "body", "#document"].includes(ge(e));
}
function le(e) {
  return oe(e).getComputedStyle(e);
}
function nt(e) {
  return de(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function Ee(e) {
  if (ge(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Bt(e) && e.host || // Fallback.
    ce(e)
  );
  return Bt(t) ? t.host : t;
}
function ro(e) {
  const t = Ee(e);
  return ot(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : ie(t) && Re(t) ? t : ro(t);
}
function Pe(e, t, l) {
  var o;
  t === void 0 && (t = []), l === void 0 && (l = !0);
  const n = ro(e), r = n === ((o = e.ownerDocument) == null ? void 0 : o.body), a = oe(n);
  return r ? t.concat(a, a.visualViewport || [], Re(n) ? n : [], a.frameElement && l ? Pe(a.frameElement) : []) : t.concat(n, Pe(n, [], l));
}
function io(e) {
  const t = le(e);
  let l = parseFloat(t.width) || 0, o = parseFloat(t.height) || 0;
  const n = ie(e), r = n ? e.offsetWidth : l, a = n ? e.offsetHeight : o, i = Ye(l) !== r || Ye(o) !== a;
  return i && (l = r, o = a), {
    width: l,
    height: o,
    $: i
  };
}
function jt(e) {
  return de(e) ? e : e.contextElement;
}
function Ae(e) {
  const t = jt(e);
  if (!ie(t))
    return he(1);
  const l = t.getBoundingClientRect(), {
    width: o,
    height: n,
    $: r
  } = io(t);
  let a = (r ? Ye(l.width) : l.width) / o, i = (r ? Ye(l.height) : l.height) / n;
  return (!a || !Number.isFinite(a)) && (a = 1), (!i || !Number.isFinite(i)) && (i = 1), {
    x: a,
    y: i
  };
}
const $r = /* @__PURE__ */ he(0);
function so(e) {
  const t = oe(e);
  return !_t() || !t.visualViewport ? $r : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Sr(e, t, l) {
  return t === void 0 && (t = !1), !l || t && l !== oe(e) ? !1 : t;
}
function Se(e, t, l, o) {
  t === void 0 && (t = !1), l === void 0 && (l = !1);
  const n = e.getBoundingClientRect(), r = jt(e);
  let a = he(1);
  t && (o ? de(o) && (a = Ae(o)) : a = Ae(e));
  const i = Sr(r, l, o) ? so(r) : he(0);
  let s = (n.left + i.x) / a.x, d = (n.top + i.y) / a.y, p = n.width / a.x, u = n.height / a.y;
  if (r) {
    const f = oe(r), m = o && de(o) ? oe(o) : o;
    let y = f.frameElement;
    for (; y && o && m !== f; ) {
      const b = Ae(y), h = y.getBoundingClientRect(), $ = le(y), j = h.left + (y.clientLeft + parseFloat($.paddingLeft)) * b.x, x = h.top + (y.clientTop + parseFloat($.paddingTop)) * b.y;
      s *= b.x, d *= b.y, p *= b.x, u *= b.y, s += j, d += x, y = oe(y).frameElement;
    }
  }
  return Ge({
    width: p,
    height: u,
    x: s,
    y: d
  });
}
function Cr(e) {
  let {
    rect: t,
    offsetParent: l,
    strategy: o
  } = e;
  const n = ie(l), r = ce(l);
  if (l === r)
    return t;
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  }, i = he(1);
  const s = he(0);
  if ((n || !n && o !== "fixed") && ((ge(l) !== "body" || Re(r)) && (a = nt(l)), ie(l))) {
    const d = Se(l);
    i = Ae(l), s.x = d.x + l.clientLeft, s.y = d.y + l.clientTop;
  }
  return {
    width: t.width * i.x,
    height: t.height * i.y,
    x: t.x * i.x - a.scrollLeft * i.x + s.x,
    y: t.y * i.y - a.scrollTop * i.y + s.y
  };
}
function Vr(e) {
  return Array.from(e.getClientRects());
}
function uo(e) {
  return Se(ce(e)).left + nt(e).scrollLeft;
}
function Tr(e) {
  const t = ce(e), l = nt(e), o = e.ownerDocument.body, n = Be(t.scrollWidth, t.clientWidth, o.scrollWidth, o.clientWidth), r = Be(t.scrollHeight, t.clientHeight, o.scrollHeight, o.clientHeight);
  let a = -l.scrollLeft + uo(e);
  const i = -l.scrollTop;
  return le(o).direction === "rtl" && (a += Be(t.clientWidth, o.clientWidth) - n), {
    width: n,
    height: r,
    x: a,
    y: i
  };
}
function xr(e, t) {
  const l = oe(e), o = ce(e), n = l.visualViewport;
  let r = o.clientWidth, a = o.clientHeight, i = 0, s = 0;
  if (n) {
    r = n.width, a = n.height;
    const d = _t();
    (!d || d && t === "fixed") && (i = n.offsetLeft, s = n.offsetTop);
  }
  return {
    width: r,
    height: a,
    x: i,
    y: s
  };
}
function Ir(e, t) {
  const l = Se(e, !0, t === "fixed"), o = l.top + e.clientTop, n = l.left + e.clientLeft, r = ie(e) ? Ae(e) : he(1), a = e.clientWidth * r.x, i = e.clientHeight * r.y, s = n * r.x, d = o * r.y;
  return {
    width: a,
    height: i,
    x: s,
    y: d
  };
}
function At(e, t, l) {
  let o;
  if (t === "viewport")
    o = xr(e, l);
  else if (t === "document")
    o = Tr(ce(e));
  else if (de(t))
    o = Ir(t, l);
  else {
    const n = so(e);
    o = {
      ...t,
      x: t.x - n.x,
      y: t.y - n.y
    };
  }
  return Ge(o);
}
function co(e, t) {
  const l = Ee(e);
  return l === t || !de(l) || ot(l) ? !1 : le(l).position === "fixed" || co(l, t);
}
function Lr(e, t) {
  const l = t.get(e);
  if (l)
    return l;
  let o = Pe(e, [], !1).filter((i) => de(i) && ge(i) !== "body"), n = null;
  const r = le(e).position === "fixed";
  let a = r ? Ee(e) : e;
  for (; de(a) && !ot(a); ) {
    const i = le(a), s = wt(a);
    !s && i.position === "fixed" && (n = null), (r ? !s && !n : !s && i.position === "static" && !!n && ["absolute", "fixed"].includes(n.position) || Re(a) && !s && co(e, a)) ? o = o.filter((p) => p !== a) : n = i, a = Ee(a);
  }
  return t.set(e, o), o;
}
function Br(e) {
  let {
    element: t,
    boundary: l,
    rootBoundary: o,
    strategy: n
  } = e;
  const a = [...l === "clippingAncestors" ? Lr(t, this._c) : [].concat(l), o], i = a[0], s = a.reduce((d, p) => {
    const u = At(t, p, n);
    return d.top = Be(u.top, d.top), d.right = ut(u.right, d.right), d.bottom = ut(u.bottom, d.bottom), d.left = Be(u.left, d.left), d;
  }, At(t, i, n));
  return {
    width: s.right - s.left,
    height: s.bottom - s.top,
    x: s.left,
    y: s.top
  };
}
function Ar(e) {
  return io(e);
}
function Er(e, t, l) {
  const o = ie(t), n = ce(t), r = l === "fixed", a = Se(e, !0, r, t);
  let i = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const s = he(0);
  if (o || !o && !r)
    if ((ge(t) !== "body" || Re(n)) && (i = nt(t)), o) {
      const d = Se(t, !0, r, t);
      s.x = d.x + t.clientLeft, s.y = d.y + t.clientTop;
    } else n && (s.x = uo(n));
  return {
    x: a.left + i.scrollLeft - s.x,
    y: a.top + i.scrollTop - s.y,
    width: a.width,
    height: a.height
  };
}
function Et(e, t) {
  return !ie(e) || le(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function fo(e, t) {
  const l = oe(e);
  if (!ie(e))
    return l;
  let o = Et(e, t);
  for (; o && jr(o) && le(o).position === "static"; )
    o = Et(o, t);
  return o && (ge(o) === "html" || ge(o) === "body" && le(o).position === "static" && !wt(o)) ? l : o || kr(e) || l;
}
const zr = async function(e) {
  let {
    reference: t,
    floating: l,
    strategy: o
  } = e;
  const n = this.getOffsetParent || fo, r = this.getDimensions;
  return {
    reference: Er(t, await n(l), o),
    floating: {
      x: 0,
      y: 0,
      ...await r(l)
    }
  };
};
function Jr(e) {
  return le(e).direction === "rtl";
}
const Mr = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Cr,
  getDocumentElement: ce,
  getClippingRect: Br,
  getOffsetParent: fo,
  getElementRects: zr,
  getClientRects: Vr,
  getDimensions: Ar,
  getScale: Ae,
  isElement: de,
  isRTL: Jr
};
function Pr(e, t) {
  let l = null, o;
  const n = ce(e);
  function r() {
    clearTimeout(o), l && l.disconnect(), l = null;
  }
  function a(i, s) {
    i === void 0 && (i = !1), s === void 0 && (s = 1), r();
    const {
      left: d,
      top: p,
      width: u,
      height: f
    } = e.getBoundingClientRect();
    if (i || t(), !u || !f)
      return;
    const m = qe(p), y = qe(n.clientWidth - (d + u)), b = qe(n.clientHeight - (p + f)), h = qe(d), j = {
      rootMargin: -m + "px " + -y + "px " + -b + "px " + -h + "px",
      threshold: Be(0, ut(1, s)) || 1
    };
    let x = !0;
    function E(B) {
      const P = B[0].intersectionRatio;
      if (P !== s) {
        if (!x)
          return a();
        P ? a(!1, P) : o = setTimeout(() => {
          a(!1, 1e-7);
        }, 100);
      }
      x = !1;
    }
    try {
      l = new IntersectionObserver(E, {
        ...j,
        // Handle <iframe>s
        root: n.ownerDocument
      });
    } catch {
      l = new IntersectionObserver(E, j);
    }
    l.observe(e);
  }
  return a(!0), r;
}
function Fr(e, t, l, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: n = !0,
    ancestorResize: r = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: i = typeof IntersectionObserver == "function",
    animationFrame: s = !1
  } = o, d = jt(e), p = n || r ? [...d ? Pe(d) : [], ...Pe(t)] : [];
  p.forEach(($) => {
    n && $.addEventListener("scroll", l, {
      passive: !0
    }), r && $.addEventListener("resize", l);
  });
  const u = d && i ? Pr(d, l) : null;
  let f = -1, m = null;
  a && (m = new ResizeObserver(($) => {
    let [j] = $;
    j && j.target === d && m && (m.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      m && m.observe(t);
    })), l();
  }), d && !s && m.observe(d), m.observe(t));
  let y, b = s ? Se(e) : null;
  s && h();
  function h() {
    const $ = Se(e);
    b && ($.x !== b.x || $.y !== b.y || $.width !== b.width || $.height !== b.height) && l(), b = $, y = requestAnimationFrame(h);
  }
  return l(), () => {
    p.forEach(($) => {
      n && $.removeEventListener("scroll", l), r && $.removeEventListener("resize", l);
    }), u && u(), m && m.disconnect(), m = null, s && cancelAnimationFrame(y);
  };
}
const Or = (e, t, l) => {
  const o = /* @__PURE__ */ new Map(), n = {
    platform: Mr,
    ...l
  }, r = {
    ...n.platform,
    _c: o
  };
  return br(e, t, {
    ...n,
    platform: r
  });
};
function Dr(e) {
  return po(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Rr(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function po(e) {
  return e instanceof Node || e instanceof Rr(e).Node;
}
function Nr(e) {
  return e != null && typeof e == "object" && "$el" in e;
}
function dt(e) {
  if (Nr(e)) {
    const t = e.$el;
    return po(t) && Dr(t) === "#comment" ? null : t;
  }
  return e;
}
function Ie(e) {
  return typeof e == "function" ? e() : q(e);
}
function yo(e) {
  return {
    name: "arrow",
    options: e,
    fn(t) {
      const l = dt(Ie(e.element));
      return l == null ? {} : wr({
        element: l,
        padding: e.padding
      }).fn(t);
    }
  };
}
function mo(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function zt(e, t) {
  const l = mo(e);
  return Math.round(t * l) / l;
}
function vo(e, t, l) {
  l === void 0 && (l = {});
  const o = l.whileElementsMounted, n = V(() => {
    var k;
    return (k = Ie(l.open)) != null ? k : !0;
  }), r = V(() => Ie(l.middleware)), a = V(() => {
    var k;
    return (k = Ie(l.placement)) != null ? k : "bottom";
  }), i = V(() => {
    var k;
    return (k = Ie(l.strategy)) != null ? k : "absolute";
  }), s = V(() => {
    var k;
    return (k = Ie(l.transform)) != null ? k : !0;
  }), d = V(() => dt(e.value)), p = V(() => dt(t.value)), u = C(0), f = C(0), m = C(i.value), y = C(a.value), b = Ot({}), h = C(!1), $ = V(() => {
    const k = {
      position: m.value,
      left: "0",
      top: "0"
    };
    if (!p.value)
      return k;
    const N = zt(p.value, u.value), S = zt(p.value, f.value);
    return s.value ? {
      ...k,
      transform: "translate(" + N + "px, " + S + "px)",
      ...mo(p.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: m.value,
      left: N + "px",
      top: S + "px"
    };
  });
  let j;
  function x() {
    d.value == null || p.value == null || Or(d.value, p.value, {
      middleware: r.value,
      placement: a.value,
      strategy: i.value
    }).then((k) => {
      u.value = k.x, f.value = k.y, m.value = k.strategy, y.value = k.placement, b.value = k.middlewareData, h.value = !0;
    });
  }
  function E() {
    typeof j == "function" && (j(), j = void 0);
  }
  function B() {
    if (E(), o === void 0) {
      x();
      return;
    }
    if (d.value != null && p.value != null) {
      j = o(d.value, p.value, x);
      return;
    }
  }
  function P() {
    n.value || (h.value = !1);
  }
  return K([r, a, i], x, {
    flush: "sync"
  }), K([d, p], B, {
    flush: "sync"
  }), K(n, P, {
    flush: "sync"
  }), Pt() && Ft(E), {
    x: xe(u),
    y: xe(f),
    strategy: xe(m),
    placement: xe(y),
    middlewareData: xe(b),
    isPositioned: xe(h),
    floatingStyles: $,
    update: x
  };
}
const qr = () => {
  const e = C(null);
  return {
    clearProductTourRef: () => {
      e.value = null;
    },
    storeProductTourRef: (o) => {
      var n;
      (n = e.value) == null || n.hide(), o && (e.value = o, e.value.show());
    },
    productToursRef: e
  };
}, ho = qr(), Hr = { class: "joy-product-tour__content" }, Wr = { class: "joy-product-tour__header" }, Ur = {
  key: 0,
  class: "joy-product-tour__footer"
}, Gr = { class: "joy-product-tour__footer___steps" }, Yr = "joy-product-tour-spotlight__wrapper", Kr = /* @__PURE__ */ L({
  __name: "VJoyProductTourInner",
  props: {
    icon: {},
    steps: { default: 1 },
    step: { default: 1 },
    position: { default: "bottom" },
    open: { type: Boolean, default: !1 },
    maxWidth: { default: 500 },
    disableOverlay: { type: Boolean, default: !1 },
    spotlightPadding: { default: 8 },
    spotlightSelector: {},
    closeButton: { type: Boolean, default: !0 }
  },
  emits: ["product-tour:hide"],
  setup(e, { expose: t, emit: l }) {
    const o = l, n = e, { clearProductTourRef: r } = ho, a = C(null), i = C(null), s = C(null), d = C(null), p = C(null), u = C(n.open), f = C(), m = C(
      vo(s, a, {
        placement: n.position,
        whileElementsMounted(...k) {
          return Fr(...k, { ancestorResize: !0, ancestorScroll: !0, elementResize: !0 });
        },
        transform: !1,
        middleware: [
          oo(30),
          no({
            limiter: lo()
          }),
          to({
            fallbackPlacements: ["bottom", "top", "left", "right"]
          }),
          yo({ element: f, padding: 0 })
        ]
      })
    ), y = V(() => {
      const { middlewareData: k, placement: N } = m.value, S = k.arrow, M = {
        top: "bottom",
        right: "left",
        bottom: "top",
        left: "right"
      }[N.split("-")[0]];
      return {
        left: (S == null ? void 0 : S.x) && `${S == null ? void 0 : S.x}px`,
        top: (S == null ? void 0 : S.y) && `${S == null ? void 0 : S.y}px`,
        right: "",
        bottom: "",
        [M]: "-12px"
      };
    });
    function b() {
      var k;
      n.spotlightSelector && document.body.contains(document.querySelector(n.spotlightSelector)) && (s.value = document.querySelector(n.spotlightSelector), $({
        elementToHighlight: s.value,
        disableOverlay: n.disableOverlay
      }), (k = m.value) == null || k.update(), u.value = !0);
    }
    function h() {
      u.value = !1, r(), P(), o("product-tour:hide");
    }
    function $(k) {
      s.value && (k.disableOverlay || j(), x(k.elementToHighlight));
    }
    function j() {
      i.value = document.createElement("div"), i.value.classList.add("joy-product-tour__overlay"), i.value.addEventListener("click", h, { once: !0 }), i.value.style.position = "fixed", i.value.style.top = "0", i.value.style.left = "0", i.value.style.width = "100%", i.value.style.height = "100%", i.value.style.zIndex = "var(--joy-core-z-index-backdrop)", document.querySelector("body").appendChild(i.value);
    }
    function x(k) {
      k && (k.style.position = "relative", k.style.zIndex = "calc(var(--joy-core-z-index-backdrop) + 1)", d.value = O(dr), p.value = document.createElement("div"), p.value.classList.add(Yr), document.body.appendChild(p.value), kt(d.value, p.value), E());
    }
    function E() {
      if (!p.value)
        return;
      const { left: k, top: N, height: S, width: M } = s.value.getBoundingClientRect();
      p.value.style.left = `calc(${window.scrollX + k - n.spotlightPadding}px`, p.value.style.top = `${window.scrollY + N - n.spotlightPadding}px`, p.value.style.width = `${M}px`, p.value.style.height = `${S}px`, p.value.style.position = "absolute", p.value.style.padding = n.spotlightPadding + "px", p.value.style.boxSizing = "content-box";
    }
    function B() {
      i.value && i.value.remove();
    }
    function P() {
      B(), s.value && (s.value.style.position = "", s.value.style.zIndex = ""), p.value && (kt(null, p.value), p.value.remove());
    }
    return K(m.value, () => {
      var k;
      d.value && ((k = a.value) != null && k.isConnected ? E() : h());
    }), Mt(() => {
      P();
    }), t({
      hide: h,
      show: b,
      isOpen: u
    }), (k, N) => {
      var S;
      return Ke((c(), g("div", {
        ref_key: "productTour",
        ref: a,
        class: "joy-product-tour__wrapper",
        role: "tooltip",
        style: ee({ "--product-tour-width": k.maxWidth + "px", ...(S = m.value) == null ? void 0 : S.floatingStyles })
      }, [
        v("div", {
          ref_key: "productTourArrow",
          ref: f,
          class: "joy-product-tour__arrow",
          style: ee(y.value)
        }, null, 4),
        v("div", {
          class: I([
            "joy-product-tour",
            `joy-product-tour--${k.position}`,
            {
              "joy-product-tour--open": u.value
            }
          ])
        }, [
          v("div", {
            class: I(["joy-product-tour__banner", { "joy-product-tour__hasBanner": k.$slots["product-tour-banner"] }])
          }, [
            w(k.$slots, "product-tour-banner", {}, void 0, !0)
          ], 2),
          v("div", {
            class: I(["joy-product-tour__preheader", { "joy-product-tour__hasPreheader": k.$slots["product-tour-preheader"] }])
          }, [
            v("div", null, [
              w(k.$slots, "product-tour-preheader", {}, void 0, !0)
            ]),
            k.closeButton ? (c(), T(ne, {
              key: 0,
              class: "joy-product-tour__close",
              variant: "ghost",
              circle: "",
              icon: "cross",
              size: "small",
              onClick: h
            })) : _("", !0)
          ], 2),
          v("div", Hr, [
            k.icon ? (c(), T(R, {
              key: 0,
              class: "joy-product-tour__content___icon",
              name: k.icon,
              size: "medium"
            }, null, 8, ["name"])) : _("", !0),
            v("div", null, [
              v("div", Wr, [
                w(k.$slots, "product-tour-header", {}, void 0, !0)
              ]),
              w(k.$slots, "product-tour-content", {}, void 0, !0)
            ])
          ]),
          k.$slots["product-tour-dismiss"] || k.$slots["product-tour-next"] ? (c(), g("div", Ur, [
            v("div", { onClick: h }, [
              w(k.$slots, "product-tour-dismiss", {}, void 0, !0)
            ]),
            v("span", Gr, [
              k.steps > 1 ? (c(), g(W, { key: 0 }, [
                D(J(k.step) + "/" + J(k.steps), 1)
              ], 64)) : _("", !0)
            ]),
            w(k.$slots, "product-tour-next", {}, void 0, !0)
          ])) : _("", !0)
        ], 2)
      ], 4)), [
        [Lo, u.value]
      ]);
    };
  }
}), Zr = /* @__PURE__ */ A(Kr, [["__scopeId", "data-v-3f8b3a2a"]]), Vu = /* @__PURE__ */ L({
  inheritAttrs: !1,
  __name: "VJoyProductTour",
  props: {
    icon: {},
    steps: {},
    step: {},
    position: {},
    open: { type: Boolean },
    maxWidth: {},
    disableOverlay: { type: Boolean },
    spotlightPadding: {},
    spotlightSelector: {},
    closeButton: { type: Boolean, default: !0 }
  },
  emits: ["product-tour:hide"],
  setup(e, { expose: t, emit: l }) {
    const o = C(!1), n = e, r = l, { storeProductTourRef: a, clearProductTourRef: i } = ho, s = C(), d = be(), p = V(() => {
      if (o.value)
        return d;
    });
    function u() {
      a(s.value);
    }
    function f() {
      r("product-tour:hide");
    }
    function m(y = { fireHideEvent: !1 }) {
      var b;
      (b = s.value) == null || b.hide(), i(), y.fireHideEvent && f();
    }
    return te(() => {
      o.value = !0, n.open && a(s.value);
    }), t({
      show: u,
      hide: m
    }), (y, b) => (c(), T(ze, { to: "body" }, [
      O(Zr, H({ ...n, ...p.value }, {
        ref_key: "productTour",
        ref: s,
        "onProductTour:hide": f
      }), {
        "product-tour-banner": z(() => [
          w(y.$slots, "product-tour-banner")
        ]),
        "product-tour-preheader": z(() => [
          w(y.$slots, "product-tour-preheader")
        ]),
        "product-tour-header": z(() => [
          w(y.$slots, "product-tour-header")
        ]),
        "product-tour-content": z(() => [
          w(y.$slots, "product-tour-content")
        ]),
        "product-tour-dismiss": z(() => [
          w(y.$slots, "product-tour-dismiss")
        ]),
        "product-tour-next": z(() => [
          w(y.$slots, "product-tour-next")
        ]),
        _: 3
      }, 16)
    ]));
  }
}), Tu = /* @__PURE__ */ L({
  __name: "VJoyProductTourTrigger",
  props: {
    productTour: {}
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const l = e, o = t, n = V(() => l.productTour), r = G(), a = V(() => r.default());
    async function i() {
      var s;
      o("click"), n.value && ((s = n.value) == null || s.show());
    }
    return (s, d) => (c(!0), g(W, null, U(a.value, (p) => (c(), T(Z(p), {
      key: p,
      onClick: i
    }))), 128));
  }
}), Xr = { class: "joy-progress-bar-wrapper" }, Qr = {
  key: 0,
  class: "joy-progress-bar-label joy-font-primary-250"
}, ei = /* @__PURE__ */ L({
  __name: "VJoyProgressBar",
  props: {
    /** import TJoyProgressBarColors */
    color: {
      type: String,
      default: "secondary"
    },
    /**
     * Total number of steps.
     */
    steps: {
      type: Number
    },
    /**
     * Current step number.
     */
    currentStep: {
      type: Number
    },
    /**
     * Progress bar percentage, percentage usage will override steps & currentStep definition.
     */
    percentage: {
      type: Number
    },
    /** Display the actual progress value next to the bar */
    showLabel: {
      type: Boolean,
      default: !1
    }
  },
  setup(e, { expose: t }) {
    const l = e, o = C(0), n = V(() => r());
    function r() {
      return l.percentage ? o.value = l.percentage : l.currentStep && l.steps ? o.value = Math.round(l.currentStep / l.steps * 100) : o.value = 0, o.value < 0 && (o.value = 0), o.value > 100 && (o.value = 100), o.value + "%";
    }
    return t({
      computeInnerWidth: n,
      computedPercentage: o
    }), (a, i) => (c(), T(re, {
      wrap: "nowrap",
      "column-gap": "1",
      align: "center",
      class: I([`joy-progress-bar_${e.color}`])
    }, {
      default: z(() => [
        v("div", Xr, [
          v("div", {
            class: "joy-progress-bar-inner",
            style: ee({ width: n.value })
          }, null, 4)
        ]),
        e.showLabel && e.percentage ? (c(), g("span", Qr, J(e.percentage + "%"), 1)) : _("", !0)
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), xu = /* @__PURE__ */ A(ei, [["__scopeId", "data-v-1216eff6"]]), ti = ["id", "value", "checked", "disabled", "required", "name"], oi = { class: "joy-radio-label" }, ni = { class: "joy-radio-header-right" }, li = { class: "joy-radio-sublabel" }, ai = { class: "joy-radio-content__wrapper" }, ri = { class: "joy-radio-content" }, ii = /* @__PURE__ */ L({
  __name: "VJoyRadio",
  props: {
    disabled: {
      type: Boolean,
      default: !1
    },
    id: {
      type: String
    },
    name: {
      type: String
    },
    required: {
      type: Boolean,
      default: !1
    },
    modelValue: {
      type: [String, Number]
    },
    /** Change the layout by using this property */
    theme: {
      type: String,
      default: "default"
    },
    value: {
      type: [String, Number],
      required: !0
    }
  },
  emits: ["update:modelValue"],
  setup(e, { expose: t, emit: l }) {
    const o = l, n = e, r = C(!1), a = C(!1), i = C(null), s = C(null), d = G(), p = V(() => !n.modelValue || !n.value ? !1 : n.modelValue === n.value);
    function u() {
      r.value = !!d["expandable-content"] && p.value;
    }
    function f() {
      o("update:modelValue", n.value), u();
    }
    te(() => {
      n.theme === "outline" && u();
    });
    function m() {
      a.value = !0;
    }
    function y() {
      a.value = !1;
    }
    return K(
      () => n.modelValue,
      () => {
        u();
      }
    ), t({
      checked: p,
      isExpanded: r
    }), (b, h) => (c(), g("label", {
      ref_key: "root",
      ref: i,
      class: I([
        "joy-radio",
        `joy-radio--${e.theme}`,
        {
          "joy-radio--checked": p.value,
          "joy-radio--disabled": e.disabled,
          "joy-radio--outline-focus": a.value && e.theme === "outline",
          "joy-radio--focus": a.value && e.theme === "default"
        }
      ])
    }, [
      v("input", {
        id: e.id,
        "data-joy-form-field": "",
        type: "radio",
        value: e.value,
        checked: p.value,
        disabled: e.disabled,
        required: e.required,
        name: e.name,
        onChange: f,
        onFocus: m,
        onBlur: y
      }, null, 40, ti),
      v("span", oi, [
        w(b.$slots, "default", {}, void 0, !0),
        v("div", ni, [
          w(b.$slots, "radio-header-right", {}, void 0, !0)
        ])
      ]),
      v("div", li, [
        w(b.$slots, "radio-sublabel", {}, void 0, !0)
      ]),
      v("div", ai, [
        v("div", {
          ref_key: "expandableElement",
          ref: s,
          class: I(["joy-radio-expandable", { "joy-radio-expandable--expanded": r.value }])
        }, [
          w(b.$slots, "expandable-content", {}, void 0, !0)
        ], 2),
        v("div", ri, [
          w(b.$slots, "radio-content", {}, void 0, !0)
        ])
      ])
    ], 2));
  }
}), Iu = /* @__PURE__ */ A(ii, [["__scopeId", "data-v-c5b11e4c"]]), si = ["form", "name"], ui = /* @__PURE__ */ L({
  __name: "VJoyRadioGroup",
  props: {
    direction: { default: "horizontal" },
    form: {},
    name: {}
  },
  setup(e) {
    return (t, l) => (c(), g("fieldset", {
      ref: "root",
      class: "joy-radio-group-fieldset",
      role: "radiogroup",
      form: t.form,
      name: t.name
    }, [
      w(t.$slots, "radio-group-legend", {}, void 0, !0),
      v("div", {
        class: I(["joy-radio-group-container", `joy-radio-group-${t.direction}`])
      }, [
        w(t.$slots, "default", {}, void 0, !0)
      ], 2)
    ], 8, si));
  }
}), Lu = /* @__PURE__ */ A(ui, [["__scopeId", "data-v-ac4dd24e"]]), di = ["aria-label"], ci = { class: "joy-rating-stars" }, fi = { class: "joy-rating-stars__content" }, pi = { key: 0 }, yi = /* @__PURE__ */ L({
  __name: "VJoyRatingStars",
  props: {
    /** Between 0 and 5 */
    ratingValue: {
      type: Number,
      default: 0
    },
    /** Display the amount of review leading to the rating value */
    reviewCount: {
      type: Number,
      default: 0
    },
    size: {
      type: String,
      default: "medium"
    }
  },
  setup(e, { expose: t }) {
    const l = e, o = be(), n = V(() => {
      let r = [], a = 0.24, i = 0.75;
      for (let s = 0; s < 5; s++)
        l.ratingValue > a ? r.push(l.ratingValue < i ? "half" : "full") : r.push("empty"), a += 1, i += 1;
      return r;
    });
    return t({
      setStars: n
    }), (r, a) => (c(), g("div", {
      role: "img",
      class: "joy-rating-stars__wrapper",
      "aria-label": q(o).ariaLabel || `Rating: ${e.ratingValue} out of 5`
    }, [
      v("ul", ci, [
        (c(!0), g(W, null, U(n.value, (i, s) => (c(), g("li", {
          key: s,
          class: I([`joy-rating-stars--${e.size}`])
        }, [
          i === "full" ? (c(), T(R, {
            key: 0,
            "aria-hidden": "true",
            name: "star-fill",
            color: "quaternary"
          })) : i === "half" ? (c(), T(R, {
            key: 1,
            "aria-hidden": "true",
            name: "star-half",
            color: "quaternary"
          })) : (c(), T(R, {
            key: 2,
            "aria-hidden": "true",
            name: "star",
            color: "quaternary"
          }))
        ], 2))), 128))
      ]),
      v("div", fi, [
        w(r.$slots, "rating-stars-content", {}, () => [
          e.reviewCount ? (c(), g("span", pi, "(" + J(e.reviewCount) + ")", 1)) : _("", !0)
        ], !0)
      ])
    ], 8, di));
  }
}), mi = /* @__PURE__ */ A(yi, [["__scopeId", "data-v-df20c585"]]), vi = ["id", "name", "aria-label", "aria-invalid", "required", "disabled"], hi = ["selected"], gi = /* @__PURE__ */ L({
  __name: "VJoySelect",
  props: {
    /** aria-label is available only if 'label' property is undefined **/
    ariaLabel: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    id: {
      type: String
    },
    invalid: {
      type: Boolean,
      default: !1
    },
    name: {
      type: String
    },
    required: {
      type: Boolean,
      default: !1
    },
    // ...FORM_BASED_PROPS,
    label: String,
    labelSize: {
      type: String
    },
    optionalLabel: String,
    requiredMark: {
      type: Boolean,
      default: !1
    },
    /** Made to use the built-in v-model */
    modelValue: {
      type: [String, Number],
      default: ""
    },
    size: {
      type: String,
      default: "medium"
    }
    // ...TEXT_BASED_PROPS,
  },
  emits: ["update:modelValue"],
  setup(e, { expose: t, emit: l }) {
    const o = e, n = l, r = G(), a = V(() => {
      const b = (r == null ? void 0 : r.default) && (r == null ? void 0 : r.default());
      let h = [];
      return b.forEach(($) => {
        if (i($))
          h.push($);
        else {
          const j = $.children;
          if (typeof j == "string" || !j.length)
            return;
          const x = j.filter(i);
          h = [...h, ...x];
        }
      }), h;
    });
    function i(b) {
      return (b == null ? void 0 : b.type) === "option";
    }
    const s = C(), d = C(), p = C(!1), u = V(() => o.labelSize ? o.labelSize : o.size !== "medium" ? "small" : "medium");
    te(() => {
      var $;
      const b = r["select-label"] && r["select-label"]();
      if (!b || !b.length)
        return;
      const h = b[0];
      if (h.type === "JoyLabel") {
        const j = ($ = h.props) == null ? void 0 : $.for;
        if (!j) {
          console.warn("JoyLabel for attribute is missing");
          return;
        }
        j !== o.id && console.warn("JoyLabel for attribute does not match with JoySelect id");
      }
    });
    function f(b) {
      const h = b.target.value;
      n("update:modelValue", h);
    }
    function m() {
      p.value = !0;
    }
    function y() {
      p.value = !1;
    }
    return t({
      select: d
    }), (b, h) => (c(), g("div", {
      ref_key: "root",
      ref: s
    }, [
      w(b.$slots, "select-label", {}, () => [
        e.label ? (c(), T(Ve, {
          key: 0,
          required: e.required && e.requiredMark,
          "optional-label": e.optionalLabel,
          for: e.id || e.name,
          size: u.value
        }, {
          default: z(() => [
            D(J(e.label), 1)
          ]),
          _: 1
        }, 8, ["required", "optional-label", "for", "size"])) : _("", !0)
      ], !0),
      v("div", {
        class: I([
          `joy-select--${e.size}`,
          {
            "joy-select__wrapper": !0,
            "joy-select--invalid": e.invalid,
            "joy-select--disabled": e.disabled,
            "joy-select--focusing": p.value
          }
        ])
      }, [
        v("select", {
          id: e.id || e.name,
          ref_key: "select",
          ref: d,
          "data-joy-form-field": "",
          class: "joy-select",
          name: e.name,
          "aria-label": e.label ? void 0 : e.ariaLabel,
          "aria-invalid": e.invalid,
          required: e.required,
          disabled: e.disabled,
          onChange: f,
          onFocus: m,
          onBlur: y
        }, [
          (c(!0), g(W, null, U(a.value, ($) => {
            var j, x;
            return c(), g("option", H({
              key: (j = $.props) == null ? void 0 : j.value,
              ref_for: !0
            }, $.props, {
              selected: ((x = $.props) == null ? void 0 : x.value) === e.modelValue
            }), J($.children), 17, hi);
          }), 128))
        ], 40, vi),
        O(R, {
          class: "joy-select__chevron",
          name: "chevron-down"
        })
      ], 2)
    ], 512));
  }
}), Bu = /* @__PURE__ */ A(gi, [["__scopeId", "data-v-8811eaf5"]]), bi = ["aria-disabled"], wi = ["id", "value", "checked", "disabled", "required", "name"], _i = { class: "joy-selectable-item__label" }, ji = /* @__PURE__ */ L({
  __name: "VJoySelectableItem",
  props: {
    disabled: { type: Boolean, default: !1 },
    id: {},
    invalid: { type: Boolean, default: !1 },
    multiple: { type: Boolean, default: !1 },
    name: {},
    required: { type: Boolean, default: !1 },
    checked: { type: Boolean },
    value: {},
    label: {},
    subLabel: {},
    icon: {}
  },
  emits: ["update:checked"],
  setup(e, { emit: t }) {
    const l = t, o = Fe() + "--JoySelectableItem", n = e, r = C(), a = C(!1), i = n.multiple ? "div" : "label", s = V(() => n.id || o), d = {
      onRadioChange: () => {
        l("update:checked", n.value);
      },
      onClick: () => {
        n.checked && !n.multiple && l("update:checked", "");
      },
      onLabelClick: (u) => {
        n.multiple || u.stopPropagation();
      },
      onFocus: () => {
        a.value = !0;
      },
      onBlur: () => {
        a.value = !1;
      }
    };
    function p(u) {
      l("update:checked", u);
    }
    return (u, f) => (c(), g("div", {
      class: I([
        "joy-selectable-item__wrapper",
        {
          "joy-selectable-item--focusing": a.value
        }
      ]),
      "aria-disabled": u.disabled,
      onClick: f[5] || (f[5] = //@ts-ignore
      (...m) => d.onClick && d.onClick(...m))
    }, [
      u.multiple ? _("", !0) : (c(), g("input", {
        key: 0,
        id: s.value,
        ref_key: "inputRadio",
        ref: r,
        "data-joy-form-field": "",
        type: "radio",
        value: u.value,
        checked: u.checked,
        disabled: u.disabled,
        required: u.required,
        name: u.name,
        onChange: f[0] || (f[0] = //@ts-ignore
        (...m) => d.onRadioChange && d.onRadioChange(...m)),
        onFocus: f[1] || (f[1] = //@ts-ignore
        (...m) => d.onFocus && d.onFocus(...m)),
        onBlur: f[2] || (f[2] = //@ts-ignore
        (...m) => d.onBlur && d.onBlur(...m))
      }, null, 40, wi)),
      (c(), T(Z(q(i)), {
        for: s.value,
        class: I([
          "joy-selectable-item",
          {
            "joy-selectable-item--disabled": u.disabled,
            "joy-selectable-item--checked": u.checked,
            "joy-selectable-item--multiple": u.multiple,
            "joy-selectable-item--single": !u.multiple,
            "joy-selectable-item--invalid": u.invalid
          }
        ]),
        onClick: d.onLabelClick
      }, {
        default: z(() => [
          u.multiple ? (c(), T(Kt, {
            key: 0,
            id: s.value,
            checked: u.checked,
            disabled: u.disabled,
            value: u.value,
            name: u.name,
            "display-focus": !1,
            required: u.required,
            invalid: u.invalid,
            onFocus: f[3] || (f[3] = () => d.onFocus()),
            onBlur: f[4] || (f[4] = () => d.onBlur()),
            "onUpdate:checked": p
          }, {
            default: z(() => [
              w(u.$slots, "default", {}, void 0, !0)
            ]),
            _: 3
          }, 8, ["id", "checked", "disabled", "value", "name", "required", "invalid"])) : _("", !0),
          v("div", _i, [
            u.multiple ? _("", !0) : w(u.$slots, "default", { key: 0 }, void 0, !0)
          ]),
          v("div", {
            class: I([{ "joy-selectable-item__sublabel": u.$slots["selectable-item-sublabel"] }])
          }, [
            w(u.$slots, "selectable-item-sublabel", {}, () => [
              D(J(u.subLabel), 1)
            ], !0)
          ], 2)
        ]),
        _: 3
      }, 8, ["for", "class", "onClick"]))
    ], 10, bi));
  }
}), ki = /* @__PURE__ */ A(ji, [["__scopeId", "data-v-1bc198e0"]]), $i = ["id"], Si = /* @__PURE__ */ L({
  __name: "VJoySelectableItemGroup",
  props: {
    options: {},
    id: {},
    value: { default: null },
    valueKey: {},
    multiple: { type: Boolean, default: !1 },
    fullWidth: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    label: {},
    labelKey: {},
    labelSize: { default: "medium" },
    optionalLabel: {},
    requiredMark: { type: Boolean, default: !1 },
    invalid: { type: Boolean },
    errorMessage: {}
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const l = t, o = e;
    function n(i) {
      return typeof o.value == "string" ? o.value === a(i) : (o.value || []).includes(a(i));
    }
    function r(i, s) {
      if (!o.multiple)
        return l("update:value", s);
      let d = [...o.value || []];
      s && typeof s == "boolean" ? d.push(i) : d.splice(d.indexOf(i), 1), l("update:value", d);
    }
    function a(i) {
      return o.valueKey && Object.prototype.hasOwnProperty.call(i, o.valueKey) ? i[o.valueKey] : i.value;
    }
    return (i, s) => (c(), g("fieldset", {
      id: i.id,
      class: "joy-selectable-item-group__wrapper"
    }, [
      i.label ? (c(), T(Ve, {
        key: 0,
        "tag-name": "legend",
        required: i.required && i.requiredMark,
        "optional-label": i.optionalLabel,
        size: i.labelSize
      }, {
        default: z(() => [
          D(J(i.label), 1)
        ]),
        _: 1
      }, 8, ["required", "optional-label", "size"])) : _("", !0),
      v("div", {
        class: I([
          "joy-selectable-item-group",
          {
            "joy-selectable-item-group--multiple": i.multiple,
            "joy-selectable-item-group--single": !i.multiple,
            "joy-selectable-item-group--full": i.fullWidth,
            "joy-selectable-item-group--invalid": i.invalid
          }
        ])
      }, [
        (c(!0), g(W, null, U(i.options, (d) => (c(), T(ki, H({ ref_for: !0 }, d.attrs, {
          id: d.id,
          key: d.id,
          name: d.name,
          disabled: d.disabled,
          value: a(d),
          multiple: i.multiple,
          checked: n(d),
          invalid: i.invalid,
          "onUpdate:checked": (p) => r(a(d), p)
        }), pt({
          default: z(() => [
            w(i.$slots, "item", H({ ref_for: !0 }, d), () => [
              D(J(i.labelKey && d[i.labelKey] || d.label), 1)
            ], !0)
          ]),
          _: 2
        }, [
          d.subLabel ? {
            name: "selectable-item-sublabel",
            fn: z(() => [
              D(J(d.subLabel), 1)
            ]),
            key: "0"
          } : void 0
        ]), 1040, ["id", "name", "disabled", "value", "multiple", "checked", "invalid", "onUpdate:checked"]))), 128))
      ], 2),
      i.errorMessage && i.invalid ? (c(), T(tt, {
        key: 1,
        "no-html-error-text": i.errorMessage,
        class: "joy-mt-2"
      }, null, 8, ["no-html-error-text"])) : _("", !0)
    ], 8, $i));
  }
}), Au = /* @__PURE__ */ A(Si, [["__scopeId", "data-v-b1ae09f7"]]), Ci = /* @__PURE__ */ L({
  __name: "VJoySeparator",
  props: {
    /** Main text to apply in the central area */
    text: {
      type: String
    },
    size: {
      type: String,
      default: "default"
    }
  },
  setup(e) {
    return (t, l) => (c(), g("div", {
      class: I(["joy-separator", { "joy-separator__small": e.size === "small" }])
    }, [
      v("span", null, J(e.text), 1)
    ], 2));
  }
}), Eu = /* @__PURE__ */ A(Ci, [["__scopeId", "data-v-21db2899"]]), Vi = ["id"], Ti = { class: "joy-step__stroke" }, xi = {
  key: 0,
  class: "joy-step__label"
}, Ii = /* @__PURE__ */ L({
  __name: "VJoyStep",
  props: {
    /** Set it to completed to change it's color */
    completed: {
      type: Boolean,
      default: !1
    },
    /** Progress substep of the current step  */
    currentSubStep: {
      type: Number,
      default: 0
    },
    /** Adjust the text size, not the component size */
    size: {
      type: String,
      default: "default"
    },
    /** Set the amount of sub steps of the current step */
    subSteps: {
      type: Number,
      default: 1
    },
    id: {
      type: String,
      default: "joy-step-value--" + Xe()
    },
    showLabel: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["update:subSteps"],
  setup(e, { expose: t, emit: l }) {
    const o = e, n = l, r = C(0.1), a = V(() => o.completed ? "100%" : i.value ? o.subSteps <= 1 || o.currentSubStep === 1 ? "10%" : (Math.min(o.currentSubStep / o.subSteps - r.value, 1 - r.value) * 100).toFixed(1) + "%" : "0%"), i = V(() => o.currentSubStep > 0);
    function s(d) {
      d <= 0 && console.warn("subSteps must be equal or greater than 1"), n("update:subSteps");
    }
    return K(() => o.subSteps, s), t({
      progress: a
    }), (d, p) => (c(), g("div", {
      id: e.id,
      class: I([
        "joy-step",
        `joy-step--size-${e.size}`,
        {
          "joy-step--completed": e.completed,
          "joy-step--ongoing": i.value
        }
      ])
    }, [
      v("span", Ti, [
        v("span", {
          class: "joy-step__stroke--filled",
          style: ee({ maxWidth: a.value })
        }, null, 4)
      ]),
      O(ft, { name: "joy-step__label" }, {
        default: z(() => [
          e.showLabel ? (c(), g("span", xi, [
            w(d.$slots, "default", {}, void 0, !0)
          ])) : _("", !0)
        ]),
        _: 3
      })
    ], 10, Vi));
  }
}), Li = /* @__PURE__ */ A(Ii, [["__scopeId", "data-v-3820cdf3"]]), Bi = { class: "joy-stepper" }, Ai = /* @__PURE__ */ L({
  __name: "VJoyStepper",
  props: {
    /** Current step value */
    step: {
      type: Number,
      required: !0
    },
    /** Each main step can have sub-steps to have more specific visual progress feedback  */
    subStep: {
      type: Number,
      default: 1
    }
  },
  setup(e, { expose: t }) {
    const l = e, o = G(), n = Ce("VJoyStepperShowLabels", !0), r = V(() => {
      const f = o.default();
      return f.length === 1 && typeof f[0].type != "object" ? f[0].children.filter(a) : f.filter(a);
    });
    function a(f) {
      var m;
      return ((m = f.type) == null ? void 0 : m.__name) === "VJoyStep";
    }
    const i = V(() => l.step > 0 ? r.value[l.step - 1] : r.value[0]), s = V(() => i.value.props === null ? !1 : l.subStep <= 0 || l.subStep > p.value), d = V(() => s.value && i.value.props ? i.value.props["sub-steps"] : l.subStep), p = V(() => i.value.props === null ? i.value.type.props.subSteps.default : i.value.props["sub-steps"]);
    function u(f) {
      return f !== l.step - 1 ? 0 : d.value;
    }
    return t({
      currentItemSubStep: d,
      steps: r,
      invalidSubStepValue: s
    }), (f, m) => (c(), g("div", Bi, [
      (c(!0), g(W, null, U(r.value, (y, b) => {
        var h;
        return c(), T(Li, H({ ref_for: !0 }, y.props, {
          key: (h = y.props) == null ? void 0 : h.id,
          completed: b < e.step - 1,
          "current-sub-step": u(b),
          "show-label": q(n)
        }), {
          default: z(() => {
            var $;
            return [
              ($ = y.children) != null && $.default ? (c(), T(Z(y.children.default), { key: 0 })) : _("", !0)
            ];
          }),
          _: 2
        }, 1040, ["completed", "current-sub-step", "show-label"]);
      }), 128))
    ]));
  }
}), zu = /* @__PURE__ */ A(Ai, [["__scopeId", "data-v-22705668"]]), Ei = ["id", "aria-hidden", "aria-labelledby"], zi = /* @__PURE__ */ L({
  __name: "VJoyTab",
  props: {
    /**
     * A tab id or name must be provided for each `joy-tab`. It's used internally to reference
     * the selected tab
     */
    tab: {
      type: [String, Number],
      required: !0
    },
    /**
     * The title given to the button
     */
    label: {
      type: [String, Number]
    },
    /**
     * Allow to have a link on the button. When clicking on the button, you will be redirected to the target of the URL.
     */
    href: {
      type: String,
      required: !1
    },
    /** Activates a little notification badge in the tab button. */
    notification: {
      type: Boolean,
      required: !1
    }
  },
  setup(e) {
    const t = e, l = Ce("VJoyTabs", C("")), o = V(() => l.value === t.tab);
    return (n, r) => (c(), g("div", {
      id: `joy-tab-${e.tab}`,
      role: "tabpanel",
      "aria-hidden": o.value ? void 0 : "true",
      "aria-labelledby": `joy-tab-${e.tab}`,
      class: I({
        "joy-tab": !0,
        "joy-tab__selected": o.value
      })
    }, [
      w(n.$slots, "default", {}, void 0, !0)
    ], 10, Ei));
  }
}), Ju = /* @__PURE__ */ A(zi, [["__scopeId", "data-v-a76a7c92"]]), Ji = ["id", "href", "aria-selected", "aria-controls"], Mi = {
  type: "button",
  tabindex: "-1"
}, Pi = /* @__PURE__ */ L({
  __name: "TabButton",
  props: {
    /**
     * Boolean to change style if tabButton is selected
     */
    selected: {
      type: Boolean,
      default: !1
    },
    /**
     * Id of the tab, used for aria prop
     */
    tab: {
      type: [String, Number],
      required: !0
    },
    /**
     * Href props to send to a link. If filled, it replaces the default comportment
     */
    href: {
      type: String,
      required: !1
    },
    /**
     * Label of the button. If filled, it replaces the default slot
     */
    label: {
      type: [String, Number],
      required: !1
    },
    notifications: {
      type: Number
    }
  },
  emits: ["changeTab"],
  setup(e, { emit: t }) {
    const l = e, o = t, n = V(() => typeof l.notifications == "number");
    function r() {
      o("changeTab");
    }
    function a(i) {
      (i.code === "Enter" || i.code === "NumpadEnter") && o("changeTab");
    }
    return (i, s) => (c(), g("a", {
      id: `joy-tab-${e.tab}`,
      href: e.href,
      "aria-selected": e.selected ? "true" : "false",
      "aria-controls": `job-tab-${e.tab}`,
      tabindex: "0",
      role: "tab",
      onClick: r,
      onKeydown: s[0] || (s[0] = (d) => a(d))
    }, [
      v("div", {
        class: I({
          "joy-tab-button": !0,
          "joy-tab-button__selected": e.selected
        })
      }, [
        v("button", Mi, [
          w(i.$slots, "default", {}, () => [
            D(J(e.label), 1)
          ], !0),
          n.value ? (c(), T(cn, {
            key: 0,
            class: "joy-tab-button_notifications",
            variant: "red",
            number: e.notifications
          }, null, 8, ["number"])) : _("", !0)
        ])
      ], 2)
    ], 40, Ji));
  }
}), Fi = /* @__PURE__ */ A(Pi, [["__scopeId", "data-v-8424823d"]]), Oi = { class: "joy-tabs" }, Di = /* @__PURE__ */ L({
  __name: "VJoyTabs",
  props: {
    /** Use this prop to activate a specific tab by default by giving its name */
    selectedTab: {
      type: String
    }
  },
  emits: ["update:selected-tab"],
  setup(e, { expose: t, emit: l }) {
    const o = e, n = l, r = G(), a = C(o.selectedTab);
    Ze("VJoyTabs", a);
    const i = C(null), s = C(null), d = C(!1), p = C(!1), u = V(() => {
      const h = r.default();
      return h.length === 1 && typeof h[0].type != "object" ? h[0].children.filter(f) : h.filter(f);
    });
    function f(h) {
      var $;
      return (($ = h == null ? void 0 : h.type) == null ? void 0 : $.__name) === "VJoyTab";
    }
    function m(h) {
      return h.props.tab === a.value;
    }
    function y() {
      s.value && i.value && s.value.scrollWidth > i.value.offsetWidth ? (p.value = s.value.scrollLeft > 0, d.value = s.value.scrollLeft + i.value.offsetWidth < s.value.scrollWidth) : (p.value = !1, d.value = !1);
    }
    function b(h, $ = !0) {
      h && $ && (a.value = h, n("update:selected-tab", h));
    }
    return K(
      () => o.selectedTab,
      (h) => {
        h && b(h);
      },
      { immediate: !0 }
    ), te(() => {
      var h;
      y(), (h = s.value) == null || h.addEventListener("scroll", y);
    }), Je(() => {
      var h;
      (h = s.value) == null || h.removeEventListener("scroll", y);
    }), t({
      tabs: u
    }), (h, $) => (c(), g("div", Oi, [
      v("div", {
        ref_key: "buttonListWrapper",
        ref: i,
        class: I({
          "joy-tabs-buttons__wrapper": !0,
          "joy-tabs-buttons__wrapper--scroll-end": d.value,
          "joy-tabs-buttons__wrapper--scroll-start": p.value
        })
      }, [
        v("div", {
          ref_key: "buttonList",
          ref: s,
          class: "joy-tabs-buttons",
          role: "tablist"
        }, [
          (c(!0), g(W, null, U(u.value, (j) => (c(), g("div", {
            key: j.props.tab
          }, [
            O(Fi, {
              tab: j.props.tab,
              label: j.props.label,
              href: j.props.href,
              notifications: j.props.notifications,
              selected: m(j),
              onChangeTab: () => b(j.props.tab, !j.props.href)
            }, {
              default: z(() => {
                var x;
                return [
                  (x = j.children) != null && x.header ? (c(), T(Z(j.children.header), { key: 0 })) : _("", !0)
                ];
              }),
              _: 2
            }, 1032, ["tab", "label", "href", "notifications", "selected", "onChangeTab"])
          ]))), 128))
        ], 512)
      ], 2),
      v("div", null, [
        w(h.$slots, "default", {}, void 0, !0)
      ])
    ]));
  }
}), Mu = /* @__PURE__ */ A(Di, [["__scopeId", "data-v-9aea2d41"]]), Ri = ["id", "role"], Ni = /* @__PURE__ */ L({
  __name: "VJoyTag",
  props: {
    label: {},
    size: { default: "medium" },
    variant: { default: "primary" },
    draggable: { type: Boolean, default: !1 },
    removable: { type: Boolean, default: !1 },
    selected: { type: Boolean },
    selectable: { type: Boolean },
    link: { type: Boolean, default: !1 },
    value: { default: void 0 },
    strikethrough: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    id: {}
  },
  emits: ["selected", "remove", "click"],
  setup(e, { emit: t }) {
    const l = ["primary", "secondary"], o = t, n = e, r = V(() => ({
      "joy-tag": !0,
      "joy-tag__selected": n.selected,
      "joy-tag__selectable": n.selectable || n.link,
      "joy-tag_draggable": n.draggable,
      "joy-tag__strikethrough": n.strikethrough,
      "joy-tag__disabled": n.disabled,
      ["joy-tag__" + n.size]: !0,
      ["joy-tag__" + n.variant]: !0
    })), a = Fe() + "--JoyTag", i = V(() => n.id || a);
    function s() {
      o("remove", { value: n.value });
    }
    function d() {
      n.disabled || (o("click"), n.selectable && l.includes(n.variant) && o("selected", { selected: !n.selected, value: n.value }));
    }
    return (p, u) => (c(), g("span", {
      id: i.value,
      class: I([r.value]),
      role: p.link || p.selectable ? "button" : void 0,
      onClick: d
    }, [
      w(p.$slots, "default", {}, () => [
        p.draggable ? (c(), T(R, {
          key: 0,
          class: "joy-tag__drag",
          name: "drag",
          size: "xxsmall"
        })) : _("", !0),
        D(" " + J(p.label), 1)
      ], !0),
      p.removable ? (c(), T(R, {
        key: 0,
        class: "joy-tag__removable",
        name: "cross",
        size: "xxsmall",
        role: "button",
        onClick: Bo(s, ["stop"]),
        onKeydown: Oe(s, ["enter"])
      })) : _("", !0)
    ], 10, Ri));
  }
}), go = /* @__PURE__ */ A(Ni, [["__scopeId", "data-v-f672398d"]]);
var we = /* @__PURE__ */ ((e) => (e.DUPLICATED_ENTRY = "DUPLICATED_ENTRY", e.INVALID_EMAIL = "INVALID_EMAIL", e))(we || {});
function Jt(e) {
  if (!Array.isArray(e) && typeof e != "string")
    return console.warn("Values needs to be an array of emails, or email."), !1;
  function t(l) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(l);
  }
  return Array.isArray(e) ? e.find((o) => {
    if (!t(o))
      return o;
  }) === void 0 : t(e);
}
const qi = { class: "joy-tags-input__wrapper" }, Hi = ["id", "name", "placeholder"], Wi = { key: 0 }, Ui = { key: 1 }, Gi = /* @__PURE__ */ L({
  __name: "VJoyTagsInput",
  props: {
    name: {},
    placeholder: { default: "Add your items here" },
    variant: { default: "primary" },
    size: { default: "small" },
    modelValue: { default: () => [] },
    invalid: { type: Boolean, default: !1 },
    validation: { default: "none" },
    duplicationError: {},
    invalidEmailError: {}
  },
  emits: ["update:modelValue", "validation:error"],
  setup(e, { expose: t, emit: l }) {
    const o = e, n = l, r = C(o.modelValue), a = C(!1), i = C(null), s = C(o.invalid), d = C(null), p = V(() => o.validation === "email"), u = V(() => p.value && d.value === "INVALID_EMAIL" && !!o.invalidEmailError), f = V(() => d.value === "DUPLICATED_ENTRY" && !!o.duplicationError), m = V(() => s.value && (!!u.value || !!f.value));
    function y() {
      p.value && s.value === !0 && (d.value = we.INVALID_EMAIL);
    }
    function b() {
      var F;
      const S = r.value.map((Y) => Y.trim());
      return S.filter((Y, se) => S.indexOf(Y) !== se).length ? !0 : (F = i.value) != null && F.value ? S.includes(i.value.value.trim()) : !1;
    }
    function h() {
      b() && (d.value = we.DUPLICATED_ENTRY);
    }
    function $(S) {
      var M;
      if (["Backspace"].includes(S.key)) {
        if (((M = i.value) == null ? void 0 : M.value) !== "")
          return;
        r.value.pop(), n("update:modelValue", r.value), p.value && N();
      }
    }
    function j() {
      var S, M;
      (S = i.value) != null && S.value && (r.value = [...r.value, (M = i.value) == null ? void 0 : M.value], i.value.value = "", n("update:modelValue", r.value));
    }
    function x(S) {
      var M;
      if (p.value) {
        if (["Enter", ",", " "].includes(S.key)) {
          if (S.preventDefault(), N(), b()) {
            n("validation:error", we.DUPLICATED_ENTRY);
            return;
          } else if ((M = i.value) != null && M.value && !Jt(i.value.value)) {
            n("validation:error", we.INVALID_EMAIL);
            return;
          }
          j();
        }
      } else if (["Enter", ","].includes(S.key)) {
        if (S.preventDefault(), b()) {
          s.value = !0, d.value = we.DUPLICATED_ENTRY, n("validation:error", we.DUPLICATED_ENTRY);
          return;
        }
        j(), s.value = !1;
      }
      $(S);
    }
    function E() {
      a.value = !0;
    }
    function B() {
      a.value = !1, N();
    }
    function P(S) {
      var M;
      r.value = r.value.filter((F) => F !== S.value), n("update:modelValue", r.value), (M = i.value) == null || M.focus(), N();
    }
    function k() {
      var M, F;
      let S = !1;
      if (p.value) {
        let Y = r.value;
        (M = i.value) != null && M.value && (Y = [...Y, (F = i.value) == null ? void 0 : F.value]), S = !Jt(Y);
      }
      s.value = S || b(), !S && b() && (d.value = null);
    }
    function N() {
      k(), y(), h();
    }
    return K(
      () => o.modelValue,
      () => {
        p.value && N();
      },
      { immediate: !0 }
    ), t({
      isInvalid: s,
      hasDuplicates: b
    }), (S, M) => (c(), g("div", qi, [
      S.$slots.default ? (c(), T(Ve, {
        key: 0,
        id: S.name,
        class: "joy-tags-input__label"
      }, {
        default: z(() => [
          w(S.$slots, "default", {}, void 0, !0)
        ]),
        _: 3
      }, 8, ["id"])) : _("", !0),
      v("div", {
        class: I([
          "joy-tags-input__inner",
          {
            "joy-tags-input__inner--focused": a.value,
            "joy-tags-input__inner--invalid": s.value
          }
        ])
      }, [
        (c(!0), g(W, null, U(r.value, (F) => (c(), T(go, {
          key: F,
          variant: S.variant,
          removable: !0,
          size: S.size,
          label: F,
          value: F,
          onRemove: P
        }, {
          default: z(() => [
            w(S.$slots, "tag", H({ ref_for: !0 }, { name: F }), void 0, !0)
          ]),
          _: 2
        }, 1032, ["variant", "size", "label", "value"]))), 128)),
        v("input", {
          id: S.name,
          ref_key: "inputEl",
          ref: i,
          "data-joy-form-field": "",
          type: "text",
          name: S.name,
          placeholder: S.placeholder,
          onKeydown: x,
          onFocus: E,
          onBlur: B
        }, null, 40, Hi)
      ], 2),
      m.value ? (c(), T(tt, {
        key: 1,
        class: "joy-tags-input__error"
      }, {
        default: z(() => [
          v("ul", null, [
            f.value ? (c(), g("li", Wi, J(S.duplicationError), 1)) : _("", !0),
            u.value ? (c(), g("li", Ui, J(S.invalidEmailError), 1)) : _("", !0)
          ])
        ]),
        _: 1
      })) : _("", !0)
    ]));
  }
}), Pu = /* @__PURE__ */ A(Gi, [["__scopeId", "data-v-8124eb68"]]), Yi = /* @__PURE__ */ L({
  __name: "VJoyTagsList",
  props: {
    align: {
      type: String,
      default: "left"
    },
    modelValue: {
      type: Array
    },
    /** Tags list. Array of objects containing at least a label. "value" is mandatory if dealing with removable or selectable tags */
    tags: {
      type: Array,
      default() {
        return [];
      }
    },
    /** You can either pass this property to make all generated tags removable, or pass the `removable: true` to each tag in "tags" prop. */
    removable: {
      type: Boolean,
      default: !1
    },
    /** Make all VJoyTag selectable. Can be overriden by setting selectable: false in specific tags property entry. */
    selectable: {
      type: Boolean,
      default: !1
    },
    /** Apply variant for all VJoyTag. Can be overriden by setting a variant property in specific tags entry. */
    variant: {
      type: String,
      default: "primary"
    }
  },
  emits: ["update:modelValue", "removeTag"],
  setup(e, { emit: t }) {
    const l = t, o = e;
    function n(d) {
      var p;
      return o.removable ? !1 : (p = o.modelValue) == null ? void 0 : p.includes(d.value);
    }
    function r(d) {
      return !o.modelValue || o.removable || d.removable ? !1 : d.selectable !== void 0 ? d.selectable : o.selectable;
    }
    function a(d) {
      return d.removable !== void 0 ? d.removable : o.removable;
    }
    function i(d, p) {
      let u = [];
      d.selected && !n(p) ? u = [...o.modelValue || [], p.value] : u = (o.modelValue || []).filter((f) => f !== p.value), l("update:modelValue", u);
    }
    function s(d) {
      l("removeTag", d.value);
    }
    return (d, p) => (c(), g("div", {
      class: I(["joy-tags-list", `joy-tags-list--${e.align}`])
    }, [
      (c(!0), g(W, null, U(e.tags, (u) => (c(), T(go, H({
        key: u.value || u.label,
        ref_for: !0
      }, u, {
        selectable: r(u),
        removable: a(u),
        variant: u.variant ? u.variant : e.variant,
        selected: n(u),
        onRemove: s,
        onSelected: (f) => i(f, u)
      }), {
        default: z(() => [
          w(d.$slots, "tag", H({ ref_for: !0 }, {
            ...u,
            selectable: r(u),
            selected: n(u),
            removable: a(u)
          }), void 0, !0)
        ]),
        _: 2
      }, 1040, ["selectable", "removable", "variant", "selected", "onSelected"]))), 128))
    ], 2));
  }
}), Fu = /* @__PURE__ */ A(Yi, [["__scopeId", "data-v-1d8003ef"]]), Ki = {}, Zi = {
  class: /* @__PURE__ */ I(["joy-template-shape__shapes"])
};
function Xi(e, t) {
  return c(), g("div", Zi, t[0] || (t[0] = [
    Dt('<div class="shapes__wrapper" data-v-da63aa46><div class="shape_1" data-v-da63aa46></div><div class="shape_2" data-v-da63aa46></div><div class="shape_3" data-v-da63aa46></div><div class="shape_4" data-v-da63aa46></div></div>', 1)
  ]));
}
const Qi = /* @__PURE__ */ A(Ki, [["render", Xi], ["__scopeId", "data-v-da63aa46"]]), es = { class: "joy-template__wrapper" }, ts = {
  key: 0,
  class: "joy-template__heading"
}, os = {
  key: 0,
  class: "joy-template-slot-back"
}, ns = { class: "joy-template__heading___headings" }, ls = {
  key: 0,
  class: "joy-template-slot-title"
}, as = {
  key: 1,
  class: "joy-template-slot-subtitle"
}, rs = {
  key: 1,
  class: "joy-template-slot-actions"
}, is = {
  key: 0,
  class: "joy-template-slot-main"
}, ss = {
  key: 1,
  class: "joy-template-slot-sidebar"
}, us = /* @__PURE__ */ L({
  __name: "VJoyTemplate",
  props: {
    /** Takes 100% of free space */
    full: { type: Boolean, default: !1 },
    sidebar: { type: String, default: "right" },
    loading: {
      type: Boolean,
      default: !1
    },
    loadingColor: {
      type: String,
      default: "light"
    },
    /** Decorative purpose, on bottom right corner */
    shapes: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, l = G(), o = V(() => !!l["template-back"] || !!l["template-title"] || !!l["template-subtitle"] || !!l["template-actions"]);
    return (n, r) => (c(), g("div", {
      class: I(["joy-template", { "joy-template--full": e.full, "joy-template--loading": e.loading }])
    }, [
      e.shapes ? (c(), T(Qi, { key: 0 })) : _("", !0),
      v("div", es, [
        o.value ? (c(), g("div", ts, [
          l["template-back"] ? (c(), g("div", os, [
            w(n.$slots, "template-back", {}, void 0, !0)
          ])) : _("", !0),
          v("div", ns, [
            l["template-title"] ? (c(), g("div", ls, [
              w(n.$slots, "template-title", {}, void 0, !0)
            ])) : _("", !0),
            l["template-subtitle"] ? (c(), g("div", as, [
              w(n.$slots, "template-subtitle", {}, void 0, !0)
            ])) : _("", !0)
          ]),
          l["template-actions"] ? (c(), g("div", rs, [
            w(n.$slots, "template-actions", {}, void 0, !0)
          ])) : _("", !0)
        ])) : _("", !0),
        v("div", {
          class: I([
            "joy-template__content",
            {
              "joy-template__content--reverse": t.sidebar === "left"
            }
          ])
        }, [
          n.$slots["template-main"] ? (c(), g("div", is, [
            w(n.$slots, "template-main", {}, void 0, !0)
          ])) : _("", !0),
          n.$slots["template-sidebar"] ? (c(), g("div", ss, [
            w(n.$slots, "template-sidebar", {}, void 0, !0)
          ])) : _("", !0)
        ], 2)
      ]),
      e.loading ? (c(), T(Xt, {
        key: 1,
        overlay: "",
        color: e.loadingColor
      }, {
        content: z(() => [
          w(n.$slots, "template-loader-content", {}, void 0, !0)
        ]),
        _: 3
      }, 8, ["color"])) : _("", !0)
    ], 2));
  }
}), Ou = /* @__PURE__ */ A(us, [["__scopeId", "data-v-8e1d59ca"]]), ds = /* @__PURE__ */ L({
  __name: "VJoyText",
  props: {
    /** Defines the tag name of the Node you want to create. By default it's a simple P tag. Lowercase only */
    tagName: {
      type: String,
      default: "p"
    },
    /** Choose a pre-configured set of CSS rules : font-family, font-size, line-height, font-weight.  */
    preset: {
      type: String,
      default: "primary-400"
    }
  },
  setup(e) {
    return (t, l) => (c(), T(Z(e.tagName), {
      class: I(`joy-text joy-font-${e.preset}`)
    }, {
      default: z(() => [
        w(t.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), Du = /* @__PURE__ */ A(ds, [["__scopeId", "data-v-6295f9ec"]]), cs = ["aria-disabled"], fs = { class: "joy-textarea_wrapper" }, ps = ["id", "disabled", "name", "required", "minlength", "value"], ys = {
  key: 1,
  class: "joy-textarea_helpers"
}, ms = {
  inheritAttrs: !1
}, vs = /* @__PURE__ */ L({
  ...ms,
  __name: "VJoyTextarea",
  props: {
    autofocus: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    id: {
      type: String
    },
    invalid: {
      type: Boolean,
      default: !1
    },
    name: {
      type: String
    },
    required: {
      type: Boolean,
      default: !1
    },
    label: String,
    labelSize: {
      type: String,
      default: "medium"
    },
    optionalLabel: String,
    requiredMark: {
      type: Boolean,
      default: !1
    },
    modelValue: {
      type: String,
      default: ""
    },
    modelModifiers: {
      default: () => ({
        lazy: !1
      })
    },
    autogrow: {
      type: Boolean,
      default: !1
    },
    minlength: {
      type: Number
    },
    minlengthLabel: String,
    maxlength: {
      type: Number
    }
  },
  emits: ["update:modelValue"],
  setup(e, { expose: t, emit: l }) {
    const o = l, n = e, r = G(), a = C(), { triggerResize: i } = In({
      element: n.autogrow ? a : void 0
    }), s = C(!1), d = C(!1);
    vt(a, n.autofocus);
    const p = V(() => n.maxlength ? n.modelValue.length > n.maxlength : !1), u = V(() => n.minlength ? n.modelValue.length < n.minlength : !1), f = V(() => !!(n.label || r.default)), m = {
      onInput: (y) => {
        n.modelModifiers.lazy || o("update:modelValue", y.target.value), m.triggerResize();
      },
      onChange: (y) => {
        n.modelModifiers.lazy && o("update:modelValue", y.target.value);
      },
      onBlur: () => {
        d.value = !1, s.value = p.value || u.value;
      },
      onFocus: () => {
        d.value = !0;
      },
      /**
       * Here we store the function in an object to more easily test it with vitest.
       * There is an issue when we try to use spyOn vm object directly.
       * */
      triggerResize: i
    };
    return K(
      () => n.modelValue,
      () => {
        m.triggerResize();
      },
      { flush: "post" }
    ), t({
      isInvalid: s,
      valueOverMaxlength: p,
      valueUnderMinlength: u,
      triggerResize: i,
      eventHandlers: m
    }), (y, b) => (c(), g("div", {
      "aria-disabled": e.disabled,
      class: I([
        "joy-textarea",
        {
          "joy-textarea_invalid": s.value || e.invalid,
          "joy-textarea_disabled": e.disabled,
          "joy-textarea_autogrow": e.autogrow,
          "joy-textarea_focusing": d.value
        }
      ])
    }, [
      f.value ? (c(), T(Ve, {
        key: 0,
        for: e.id,
        required: e.required && e.requiredMark,
        "optional-label": e.optionalLabel,
        size: e.labelSize
      }, {
        default: z(() => [
          w(y.$slots, "default", {}, () => [
            D(J(e.label), 1)
          ], !0)
        ]),
        _: 3
      }, 8, ["for", "required", "optional-label", "size"])) : _("", !0),
      v("div", fs, [
        v("textarea", H(y.$attrs, {
          id: e.id,
          ref_key: "textarea",
          ref: a,
          "data-joy-form-field": "",
          class: "joy-native-textarea",
          disabled: e.disabled,
          name: e.name,
          required: e.required,
          minlength: e.minlength,
          value: e.modelValue,
          onInput: b[0] || (b[0] = //@ts-ignore
          (...h) => m.onInput && m.onInput(...h)),
          onChange: b[1] || (b[1] = //@ts-ignore
          (...h) => m.onChange && m.onChange(...h)),
          onFocus: b[2] || (b[2] = //@ts-ignore
          (...h) => m.onFocus && m.onFocus(...h)),
          onBlur: b[3] || (b[3] = //@ts-ignore
          (...h) => m.onBlur && m.onBlur(...h))
        }), null, 16, ps)
      ]),
      e.minlength || e.maxlength ? (c(), g("div", ys, [
        e.minlength ? (c(), g("p", {
          key: 0,
          class: I(["joy-textarea-min", { "joy-textarea-min-invalid": e.invalid }])
        }, [
          u.value ? _("", !0) : (c(), T(R, {
            key: 0,
            name: "check",
            color: "neutral",
            size: "xxsmall"
          })),
          D(" " + J(e.minlengthLabel || `Minimum ${e.minlength} characters`), 1)
        ], 2)) : _("", !0),
        e.maxlength ? (c(), g("p", {
          key: 1,
          class: I(["joy-textarea-count", { "joy-textarea-count-invalid": p.value }])
        }, J(e.modelValue.length + "/" + e.maxlength), 3)) : _("", !0)
      ])) : _("", !0)
    ], 10, cs));
  }
}), Ru = /* @__PURE__ */ A(vs, [["__scopeId", "data-v-c0a7c534"]]), hs = /* @__PURE__ */ L({
  __name: "VJoyTitleBrand",
  props: {
    tag: { default: "p" }
  },
  setup(e) {
    return (t, l) => (c(), T(Z(t.tag), { class: "joy-title-brand joy-font-secondary-200" }, {
      default: z(() => [
        w(t.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }));
  }
}), Nu = /* @__PURE__ */ A(hs, [["__scopeId", "data-v-f63a2545"]]), gs = { class: "joy-toggle__wrapper" }, bs = ["name", "disabled", "checked", "required", "aria-checked", "value"], ws = { class: "joy-toggle__content" }, _s = { class: "joy-toggle__content-label" }, js = {
  key: 0,
  class: "joy-toggle__smile"
}, ks = /* @__PURE__ */ L({
  __name: "VJoyToggle",
  props: {
    modelValue: {
      type: Boolean,
      default: !1
    },
    value: {
      type: String,
      default: "on"
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    id: {
      type: String
    },
    invalid: {
      type: Boolean,
      default: !1
    },
    name: {
      type: String
    },
    required: {
      type: Boolean,
      default: !1
    },
    // ...CHECKBOX_BASED_PROPS,
    label: String,
    variant: {
      type: String,
      default: "default"
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const l = t;
    G();
    const o = C(!1), n = {
      onChange: (r) => {
        const a = r.target.checked;
        l("update:modelValue", a);
      },
      onFocus: () => {
        o.value = !0;
      },
      onBlur: () => {
        o.value = !1;
      }
    };
    return (r, a) => (c(), g("div", gs, [
      v("label", {
        class: I([
          "joy-toggle",
          "joy-toggle__" + e.variant,
          {
            "joy-toggle__checked": e.modelValue,
            "joy-toggle__disabled": e.disabled,
            "joy-toggle__focusing": o.value
          }
        ])
      }, [
        v("input", {
          ref: "input",
          "data-joy-form-field": "",
          type: "checkbox",
          class: "joy-toggle__input",
          role: "checkbox",
          name: e.name,
          disabled: e.disabled,
          checked: e.modelValue,
          required: e.required,
          "aria-checked": e.modelValue,
          value: e.value,
          onChange: a[0] || (a[0] = //@ts-ignore
          (...i) => n.onChange && n.onChange(...i)),
          onFocus: a[1] || (a[1] = //@ts-ignore
          (...i) => n.onFocus && n.onFocus(...i)),
          onBlur: a[2] || (a[2] = //@ts-ignore
          (...i) => n.onBlur && n.onBlur(...i))
        }, null, 40, bs),
        v("p", ws, [
          a[4] || (a[4] = v("span", { class: "joy-toggle__symbol" }, null, -1)),
          v("span", _s, [
            w(r.$slots, "default", {}, () => [
              D(J(e.label), 1)
            ], !0)
          ]),
          e.variant === "default" ? (c(), g("span", js, a[3] || (a[3] = [
            v("svg", {
              width: "18",
              height: "10",
              viewBox: "0 0 18 10",
              fill: "currentColor",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              v("path", {
                d: "M9.0237 9.14856C15.7144 9.14856 17.8736 2.22231 17.9649 1.91853L17.9345 1.94891C18.1778 1.15908 17.7216 0.308485 16.9309 0.0654591C16.1402 -0.177566 15.2886 0.278108 15.0453 1.06794C14.9845 1.25021 13.5551 6.11073 8.99328 6.11073C4.43147 6.11073 3.03249 1.43248 2.97167 1.21983C2.75878 0.399622 1.90724 -0.0560541 1.11652 0.156593C0.295397 0.369241 -0.160787 1.18945 0.0520982 2.00967C0.721165 4.4703 3.48869 9.14856 9.0237 9.14856Z",
                fill: "currentColor"
              })
            ], -1)
          ]))) : (c(), T(R, {
            key: 1,
            name: "eye",
            class: "joy-toggle__icon"
          }))
        ])
      ], 2)
    ]));
  }
}), qu = /* @__PURE__ */ A(ks, [["__scopeId", "data-v-df289167"]]), $s = ["aria-describedby"], Ss = ["id"], Cs = /* @__PURE__ */ L({
  __name: "VJoyTooltip",
  props: {
    /** If you are 100% sure the content you want to inject does not contain anything that could lead to any XSS, use this  */
    text: {
      type: String
    },
    /** It will automatically switch to another placement if there is not enough space. Please see https://floating-ui.com/docs/tutorial#placements for available values */
    placement: {
      type: String,
      default: "bottom"
    },
    /** Mouseenter (default) or click */
    event: {
      type: String,
      default: "mouseenter"
    },
    /** By default the tooltip is shown after a certain delay to make the experience smoother. You can change the value (in ms) */
    delay: {
      type: Number,
      default: 100
    },
    /** Mostly for visual testing purpose */
    show: {
      type: Boolean,
      default: !1
    },
    /** Maw-width for the generated tooltip. */
    tooltipWidth: {
      type: Number,
      default: 250
    },
    /**
     * @deprecated
     *
     * This property will be activated by default. Enable interacting with the content.
     *  */
    enableClickInContent: {
      type: Boolean,
      default: !0
    },
    id: {
      type: String
    }
  },
  setup(e, { expose: t }) {
    const l = G(), o = e, n = C(!1), r = C(null), a = C(null), i = C(null), s = C(), d = C(
      vo(r, i, {
        placement: o.placement,
        transform: !1,
        middleware: [
          oo(10),
          no({
            limiter: lo()
          }),
          to({
            fallbackPlacements: ["bottom", "top", "left", "right"]
          }),
          yo({ element: s, padding: 0 })
        ]
      })
    ), p = V(
      () => o.enableClickInContent ? {
        ignore: [a]
      } : {}
    ), u = V(() => l["tooltip-content"] || o.text);
    function f($) {
      $.preventDefault(), $.stopPropagation(), !n.value && o.event !== "click" && b();
    }
    function m() {
      o.event !== "click" && b(!1);
    }
    function y($) {
      !n.value && o.event === "click" && ($.preventDefault(), $.stopPropagation(), b());
    }
    function b($ = !0) {
      var j;
      (j = d.value) == null || j.update(), setTimeout(() => {
        n.value = $;
      }, o.delay);
    }
    const h = V(() => {
      const { middlewareData: $, placement: j } = d.value, x = $.arrow, E = {
        top: "bottom",
        right: "left",
        bottom: "top",
        left: "right"
      }[j.split("-")[0]];
      return {
        left: (x == null ? void 0 : x.x) && `${x == null ? void 0 : x.x}px`,
        top: (x == null ? void 0 : x.y) && `${x == null ? void 0 : x.y}px`,
        right: "",
        bottom: "",
        [E]: "-4px"
      };
    });
    return te(() => {
      o.show && b();
    }), Je(() => {
      n.value = !1;
    }), t({
      tooltipVisible: n,
      tooltip: i
    }), ($, j) => (c(), T(q(mt), {
      ref: "tooltipClickOutside",
      class: "joy-tooltip__click-outside",
      options: p.value,
      onTrigger: j[1] || (j[1] = (x) => b(!1))
    }, {
      default: z(() => {
        var x;
        return [
          v("div", {
            ref_key: "tooltipWrapper",
            ref: r,
            class: "joy-tooltip__wrapper",
            "aria-describedby": e.id,
            onClick: y,
            onMouseenter: f,
            onMouseleave: m,
            onKeydown: j[0] || (j[0] = Oe((E) => b(!1), ["tab"]))
          }, [
            w($.$slots, "default", {}, void 0, !0),
            (c(), T(ze, { to: "body" }, [
              n.value && u.value ? (c(), g("div", {
                key: 0,
                id: e.id,
                ref_key: "tooltip",
                ref: i,
                role: "tooltip",
                class: I([
                  "joy-tooltip__content",
                  {
                    "joy-tooltip__content--hiding": !n.value
                  }
                ]),
                style: ee({ ...(x = d.value) == null ? void 0 : x.floatingStyles, maxWidth: `${e.tooltipWidth}px` })
              }, [
                v("div", {
                  ref_key: "tooltipArrow",
                  ref: s,
                  class: "joy-tooltip__arrow",
                  style: ee(h.value)
                }, null, 4),
                v("div", {
                  ref_key: "tooltipContent",
                  ref: a,
                  class: "joy-tooltip__content__inner"
                }, [
                  w($.$slots, "tooltip-content", {}, () => [
                    D(J(e.text), 1)
                  ], !0)
                ], 512)
              ], 14, Ss)) : _("", !0)
            ]))
          ], 40, $s)
        ];
      }),
      _: 3
    }, 8, ["options"]));
  }
}), Hu = /* @__PURE__ */ A(Cs, [["__scopeId", "data-v-4e623435"]]), Vs = { class: "joy-user-card__picture" }, Ts = { class: "joy-user-card__informations" }, xs = { class: "joy-user-card__title" }, Is = { class: "joy-user-card__subtitle" }, Ls = /* @__PURE__ */ L({
  __name: "VJoyUserCard",
  props: {
    /**
     * Giving a link will make the whole component wrapped by an hyperlink
     */
    link: {
      type: String
    },
    /**
     * Use this prop if you don't want to use the user-card-avatar slot.
     */
    photoUrl: {
      type: String
    },
    fullName: {
      type: String
    },
    subTitle: {
      type: String
    },
    /** Introduce a VJoyRatingStars component with given rating */
    ratingValue: {
      type: Number
    }
  },
  setup(e) {
    return (t, l) => (c(), T(Z(e.link ? "a" : "div"), H({
      class: "joy-user-card",
      href: e.link,
      title: e.fullName
    }, t.$attrs), {
      default: z(() => [
        v("div", Vs, [
          w(t.$slots, "user-card-avatar", {}, () => [
            O(an, {
              "photo-url": e.photoUrl,
              "full-name": e.fullName
            }, null, 8, ["photo-url", "full-name"])
          ], !0)
        ]),
        v("div", Ts, [
          v("p", xs, [
            w(t.$slots, "user-card-title", {}, () => [
              D(J(e.fullName), 1)
            ], !0)
          ]),
          v("p", Is, [
            w(t.$slots, "user-card-subtitle", {}, () => [
              D(J(e.subTitle), 1)
            ], !0)
          ]),
          w(t.$slots, "user-card-rating-stars", {}, () => [
            e.ratingValue ? (c(), T(mi, {
              key: 0,
              "rating-value": e.ratingValue
            }, null, 8, ["rating-value"])) : _("", !0)
          ], !0),
          v("div", null, [
            w(t.$slots, "default", {}, void 0, !0)
          ])
        ])
      ]),
      _: 3
    }, 16, ["href", "title"]));
  }
}), Wu = /* @__PURE__ */ A(Ls, [["__scopeId", "data-v-86acec3a"]]), Bs = { class: "joy-walkthrough-trigger__content" }, As = {
  key: 0,
  class: "joy-pr-3"
}, Es = {
  key: 1,
  class: "joy-pl-3"
}, zs = /* @__PURE__ */ L({
  __name: "VJoyWalkthroughTrigger",
  props: {
    icon: {},
    title: {},
    subtitle: {},
    open: { type: Boolean }
  },
  setup(e) {
    const l = C(e.open);
    return (o, n) => {
      const r = ct("joy-ripple");
      return Ke((c(), g("button", H(o.$attrs, {
        type: "button",
        class: "joy-walkthrough-trigger joy-bgcolor-neutral-60 joy-core-radius-5",
        onClick: n[0] || (n[0] = (a) => l.value = !l.value)
      }), [
        o.icon ? (c(), T(R, {
          key: 0,
          color: "white",
          class: "joy-walkthrough-trigger__icon joy-mr-3",
          name: o.icon
        }, null, 8, ["name"])) : _("", !0),
        v("div", Bs, [
          o.title ? (c(), g("span", As, J(o.title), 1)) : _("", !0),
          o.subtitle ? (c(), g("span", Es, J(o.subtitle), 1)) : _("", !0)
        ]),
        O(R, {
          class: "joy-ml-3",
          color: "white",
          name: l.value ? "chevron-down" : "chevron-up"
        }, null, 8, ["name"])
      ], 16)), [
        [r]
      ]);
    };
  }
}), Js = /* @__PURE__ */ A(zs, [["__scopeId", "data-v-56824d11"]]), Ms = { class: "joy-walkthrough-modal__illustration" }, Ps = { class: "joy-walkthrough-modal__content___titles" }, Fs = { class: "joy-walkthrough-modal__content___title" }, Os = { class: "joy-walkthrough-modal__content___subtitle" }, Ds = {
  key: 0,
  class: "joy-mt-4"
}, Rs = {
  key: 1,
  class: "joy-mt-4 joy-walkthrough-modal__content-inner"
}, Ns = {
  type: "button",
  class: "joy-walkthrough-modal__footer-button joy-color-secondary-50 joy-font-primary-300"
}, qs = /* @__PURE__ */ L({
  __name: "VJoyWalkthrough",
  props: {
    open: { type: Boolean, default: !1 },
    triggerTitle: {},
    triggerSubtitle: {},
    triggerIcon: {},
    footer: {},
    triggerAttrs: {},
    disableTeleport: { type: Boolean }
  },
  emits: ["hide", "hide:header", "hide:footer"],
  setup(e, { expose: t, emit: l }) {
    const o = e, n = l;
    let r = null;
    const a = C(o.open), i = C(!1);
    function s() {
      a.value ? u() : a.value = !0;
    }
    function d() {
      u(), n("hide"), n("hide:header");
    }
    function p() {
      u(), n("hide"), n("hide:footer");
    }
    function u() {
      r && clearTimeout(r), i.value = !0, r = setTimeout(() => {
        a.value = !1, i.value = !1;
      }, 200);
    }
    return K(
      () => o.open,
      (f) => {
        a.value = f;
      }
    ), t({
      isOpen: a
    }), (f, m) => (c(), T(ze, {
      to: "body",
      disabled: f.disableTeleport
    }, [
      v("div", {
        class: I(["joy-walkthrough joy-core-radius-4", { "joy-walkthrough--collapsed": !a.value }])
      }, [
        a.value ? (c(), g("div", H({ key: 0 }, f.$attrs, {
          class: ["joy-walkthrough-modal joy-core-elevation-4", { "joy-walkthrough-modal--hiding": i.value }]
        }), [
          O(re, {
            "no-margin": "",
            role: "button",
            class: "joy-walkthrough-modal__header joy-pt-5 joy-pl-6 joy-pb-5 joy-pr-6 joy-bgcolor-neutral-60",
            onClick: d
          }, {
            default: z(() => [
              f.triggerIcon ? (c(), T(R, {
                key: 0,
                color: "white",
                name: f.triggerIcon
              }, null, 8, ["name"])) : _("", !0),
              O(re, {
                justify: "space-between",
                class: "joy-walkthrough-modal__title",
                "no-margin": ""
              }, {
                default: z(() => [
                  D(J(f.triggerTitle) + " ", 1),
                  O(R, {
                    color: "white",
                    name: a.value ? "chevron-down" : "chevron-up"
                  }, null, 8, ["name"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          v("div", {
            class: I(["joy-walkthrough-modal__content joy-p-6", { "joy-walkthrough-modal__content--with-footer": f.footer }])
          }, [
            O(re, {
              "no-margin": "",
              wrap: "nowrap"
            }, {
              default: z(() => [
                v("div", Ms, [
                  w(f.$slots, "walkthrough-illustration", {}, void 0, !0)
                ]),
                v("div", Ps, [
                  v("div", Fs, [
                    w(f.$slots, "walkthrough-title", {}, void 0, !0)
                  ]),
                  v("div", Os, [
                    w(f.$slots, "walkthrough-subtitle", {}, void 0, !0)
                  ])
                ])
              ]),
              _: 3
            }),
            f.$slots["walkthrough-progress"] ? (c(), g("div", Ds, [
              w(f.$slots, "walkthrough-progress", {}, void 0, !0)
            ])) : _("", !0),
            f.$slots["walkthrough-content"] ? (c(), g("div", Rs, [
              w(f.$slots, "walkthrough-content", {}, void 0, !0)
            ])) : _("", !0)
          ], 2),
          f.footer ? (c(), g("div", {
            key: 0,
            class: "joy-walkthrough-modal__footer joy-p-6",
            onClick: p
          }, [
            v("button", Ns, J(f.footer), 1)
          ])) : _("", !0)
        ], 16)) : _("", !0),
        a.value ? _("", !0) : (c(), T(Js, H({ key: 1 }, f.triggerAttrs, {
          title: f.triggerTitle,
          subtitle: f.triggerSubtitle,
          icon: f.triggerIcon,
          class: "joy-walkthrough-trigger",
          onClick: s
        }), null, 16, ["title", "subtitle", "icon"]))
      ], 2)
    ], 8, ["disabled"]));
  }
}), Uu = /* @__PURE__ */ A(qs, [["__scopeId", "data-v-c1a50091"]]), Gu = {
  install: (e) => {
    typeof window < "u" && Wt(), e.directive("joy-ripple", Rt), e.directive("bind-once", Mo);
  }
};
export {
  Gu as JoyVueLightPlugin,
  Gs as VJoyAdminBanner,
  Ys as VJoyAvailability,
  an as VJoyAvatar,
  Ks as VJoyAvatarsList,
  cn as VJoyBadge,
  Zs as VJoyBadgeLevel,
  Xs as VJoyBlockSkeleton,
  Qs as VJoyBottomSheet,
  eu as VJoyBottomSheetTrigger,
  ne as VJoyButton,
  Kt as VJoyCheckbox,
  tu as VJoyCollapse,
  Xn as VJoyCollapseItem,
  ou as VJoyCompanyAvatar,
  nu as VJoyCounter,
  lu as VJoyDialog,
  au as VJoyDialogTrigger,
  Ct as VJoyDot,
  ru as VJoyDrawer,
  iu as VJoyDrawerTrigger,
  su as VJoyDropdown,
  Pl as VJoyDropdownList,
  uu as VJoyDropzone,
  du as VJoyFilterBar,
  cu as VJoyFilterBarButton,
  tt as VJoyFormError,
  fu as VJoyFormFieldSkeleton,
  pu as VJoyFunnel,
  yu as VJoyFunnelFooter,
  mu as VJoyFunnelHeader,
  vu as VJoyHighlight,
  R as VJoyIcon,
  ja as VJoyIndicator,
  hu as VJoyIndicators,
  gu as VJoyInput,
  Ve as VJoyLabel,
  bu as VJoyLink,
  wu as VJoyListItem,
  _u as VJoyMenu,
  ju as VJoyMenuItem,
  ku as VJoyMultiCheckbox,
  $u as VJoyPagination,
  Su as VJoyPanel,
  Cu as VJoyPanelSection,
  Vu as VJoyProductTour,
  Tu as VJoyProductTourTrigger,
  xu as VJoyProgressBar,
  Iu as VJoyRadio,
  Lu as VJoyRadioGroup,
  mi as VJoyRatingStars,
  Xt as VJoyScreenLoader,
  Bu as VJoySelect,
  ki as VJoySelectableItem,
  Au as VJoySelectableItemGroup,
  Eu as VJoySeparator,
  Ho as VJoySnackbar,
  Ut as VJoySpinner,
  Li as VJoyStep,
  zu as VJoyStepper,
  Ju as VJoyTab,
  Mu as VJoyTabs,
  go as VJoyTag,
  Pu as VJoyTagsInput,
  Fu as VJoyTagsList,
  Ou as VJoyTemplate,
  Qi as VJoyTemplateShape,
  Du as VJoyText,
  Ru as VJoyTextarea,
  Nu as VJoyTitleBrand,
  qu as VJoyToggle,
  Hu as VJoyTooltip,
  Wu as VJoyUserCard,
  Uu as VJoyWalkthrough,
  Js as VJoyWalkthroughTrigger,
  re as VJoyWrapper,
  Wt as createAllSnackbarsContainer,
  Us as pushVJoySnackbar,
  Ws as resetCount,
  Rt as vJoyRipple
};
